import { PublishDialogComponent } from "./../publish-dialog/publish-dialog.component";
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  TemplateRef,
  ViewChild,
  HostListener,
} from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";
import { UserserviceService } from "src/app/Services/userservice.service";
import { DataService } from "src/app/Services/dataservice.service";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { CancalFlowDialogComponent } from "../cancal-flow-dialog/cancal-flow-dialog.component";
import { ToastrService } from "ngx-toastr";
import { ShowFlowImageDialogComponent } from "../show-flow-image-dialog/show-flow-image-dialog.component";
import { Location } from "@angular/common";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { Console } from "console";
import { EnhancedRestrictedAccessComponent } from "../enhanced-restricted-access/enhanced-restricted-access.component";
import { elements } from "chart.js";
import { HttpEvent, HttpEventType, HttpClient } from "@angular/common/http";
import { TransferOwnershipComponent } from "../transfer-ownership/transfer-ownership.component";
import { promise } from "protractor";
import { EditItemComponent } from "../edit-item/edit-item.component";
import { ItemDetailsDialogComponent } from "../item-details-dialog/item-details-dialog.component";
import { AddNewItemDialogComponent } from "../add-new-item-dialog/add-new-item-dialog.component";
import { environment } from "src/environments/environment";
import {
  handleMaxPublishedFlowsError,
  isMaxPublishedFlowsError,
  handleFlowBundlePermissionError,
  isFlowBundlePermissionError,
  handleCreatorPublicOnlyError,
  isCreatorPublicOnlyError,
} from "src/app/shared/utils/guide-limit-error.util";
import { MediaUploadService } from "src/app/Services/media-upload.service";
import { SelectionRephraseAIComponent } from "../selection-rephraseAi-dialog/selection-rephraseAi-dialog.component";
import { ThumbnailSelectionDialogComponent } from "../thumbnail-selection-dialog/thumbnail-selection-dialog.component";
import {
  LoadingModalComponent,
  LoadingModalData,
} from "../loading-modal/loading-modal.component";
import { VersionHistoryPanelComponent } from "../version-history-panel/version-history-panel.component";
import { ContentActivityPanelComponent } from "../content-activity-panel/content-activity-panel.component";
import { ItemLibraryService, ItemLibraryModel } from "src/app/Services/item-library.service";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { debounceTime, distinctUntilChanged, switchMap, catchError } from "rxjs/operators";
import { of, Subject } from "rxjs";
import { FlowNavigationService } from "src/app/Services/flow-navigation.service";
import {
  isCreatorPlanUser,
  isOrganizationAccountMode,
  showSmartCreatePaidBadge,
  hasAiCreationAccess,
  hasContentCreationPlanAccess,
} from "src/app/shared/utils/plan.util";
import {
  handleTrialLimitError,
  isTrialLimitError,
} from "src/app/shared/utils/trial-gate.util";
import { FrontlineFeatureFlags } from "src/app/shared/constants/frontline-glossary";
import { FrontlineOpsService } from "src/app/Services/frontline-ops.service";
import { OrgContextService } from "src/app/Services/org-context.service";
import {
  ContentActivityService,
  ContentApprovalStatus,
} from "src/app/Services/content-activity.service";
import { KeepLiveChoiceDialogComponent } from "../keep-live-choice-dialog/keep-live-choice-dialog.component";
import { writeGuideEditStorage } from "src/app/shared/utils/guide-edit-storage.util";
import {
  PromoteStatus,
  promoteStatusFromAudit,
  takeToPublicSteps,
} from "src/app/shared/utils/take-to-public.util";
import {
  cleanGuideQuestionForm,
  GuideQuestionForm,
  guideQuestionCount,
  guideQuestionFormErrors,
  parseGuideQuestionForm,
} from "src/app/models/guide-question-form.model";
import {
  openCreatorPlanUpgradeDialog,
} from "src/app/shared/utils/creator-plan-restrictions.util";
import {
  RestrictedAccessDraft,
  InitialAccessSnapshot,
  buildDraftFromParentState,
  cloneRestrictedAccessDraft,
  hasRestrictedDraftContent,
  buildInitialAccessSnapshot,
  shouldEnrichInitialAccessSnapshot,
} from "src/app/shared/models/restricted-access-draft.model";

type JourneyTabId = "cover" | "items" | "steps" | "faqs" | "access" | "summary";
type JourneyAccessChoice =
  | "Public"
  | "PrivateToMe"
  | "LinkAccess"
  | "Restricted";

interface JourneyTabConfig {
  id: JourneyTabId;
  label: string;
}

@Component({
  selector: "app-create-flow",
  templateUrl: "./create-flow.component.html",
  styleUrls: ["./create-flow.component.scss"],
})
export class CreateFlowComponent implements OnInit, OnDestroy {
  /** Soft-gate paid content sale UI for frontline Keep delivery. */
  readonly showContentPurchase = FrontlineFeatureFlags.showContentPurchase;
  approvalBusy = false;
  approvalComment = "";
  /** Draft | InReview | Approved | Published | Rejected */
  contentApprovalState = "Draft";
  flowOrganizationId: string | null = null;
  flowApplicationId: string | null = null;
  flowTeamId: string | null = null;

  returnUrl: string | null = null;
  profilePicture: string;
  userDisplayName: any;
  userData: any;
  showDefaultImage: boolean;
  email: any;
  phone: any;
  info: any;
  website: any;
  uname: any;
  name: any;
  flows: any;
  showNotificationCount: boolean;
  notificationCount: number;
  CategoryName: string;
  /** Matches API Constants.Categories — optional flow subject category. */
  flowCategories: string[] = [
    "Adventures",
    "Art & Craft",
    "Automobiles",
    "Beauty",
    "Fashion",
    "Fitness",
    "Home & Garden",
    "Metalworks",
    "Photography",
    "Media Production",
    "Recipe",
    "Technology",
    "Woodworks",
  ];
  inames: any[];
  _steps: any[];
  supportingDocumentDocuments: any[];
  supportingDocumentHyperLinks: any[];
  allSteps: any[] = [];
  selectedSummaryStepIndex: number = -2; // -2 = Cover, -1 = Items, >= 0 = Steps
  selectedStepSummaryIndex: number = 0; // Selected step index in the steps summary sidebar
  originalCoverDescription: string = ""; // Store original cover description
  showDescriptionExpanded: boolean = false; // Control description expand/collapse
  coverImageUri: string;
  coverPosterPageURI: string = "";
  stepsImageUri: string;
  stepDescription: string;
  title: string;
  duration: number;
  durationUnit: string = 'Mins';
  description: string;
  quantity: string;
  coverPage: string;
  isSCenabled: any;
  stepsButton: any;
  flowData: any;
  accessType: string;
  restrictedAccessType: string = "";
  isSearchHidden: boolean = false;
  savedAccessFlows: any[] = [];
  savedAccessAdvanced: any = {};
  /** Session draft for Restricted access (preserved when switching access types). */
  restrictedAccessDraft: RestrictedAccessDraft | null = null;
  /** Frozen access loaded when opening edit, used as a reference in Access summary. */
  initialAccessSnapshot: InitialAccessSnapshot | null = null;
  private initialAccessSnapshotLocked = false;
  /** Access tab selection (before Summary). Default Public. */
  journeyAccessChoice: JourneyAccessChoice = "Public";
  @ViewChild(EnhancedRestrictedAccessComponent)
  restrictedAccessPanel?: EnhancedRestrictedAccessComponent;
  reSelectedCategory: string;
  categoryPageNavigatedFrom: any;
  //flowId: any;
  flowNavigateTo: any;
  showItemsOrStepsButton: boolean;
  disablePublishButton: boolean;
  hasUnsavedChanges: boolean = false;
  private _initialFlowState: string | null = null;
  private _editChangeDetectionReady: boolean = false;
  selectedCategoryName: any;
  showDeleteContentMenu: boolean;
  uniqueId: any;
  draft: string;
  edit: string;
  fileName: any;
  stepNumber = 1;
  noResultReturned: boolean;
  isPaid: boolean;
  creatorRequiresPaidCreation = false;
  showSmartCreatePaidBadge = false;
  /** False during the Starter free trial: "Rephrase with AI" is hidden. */
  aiCreationAllowed = true;
  price: any;
  showMessage: boolean;
  rowKey: any;
  partitionKey: any;
  faqs: any;
  _allFaqs: any[] = [];
  isFaqChecked: boolean = false;
  groupName: any;
  question: any;
  answer: any;
  progress: number = 0;
  isUploading: boolean;
  searchKeyWords: string;
  groupedData: Record<string, any[]> = {};
  groupedFaqData: Record<string, any[]> = {};
  enableTransferAfterPublish: boolean = false;
  selectedTransferUser: any = null; // Store selected user for transfer
  selectedTransferUserComment: any;
  disableTransferUserPublishButton: boolean = true;
  selectedUsers: any[] = [];
  hasActiveTransferRequest: boolean = false; // Track if there are active transfer requests
  journeyTabs: JourneyTabConfig[] = [
    { id: "cover", label: "Cover Details" },
    { id: "items", label: "Items" },
    { id: "steps", label: "Steps" },
    { id: "faqs", label: "Support FAQs" },
    { id: "access", label: "Access" },
    { id: "summary", label: "Summary" },
  ];
  activeJourneyTab: JourneyTabId = "cover";
  private journeyTabManuallySelected = false;
  private visitedTabs: Set<JourneyTabId> = new Set<JourneyTabId>();
  isMobileView: boolean = false;
  expandedMobilePanel: string | null = null; // Track which expansion panel is open in full-screen

  // Cover page form properties
  fileData: File = null;
  showCoverImage: boolean = false;
  showCoverVideo: boolean = false;
  isLoading: boolean = false;
  maxtitlelenght = 80;
  maxdesclenght = 500;
  currenttitlelenght = 0;
  currentdesclenght = 0;
  documentName: string = "";
  linkName: string = "";
  hyperLink: string = "";
  sffilename: string = "";
  sffilelink: string = "";
  tabIndex: number = 0;
  originalContentTitleText: string;
  isRephrased: boolean = false;
  isRephraseInProgress: boolean = false;
  originalTitleText: string;
  isTitleRephrased: boolean = false;
  isTitleRephraseInProgress: boolean = false;
  flowId: any;
  type: any;
  showCreateTypeSelection: boolean = false; // Show selection menu for new flows

  // Items form properties
  itemGroupName: string = "";
  itemName: string = "";
  itemQuantity: string = "";
  itemImageUrl: string = "";
  itemWhereToFindIt: string = "";
  itemGroupList: string[] = [];
  showItemImage: boolean = false;
  showItemVideo: boolean = false;
  itemUploadProgress: number = 0;
  isItemsRequired: boolean = false; // Toggle to indicate if items are mandatory
  
  // Library integration
  libraryGroupSuggestions: ItemLibraryModel[] = [];
  libraryItemSuggestions: ItemLibraryModel[] = [];
  allLibraryItems: ItemLibraryModel[] = []; // Store all library items
  filteredLibraryItems: ItemLibraryModel[] = []; // Filtered items for display
  groupNameInput$ = new Subject<string>();
  itemNameInput$ = new Subject<string>();
  selectedLibraryItem: ItemLibraryModel = null;

  // Steps form properties
  stepTitle: string = "";
  stepImageUrl: string = "";
  stepPosterUrl: string = "";
  stepFileName: string = "";
  showStepImage: boolean = false;
  showStepVideo: boolean = false;
  stepNoResultReturned: boolean = false;
  stepIsLoading: boolean = false;
  stepProgress: number = 0;
  originalStepDescriptionText: string;
  isStepRephrased: boolean = false;
  isStepRephraseInProgress: boolean = false;
  isSafetyCritical: boolean = false; // Step safety critical checkbox
  safetyInstructionsTitle: string = ""; // Step safety instructions title
  safetyInstructionsDescription: string = ""; // Step safety instructions description
  
  // Cover safety properties
  coverIsSafetyCritical: boolean = false; // Cover safety critical checkbox
  coverSafetyInstructionsTitle: string = ""; // Cover safety instructions title
  coverSafetyInstructionsDescription: string = ""; // Cover safety instructions description
  
  // Question forms: per step (edited with the step form) and at the end of the guide
  stepQuestionForm: GuideQuestionForm | null = null;
  endQuestionForm: GuideQuestionForm | null = null;
  private endQuestionFormLoaded = false;

  // Step item tagging properties
  stepTaggedItems: any[] = [];
  stepItemSearch: string = "";
  stepItemSuggestions: any[] = [];
  stepItemInput$ = new Subject<string>();

  // FAQs form properties
  faqGroupName: string = "";
  faqQuestion: string = "";
  faqAnswer: string = "";
  faqGroupList: string[] = [];

  // Thumbnail selection state
  coverThumbnails: string[] = [];
  stepThumbnails: string[] = [];
  isCoverThumbnailLoading: boolean = false;
  isStepThumbnailLoading: boolean = false;
  coverThumbnailError: string = "";
  stepThumbnailError: string = "";
  customCoverThumbnailUploading: boolean = false;
  customStepThumbnailUploading: boolean = false;
  coverThumbnailUploadProgress: number = 0;
  stepThumbnailUploadProgress: number = 0;
  generatedCoverThumbnailUrl: string = "";
  customCoverThumbnailUrl: string = "";
  customCoverThumbnailFile: File = null;
  thumbnailSelectionMode: "auto" | "upload" | "compare" = "auto";
  isThumbnailDialogOpen = false;
  thumbnailDialogMode: "auto" | "upload" | "compare" = "auto";
  selectedAutoThumbnailUrl: string = "";
  selectedAutoThumbnailFile: File = null;
  selectedUploadFrameIndex: number = -1; // Track selected frame index in upload mode (-1 = none selected)

  // FAQ Modal state
  isFaqModalOpen = false;
  selectedFaq: any = null;
  selectedFaqGroup: string = "";

  // Video player state for thumbnail selection
  videoDuration: number = 0;
  currentVideoTime: number = 0;
  @ViewChild("coverVideoPlayer") coverVideoPlayer: ElementRef<HTMLVideoElement>;

  // Step thumbnail selection state
  customStepThumbnailUrl: string = "";
  customStepThumbnailFile: File = null;
  stepThumbnailSelectionMode: "auto" | "upload" | "compare" = "auto";
  isStepThumbnailDialogOpen = false;
  stepThumbnailDialogMode: "auto" | "upload" | "compare" = "auto";
  selectedStepAutoThumbnailUrl: string = "";
  selectedStepAutoThumbnailFile: File = null;
  stepVideoDuration: number = 0;
  currentStepVideoTime: number = 0;
  @ViewChild("stepVideoPlayer") stepVideoPlayer: ElementRef<HTMLVideoElement>;

  @ViewChild("thumbnailUploadInput")
  thumbnailUploadInput: ElementRef<HTMLInputElement>;
  @ViewChild("stepThumbnailUploadInput")
  stepThumbnailUploadInput: ElementRef<HTMLInputElement>;
  @ViewChild("urlPreviewDialog") urlPreviewDialog: TemplateRef<any>;
  @ViewChild("journeyScrollContainer")
  journeyScrollContainer: ElementRef<HTMLDivElement>;
  @ViewChild("coverTitleSection") coverTitleSection: ElementRef<HTMLElement>;
  @ViewChild("coverMediaSection") coverMediaSection: ElementRef<HTMLElement>;
  @ViewChild("coverDescriptionSection")
  coverDescriptionSection: ElementRef<HTMLElement>;
  @ViewChild("itemsSection") itemsSection: ElementRef<HTMLElement>;
  @ViewChild("stepsSection") stepsSection: ElementRef<HTMLElement>;
  @ViewChild("faqsSection") faqsSection: ElementRef<HTMLElement>;

  // Loading modal reference
  loadingModalRef: MatDialogRef<LoadingModalComponent> = null;

  // ─── Collaboration ───────────────────────────────────────────────────────
  isCollaboration: boolean = false;
  /** All collaborators added to this flow */
  collabInvitees: { email: string; userName: string; profilePicUrl?: string; status: string }[] = [];
  collabInviteMessage: string = "";
  collabValue: number = null;

  // Collab user search / picker
  collabUserSearchInput$ = new Subject<string>();
  collabUserSuggestions: any[] = [];
  collabUserSearchLoading: boolean = false;
  /** The user currently selected in the search dropdown, not yet added to the list */
  pendingCollabUser: any = null;

  // ─── Sponsored Content ───────────────────────────────────────────────────
  isSponsored: boolean = false;

  // ─── Viewer interaction toggles (View Flow extras) ───────────────────────
  viewerFeatures = {
    showShare: true,
    showComments: true,
    showLike: true,
    showReview: true,
    showSave: true,
    showQr: true,
    showReport: true,
    showFollow: true,
    showSchedule: true,
    showConsult: false,
    showChatbot: true,
    showCopyLinks: true,
    showTransfer: true,
    showQuestions: true,
    showImprovementFeedback: true,
    allowDownload: false,
    allowPrint: false,
    allowEmbed: false,
  };

  feedbackWindowStart: string = '';
  feedbackWindowEnd: string = '';

  /** Server-side approval / publishing state of the guide being edited. */
  approvalInfo: ContentApprovalStatus | null = null;
  keepLiveBusy = false;
  private linkHydrationAttempted = false;

  readonly viewerFeatureToggleDefs: Array<{ key: keyof CreateFlowComponent['viewerFeatures']; label: string }> = [
    { key: 'showShare', label: 'Share link' },
    { key: 'showComments', label: 'Comments' },
    { key: 'showQuestions', label: 'Questions' },
    { key: 'showImprovementFeedback', label: 'Improvement feedback' },
    { key: 'showLike', label: 'Like' },
    { key: 'showReview', label: 'Review / Feedback' },
    { key: 'showSave', label: 'Save / Bookmark' },
    { key: 'showQr', label: 'QR code' },
    { key: 'showReport', label: 'Report' },
    { key: 'showFollow', label: 'Follow creator' },
    { key: 'showSchedule', label: 'Schedule reminder' },
    { key: 'showConsult', label: 'Consult' },
    { key: 'showChatbot', label: 'Guide Assist' },
    { key: 'showCopyLinks', label: 'Copy Cover / Step / Items links' },
    { key: 'showTransfer', label: 'Transfer ownership' },
    { key: 'allowDownload', label: 'Allow download' },
    { key: 'allowPrint', label: 'Allow print' },
    { key: 'allowEmbed', label: 'Allow embed' },
  ];

  constructor(
    private dataService: DataService,
    private flowServiceService: FlowServiceService,
    public dialog: MatDialog,
    private userserviceService: UserserviceService,
    private router: Router,
    private toastr: ToastrService,
    private location: Location,
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
    private itemLibraryService: ItemLibraryService,
    private mediaUploadService: MediaUploadService,
    private actvatedroute: ActivatedRoute,
    private flowNavigationService: FlowNavigationService,
    private frontlineOps: FrontlineOpsService,
    private orgContext: OrgContextService,
    private contentActivity: ContentActivityService,
  ) {
    // Wire collab user search — debounce 350 ms
    this.collabUserSearchInput$
      .pipe(
        debounceTime(350),
        distinctUntilChanged(),
        switchMap((term: string) => {
          if (!term || term.length < 2) {
            this.collabUserSuggestions = [];
            return of([]);
          }
          this.collabUserSearchLoading = true;
          return this.userserviceService.searchCollabUsers(term, 10).pipe(
            catchError(() => of([]))
          );
        })
      )
      .subscribe((users: any[]) => {
        this.collabUserSuggestions = users || [];
        this.collabUserSearchLoading = false;
        this.cdr.detectChanges();
      });
    this.flows = JSON.parse(localStorage.getItem("flow"));
    this.rowKey = JSON.parse(localStorage.getItem("notificationflowId"));
    // this.flowNavigateTo = JSON.parse(localStorage.getItem("navigateTo"));

    this.returnUrl =
    this.actvatedroute.snapshot.queryParams['returnUrl'] || null;
  }

  openVersionHistoryDialog(): void {
    const logicalId = this.rowKey || this.flowId;
    if (!logicalId) {
      this.toastr.error("Save the flow before viewing version history.");
      return;
    }

    this.dialog.open(VersionHistoryPanelComponent, {
      width: "640px",
      data: {
        entityType: "flow",
        logicalId,
      },
    });
  }

  openActivityDialog(): void {
    const contentId = this.currentFlowKey();
    if (!contentId) {
      this.toastr.info("Save the guide to start tracking its activity.");
      return;
    }
    ContentActivityPanelComponent.open(this.dialog, {
      contentType: "guide",
      contentId,
      title: this.title,
    });
  }

  private currentFlowKey(): string {
    return this.rowKey || this.flowId || "";
  }

  get requiresOrgApproval(): boolean {
    if (this.flowOrganizationId) return true;
    // New drafts in an active org get org scope stamped on save
    return !!this.orgContext.contentScope().organizationId;
  }

  get canApproveThisContent(): boolean {
    return this.orgContext.canApproveContent(
      this.flowOrganizationId,
      this.flowApplicationId,
      this.flowTeamId
    );
  }

  get approvalStatusLabel(): string {
    switch (this.contentApprovalState) {
      case "InReview":
        return "In review";
      case "Approved":
        return this.approvedContentEdited
          ? "Approved — your changes need approval again"
          : "Approved — ready to publish";
      case "Published":
        return "Published";
      case "Rejected":
        return "Rejected — revise and resubmit";
      default:
        return "Draft";
    }
  }

  /** Approval covers the reviewed content only; edits after approval must be submitted again. */
  /** Taking content public is an organization feature; hidden in Public account mode. */
  get showTakeToPublic(): boolean {
    return this.requiresOrgApproval && this.orgContext.isOrganizationMode();
  }

  get approvedContentEdited(): boolean {
    return (
      this.requiresOrgApproval &&
      this.contentApprovalState === "Approved" &&
      !!this.hasUnsavedChanges
    );
  }

  private approvalRequiredError(err: any): string | null {
    const message = err?.error?.message || err?.error?.error;
    return err?.status === 400 && typeof message === "string" && message.trim()
      ? message
      : null;
  }

  private applyApprovalMetaFromFlow(source: any): void {
    if (!source) return;
    const status = source.flowStatus || source.FlowStatus;
    this.contentApprovalState =
      source.approvalState ||
      source.ApprovalState ||
      (status === "InReview"
        ? "InReview"
        : status === "ContentApproved"
        ? "Approved"
        : status === "Approved"
        ? "Published"
        : "Draft");
    this.flowOrganizationId =
      source.organizationId || source.OrganizationId || this.flowOrganizationId;
    this.flowApplicationId =
      source.applicationId || source.ApplicationId || this.flowApplicationId;
    this.flowTeamId = source.teamId || source.TeamId || this.flowTeamId;
  }

  loadApprovalInfo(): void {
    const key = this.currentFlowKey();
    if (!key || !this.userData) {
      this.approvalInfo = null;
      return;
    }
    this.contentActivity.approvalStatus("guide", String(key)).subscribe({
      next: (status) => {
        this.approvalInfo = status || null;
        if (status?.approvalState && this.requiresOrgApproval) {
          this.contentApprovalState = status.approvalState;
        }
        this.cdr.detectChanges();
      },
      error: () => {
        this.approvalInfo = null;
      },
    });
  }

  /** e.g. "Live: v3 · Editing: v4 (In review)". */
  get publishingStatusLine(): string | null {
    const s = this.approvalInfo;
    if (!s) return null;
    const version = s.version || 0;
    const published = s.publishedVersion || (s.isLive ? version : 0);
    if (s.hasPendingDraft) {
      return `Live: v${published} · Editing: v${version + 1} (${this.approvalStatusLabel})`;
    }
    if (s.isLive) {
      return `Live: v${version}`;
    }
    if (published > 0 && published < version) {
      return `Published v${published} is hidden · Editing: v${version} (${this.approvalStatusLabel})`;
    }
    return null;
  }

  get rejectionNotice(): { reason: string; by?: string; atUtc?: string } | null {
    const r = this.approvalInfo?.latestRejection;
    if (!r || this.contentApprovalState !== "Rejected") return null;
    return {
      reason: (r.comment || "").trim() || "No reason was given.",
      by: r.actorEmail,
      atUtc: r.atUtc,
    };
  }

  /** True while the published version stays visible to the organization during edits. */
  get keepsPublishedLive(): boolean {
    const s = this.approvalInfo;
    return !!s && (!!s.hasPendingDraft || (!!s.isLive && s.keepPublishedLive === true));
  }

  get canChangeKeepLive(): boolean {
    const s = this.approvalInfo;
    if (!s || !this.hasFlowRowKey()) return false;
    return !!s.isLive || !!s.hasPendingDraft || !!s.canRestorePublished;
  }

  get keepLiveChoiceLabel(): string {
    const s = this.approvalInfo;
    if (s?.isLive && !s.hasPendingDraft && s.keepPublishedLive == null) {
      return "Choose what people see while you edit";
    }
    return `${this.keepsPublishedLive ? "Visible while editing" : "Hidden while editing"} · Change`;
  }

  changeKeepLiveChoice(): void {
    const s = this.approvalInfo;
    if (!s || this.keepLiveBusy) return;
    KeepLiveChoiceDialogComponent.open(this.dialog, {
      kind: "guide",
      title: this.title,
      publishedVersion: s.publishedVersion || s.version,
      current: this.keepsPublishedLive,
    }).subscribe((choice) => {
      if (choice === undefined) return;
      const undecided = s.keepPublishedLive == null && !s.hasPendingDraft;
      if (!undecided && choice === this.keepsPublishedLive) return;
      this.setKeepPublishedLive(choice);
    });
  }

  /**
   * Before the first draft save of a published guide, asks whether the published
   * version stays visible. Returns true when the save was deferred to the dialog.
   */
  private deferSaveForKeepLiveChoice(proceed: () => void): boolean {
    const s = this.approvalInfo;
    if (!s || !s.isLive || s.hasPendingDraft || s.keepPublishedLive != null || !this.hasFlowRowKey()) {
      return false;
    }
    KeepLiveChoiceDialogComponent.open(this.dialog, {
      kind: "guide",
      title: this.title,
      publishedVersion: s.publishedVersion || s.version,
    }).subscribe((choice) => {
      if (choice === undefined) return;
      this.setKeepPublishedLive(choice, proceed);
    });
    return true;
  }

  private setKeepPublishedLive(keepLive: boolean, then?: () => void): void {
    const key = this.currentFlowKey();
    if (!key) return;
    this.keepLiveBusy = true;
    this.frontlineOps.keepPublishedLive("guide", String(key), keepLive).subscribe({
      next: (status) => {
        this.keepLiveBusy = false;
        this.approvalInfo = { ...(this.approvalInfo || {}), ...(status || {}), keepPublishedLive: keepLive };
        this.toastr.success(
          keepLive
            ? "The published version stays visible while you edit."
            : "The published version is hidden until the new version is published."
        );
        this.cdr.detectChanges();
        then?.();
      },
      error: (err) => {
        this.keepLiveBusy = false;
        this.toastr.error(err?.error?.error || "Couldn't update this setting. Please try again.");
      },
    });
  }

  submitForApproval(): void {
    const key = this.currentFlowKey();
    if (!key) {
      this.toastr.warning("Save a draft before submitting for approval.");
      return;
    }
    // Reviewers must see exactly what will be published: save pending edits first.
    if (this.hasUnsavedChanges) {
      this.saveFlowToServer("Submitted", () => this.submitForApproval());
      return;
    }
    this.approvalBusy = true;
    this.frontlineOps
      .approvalAction({
        flowRowKey: key,
        action: "submit",
        changeSummary: "Submitted for process-owner / quality review",
      })
      .subscribe({
        next: (flow) => {
          this.approvalBusy = false;
          this.applyApprovalMetaFromFlow(flow);
          this.contentApprovalState = "InReview";
          this.toastr.success("Submitted for approval");
          this.closeToHome();
        },
        error: (err) => {
          this.approvalBusy = false;
          this.toastr.error(err?.error?.error || "Submit for approval failed");
        },
      });
  }

  approveWorkInstruction(): void {
    const key = this.currentFlowKey();
    if (!key) return;
    this.approvalBusy = true;
    this.frontlineOps
      .approvalAction({
        flowRowKey: key,
        action: "approve",
        comment: this.approvalComment?.trim() || undefined,
      })
      .subscribe({
        next: (flow) => {
          this.approvalBusy = false;
          this.approvalComment = "";
          this.applyApprovalMetaFromFlow(flow);
          this.loadApprovalInfo();
          this.toastr.success("Approved and published in your organization");
        },
        error: (err) => {
          this.approvalBusy = false;
          this.toastr.error(err?.error?.error || "Approve failed");
        },
      });
  }

  rejectWorkInstruction(): void {
    const key = this.currentFlowKey();
    if (!key) return;
    const reason = this.approvalComment?.trim();
    if (!reason) {
      this.toastr.warning("Add a short reason so the author knows what to change.");
      return;
    }
    this.approvalBusy = true;
    this.frontlineOps
      .approvalAction({
        flowRowKey: key,
        action: "reject",
        comment: reason,
      })
      .subscribe({
        next: (flow) => {
          this.approvalBusy = false;
          this.approvalComment = "";
          this.applyApprovalMetaFromFlow(flow);
          this.contentApprovalState = "Rejected";
          this.loadApprovalInfo();
          this.toastr.success("Rejected — author can revise and resubmit");
        },
        error: (err) => {
          this.approvalBusy = false;
          this.toastr.error(err?.error?.error || "Reject failed");
        },
      });
  }

  publishApprovedContent(): void {
    if (this.contentApprovalState !== "Approved") {
      this.toastr.warning("Content must be approved before publish");
      return;
    }
    if (this.approvedContentEdited) {
      this.toastr.warning("You changed approved content. Submit it for approval again before publishing.");
      return;
    }
    this.publishWithSelectedAccess();
  }

  canTakeContentToPublic(): boolean {
    return (
      this.requiresOrgApproval &&
      this.orgContext.allowsPublicContentPublish()
    );
  }

  readonly takeToPublicSteps = takeToPublicSteps("guide");

  get canSubmitForApproval(): boolean {
    return (
      !!(this.rowKey || this.flowId) &&
      this.requiresOrgApproval &&
      this.contentApprovalState !== "InReview" &&
      (this.contentApprovalState !== "Approved" || this.approvedContentEdited)
    );
  }

  /** Phone footer shows these from a menu instead of side-by-side buttons. */
  get hasMobileMoreActions(): boolean {
    return this.requiresOrgApproval || !!(this.rowKey || this.flowId) || !!this.publishingStatusLine;
  }

  /**
   * Approved or published guides can go public. A live copy also counts: its approval state can
   * read InReview while later edits of a kept-live guide are re-reviewed.
   */
  private get isEligibleForPublic(): boolean {
    if (this.approvalInfo?.isLive) return true;
    const state = this.approvalInfo?.approvalState || this.contentApprovalState;
    return state === "Approved" || state === "Published";
  }

  get promoteStatus(): PromoteStatus {
    return promoteStatusFromAudit(this.approvalInfo?.audit);
  }

  get takeToPublicLabel(): string {
    if (this.promoteStatus === "pending") return "Public request pending";
    if (this.promoteStatus === "promoted") return "Update public copy";
    return "Take to public";
  }

  /** Why "Take to public" can't be used yet; empty when it can. */
  get takeToPublicBlockedReason(): string {
    if (!this.orgContext.allowsPublicContentPublish()) {
      return "Your organization doesn't allow publishing to the public catalog. An org admin can turn this on in Org admin > Structure.";
    }
    if (!(this.rowKey || this.flowId) || !this.isEligibleForPublic) {
      const state = this.approvalInfo?.approvalState || this.contentApprovalState;
      if (state === "InReview") {
        return "This guide is waiting for approval. Once it's approved it goes live in your organization and you can take it to public.";
      }
      return "Submit this guide for approval first. Once it's approved it goes live in your organization and you can take it to public.";
    }
    if (this.promoteStatus === "pending") {
      return "Your request is waiting for an approver in Dashboard > Publishing approvals.";
    }
    return "";
  }

  requestPromoteToPublic(): void {
    const key = this.currentFlowKey();
    if (!key) {
      this.toastr.warning("Save this guide and get it approved first.");
      return;
    }
    if (!this.orgContext.allowsPublicContentPublish()) {
      this.toastr.info(
        "This organization does not allow publishing content to the public catalog."
      );
      return;
    }
    if (!this.isEligibleForPublic) {
      this.toastr.warning("Get this guide approved in your organization before taking it to public.");
      return;
    }
    this.approvalBusy = true;
    this.frontlineOps
      .approvalAction({
        flowRowKey: key,
        action: "requestPromote",
        changeSummary: "Request to publish publicly under the organization",
      })
      .subscribe({
        next: () => {
          this.approvalBusy = false;
          this.toastr.success("Request sent. An approver can promote it in Publishing approvals.");
          this.loadApprovalInfo();
        },
        error: (err) => {
          this.approvalBusy = false;
          this.toastr.error(err?.error?.error || "Could not request promote to public");
        },
      });
  }

  generateChecklist(): void {
    const key = this.currentFlowKey();
    if (!key) {
      this.toastr.warning("Save the guide first.");
      return;
    }
    this.approvalBusy = true;
    this.frontlineOps.generateChecklist(key).subscribe({
      next: (checklist) => {
        const rowKey = checklist?.rowKey || checklist?.RowKey;
        if (!rowKey) {
          this.approvalBusy = false;
          this.toastr.success("Checklist generated");
          return;
        }
        this.frontlineOps.approveChecklist(key, rowKey).subscribe({
          next: () => {
            this.approvalBusy = false;
            this.toastr.success("Checklist generated and approved");
          },
          error: () => {
            this.approvalBusy = false;
            this.toastr.warning("Checklist generated; approve it from the list later");
          },
        });
      },
      error: (err) => {
        this.approvalBusy = false;
        this.toastr.error(err?.error?.error || "Checklist generation failed");
      },
    });
  }

  get durationDisplay(): string {
    const val = this.duration || 0;
    if (val === 0) return '';
    const unit = this.durationUnit || 'Mins';
    return `${val} ${val === 1 ? unit.replace(/s$/i, '') : unit}`;
  }

  /**
   * Links such as `create-guide?flowId=…&edit=true` (approval notifications) open the editor
   * without the localStorage the editor loads from. Fetches the guide (unpublished edits when
   * there are any) and re-runs init. Returns true while that fetch is in flight.
   */
  private hydrateFromEditLink(): boolean {
    const linkFlowId = this.actvatedroute.snapshot.queryParamMap.get("flowId");
    if (!linkFlowId || this.linkHydrationAttempted) return false;

    this.linkHydrationAttempted = true;
    const user = JSON.parse(localStorage.getItem("LoggedInUser") || "null");
    this.flowServiceService
      .getFlowById(linkFlowId, user?.emailAddress || "", { draft: true })
      .subscribe({
        next: (res) => {
          const flow = res?.flows ?? res?.Flows;
          if (flow) {
            writeGuideEditStorage(flow);
          } else {
            this.toastr.error("This guide couldn't be opened.");
          }
          this.ngOnInit();
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.toastr.error(err?.error?.message || "This guide couldn't be opened.");
          this.ngOnInit();
          this.cdr.detectChanges();
        },
      });
    return true;
  }

  ngOnInit() {
    // Prevent body scrolling when dialog is open
    document.body.style.overflow = "hidden";

    if (this.hydrateFromEditLink()) {
      return;
    }

    // Check if mobile view
    this.checkMobileView();

    // Show selection menu for new flows (not editing)
    // This will be checked again after flow data is loaded

    localStorage.removeItem("selectedTransferUserForTransfer");
    this.draft = localStorage.getItem("draftWord");
    this.edit = localStorage.getItem("editWord");

    // Snapshot the raw server state that viewflow stored in localStorage at
    // the exact moment the user clicked "Edit".  We read directly from
    // localStorage here — before ngOnInit sets any component properties —
    // so the baseline is always the server version, not any partial in-memory state.
    if (this.edit) {
      this._snapshotFromLocalStorage();
    }
    this.flowServiceService.setScrollTop();
    this.showItemsOrStepsButton = true;
    this.disablePublishButton = true;
    this.showDeleteContentMenu = false;
    this.uniqueId = "";
    this.rowKey = 0;
    this.noResultReturned = false;

    // Check for active transfer requests if we have a flow ID
    if (this.rowKey) {
      this.checkTransferOwnershipStatus(this.rowKey);
    }

    this.stepDescription = null;
    this.title = null;
    this.duration = 0;
    this.durationUnit = 'Mins';
    this.CategoryName = null;
    //
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.showSmartCreatePaidBadge = showSmartCreatePaidBadge(this.userData);
    this.aiCreationAllowed = hasAiCreationAccess(this.userData);
    this.applyCreatorPaidOnlyRules();
    this.showNotificationCount = false;
    this.notificationCount = 4;

    console.log(this.userData);
    var cName = localStorage.getItem("selectedCategoryName");

    this.accessType = localStorage.getItem("AccessType");
    if (!this.accessType) {
      this.accessType = "Public";
    }
    this.syncJourneyAccessChoiceFromFields();
    //
    if (this.userData != null) {
      this.userDisplayName = this.userData.firstName;
    }
    this.dataService.setFlowByCategorieschangeMessage.subscribe((flowData) => {
      this.flows = flowData;
      this.flows = JSON.parse(localStorage.getItem("flowByCategory"));
    });

    this.inames = JSON.parse(localStorage.getItem("ItemsRequired"));
    if (!Array.isArray(this.inames)) {
      this.inames = [];
    }
    // Auto-check "Add items to this flow" on page load when items already exist
    // (and ensure it's false when there are no items yet)
    this.isItemsRequired = this.hasItems;

    this.groupDataByGroupName();
    this.getAllItemGroupName();
    this.setupLibrarySearch();
    this.setupStepItemSearch();
    this.selectFirstAvailableJourneyTab();

    console.log(this.inames);
    var flowCoverPage = JSON.parse(
      localStorage.getItem("flowCoverPageDetails")
    );

    console.log(flowCoverPage);

    var supportingDocumentDocuments = JSON.parse(
      localStorage.getItem("SupportingDocumentDocuments")
    );

    var supportingDocumentHyperLinks = JSON.parse(
      localStorage.getItem("SupportingDocumentHyperLinksRequired")
    );

    if (supportingDocumentDocuments != null) {
      this.supportingDocumentDocuments = supportingDocumentDocuments;
      this._documentCount = supportingDocumentDocuments.length;
    } else {
      this._documentCount = 0;
    }

    if (supportingDocumentHyperLinks != null) {
      this.supportingDocumentHyperLinks = supportingDocumentHyperLinks;
      this._hyperlinkCount = supportingDocumentHyperLinks.length;
    } else {
      this._hyperlinkCount = 0;
    }

    if (flowCoverPage != null) {
      this.showItemsOrStepsButton = false;
      this.isCoverAImageOrVideo(flowCoverPage.coverImage);
      this.coverImageUri = flowCoverPage.coverImage;
      this.coverPosterPageURI = flowCoverPage.coverPosterPageURI;
      this.title = flowCoverPage.title;
      this.searchKeyWords =
        flowCoverPage.searchKeyWords && flowCoverPage.searchKeyWords.length > 0
          ? flowCoverPage.searchKeyWords
          : "";
      this.description = flowCoverPage.description;
      this.duration = flowCoverPage.duration ?? flowCoverPage.Duration ?? 0;
      this.durationUnit = flowCoverPage.durationUnit || flowCoverPage.DurationUnit || 'Mins';
      this.rowKey = flowCoverPage.rowKey;
      this.coverIsSafetyCritical = flowCoverPage.coverIsSafetyCritical || false;
      this.coverSafetyInstructionsTitle = flowCoverPage.coverSafetyInstructionsTitle || "";
      this.coverSafetyInstructionsDescription = flowCoverPage.coverSafetyInstructionsDescription || "";
      this.uniqueId = flowCoverPage.uniqueId;
      this.fileName = flowCoverPage.fileName;
      this.applySavedAccessFromSource(flowCoverPage);
      this.loadSavedAdvancedAccessFromServer();
      this.price = flowCoverPage.price;
      this.isPaid = flowCoverPage.isPaid;
      this.partitionKey = flowCoverPage.customerEmail;
      this.flowId = flowCoverPage.flowId;
      this.type = flowCoverPage.type;
      this.isSponsored = flowCoverPage.isSponsored || false;
      this.applyViewerFeaturesFromSource(flowCoverPage);
      this.applyEndQuestionFormFromSource(flowCoverPage);
      this.isCollaboration = flowCoverPage.isCollaboration || false;
      this.collabValue = flowCoverPage.collaborationValue || null;
      // Restore collaborators list — prefer the new JSON list, fall back to single email
      if (flowCoverPage.coAuthorEmails) {
        try {
          const emails: string[] = JSON.parse(flowCoverPage.coAuthorEmails);
          let userNames: string[] = [];
          let profilePicUrls: string[] = [];
          try { if (flowCoverPage.coAuthorUserNames) userNames = JSON.parse(flowCoverPage.coAuthorUserNames); } catch {}
          try { if (flowCoverPage.coAuthorProfilePicUrls) profilePicUrls = JSON.parse(flowCoverPage.coAuthorProfilePicUrls); } catch {}
          this.collabInvitees = emails.map((email, index) => ({
            email,
            userName: userNames[index] || (index === 0 ? (flowCoverPage.coAuthorUserName || email) : email),
            profilePicUrl: profilePicUrls[index] || (index === 0 ? (flowCoverPage.coAuthorProfilePicUrl || null) : null),
            status: flowCoverPage.collaborationStatus || ''
          }));
        } catch { this.collabInvitees = []; }
      } else if (flowCoverPage.coAuthorEmail) {
        this.collabInvitees = [{
          email: flowCoverPage.coAuthorEmail,
          userName: flowCoverPage.coAuthorUserName || flowCoverPage.coAuthorEmail,
          profilePicUrl: flowCoverPage.coAuthorProfilePicUrl || null,
          status: flowCoverPage.collaborationStatus || ''
        }];
      } else {
        this.collabInvitees = [];
      }

      this.applyCreatorPaidOnlyRules();

      this.CategoryName = this.resolveCategoryName(
        flowCoverPage.type,
        cName
      );

      if (flowCoverPage.rowKey != null && flowCoverPage.rowKey != undefined) {
        this.showDeleteContentMenu = true;
        // Check for active transfer requests when editing an existing flow
        this.checkTransferOwnershipStatus(flowCoverPage.rowKey);
        this.loadApprovalInfo();
      }
    } else {
      this.coverImageUri = null;
      this.CategoryName = this.resolveCategoryName(null, cName);
    }

    this._steps = JSON.parse(localStorage.getItem("stepsCoverPageDetails"));
    this.allSteps = [];

    if (this._steps != null && this._steps.length > 0) {
      this.disablePublishButton = false;

      this._steps.forEach((element) => {
        this.isImageOrVideo(element.url);

        this.allSteps.push({
          Url: element.url,
          title: element.title,
          Description: element.description || element.Description || "",
          showImage: this.showImage,
          VideoThumbNailUrl: element.posterUrl,
          showVideo: this.showVideo,
          stepFileName: element.stepFileName || element.fileName,
          stepNumber: this.stepNumber++,
          taggedItems: element.taggedItems || [],
          isSafetyCritical: element.isSafetyCritical || element.IsSafetyCritical || false,
          safetyInstructionsTitle: element.safetyInstructionsTitle || element.SafetyInstructionsTitle || "",
          safetyInstructionsDescription: element.safetyInstructionsDescription || element.SafetyInstructionsDescription || "",
          questionForm: parseGuideQuestionForm(element.questionForm ?? element.QuestionForm),
        });
      });
    }
    this.selectFirstAvailableJourneyTab();
    // Mark the initially active tab as visited since user is viewing it
    this.visitedTabs.add(this.activeJourneyTab);

    this.getSupportFaqs(this.rowKey);
    console.log(this.rowKey);

    this.getAllFaqGroupName();
    this.getProfileUser();

    // Restore previously selected transfer user if any
    const persistedTransferUser = localStorage.getItem(
      "selectedTransferUserForTransfer"
    );
    if (persistedTransferUser) {
      try {
        this.selectedTransferUser = JSON.parse(persistedTransferUser);
      } catch {
        this.selectedTransferUser = null;
      }
    }

    var flowData = JSON.parse(localStorage.getItem("flow"));
    var notificationflowId = JSON.parse(
      localStorage.getItem("notificationflowId")
    );
    if (flowData != null && notificationflowId == null) {
      const storedFlowKey = flowData.rowKey || flowData.RowKey;
      // "flow" is also written when a guide is viewed, so it can belong to a different guide.
      if (!this.rowKey || !storedFlowKey || String(storedFlowKey) !== String(this.rowKey)) {
        flowData = null;
        localStorage.removeItem("flow");
      }
    }


    if (flowData == null || notificationflowId != null) {
      var email = "";

      if (this.userData != null) {
        email = this.userData.emailAddress;
      }

      const requestedFlowId = notificationflowId || (this.rowKey ? String(this.rowKey) : null);
      var flowQueryModel = new FlowQueryModel({
        FlowId: requestedFlowId,
        userEmail: email,
      });

      // this.noResultReturned = true;
      //
      if (requestedFlowId) this.flowServiceService.getFlowById(flowQueryModel).subscribe((data) => {
        //  this.noResultReturned = false;
        this.flowData = data.flows;
        // Check for active transfer requests when loading flow from API
        if (data.flows && data.flows.rowKey) {
          this.checkTransferOwnershipStatus(data.flows.rowKey);
        }
        // Hide selection menu if editing existing flow
        if (this.flowData) {
          this.showCreateTypeSelection = false;
          this.applySavedAccessFromSource(this.flowData);
          this.applyViewerFeaturesFromSource(this.flowData);
          this.applyEndQuestionFormFromSource(this.flowData);
          this.applyApprovalMetaFromFlow(this.flowData);
          this.loadApprovalInfo();
          this.loadSavedAdvancedAccessFromServer();
          this.applyCategoryFromFlowData(this.flowData);
        }
      });
    } else if (flowData != null) {
      this.flowData = flowData;
      this.applySavedAccessFromSource(flowData);
      this.applyViewerFeaturesFromSource(flowData);
      this.applyEndQuestionFormFromSource(flowData);
      this.applyApprovalMetaFromFlow(flowData);
      this.loadApprovalInfo();
      this.loadSavedAdvancedAccessFromServer();
      this.applyCategoryFromFlowData(flowData);
      // Check for active transfer requests when loading flow from localStorage
      if (flowData.rowKey) {
        this.checkTransferOwnershipStatus(flowData.rowKey);
      }
      // Hide selection menu if editing existing flow
      this.showCreateTypeSelection = false;
    } else {
      // Show selection menu for new flows
      const flowCoverPage = JSON.parse(localStorage.getItem("flowCoverPageDetails"));
      if (!flowCoverPage && !this.flowId) {
        this.showCreateTypeSelection = true;
      }
    }

    var createflowcallsavedraft = localStorage.getItem("create-flow-savedraft");
    if (createflowcallsavedraft == "create-flow-call-savedraft") {
      localStorage.removeItem("create-flow-savedraft");
    }

    //get support Faq
    // this.faqs =  this.flowServiceService.getSupportFaq(flowData.rowKey);
    // console.log(this.faqs);
    // if(this.faqs.groups != null){
    //   this.isFaqChecked=true;
    //  this.faqs.forEach((element:any)=>{
    //    this._allFaqs.push({
    //      groupName : element.groupName,
    //      answer : element.answer,
    //      question : element.question,
    //      flowRowKey : element.partitionKey
    //    });
    //  });
    //  console.log(this._allFaqs);
    // }

    // Yield one tick so Quill can finish its initial render, then open up
    // change detection.  Any binding events that fired during the init tick
    // are evaluated immediately after the guard lifts.
    if (this.edit) {
      setTimeout(() => {
        this._editChangeDetectionReady = true;
        this.markAsChanged(); // catch anything that fired before the guard was ready
      }, 0);
    }
  }

  getSupportFaqs(flowId) {
    console.log(flowId);
    var flowQueryModel = new FlowQueryModel({
      FlowId: flowId,
    });
    this.flowServiceService.getSupportFaq(flowQueryModel).subscribe((data) => {
      this.noResultReturned = false;
      if (data.length > 0) {
        console.log(data);
        this.isFaqChecked = true;
        this._allFaqs = [];
        data.forEach((element: any) => {
          if (element.isValid) {
            this._allFaqs.push({
              groupName: element.groupName,
              answer: element.answer,
              question: element.question,
              partitionKey: element.partitionKey,
              flowRowKey: element.partitionKey,
              userEmail: element.userEmail,
              rowKey: element.rowKey,
            });
          }
        });
        console.log(this._allFaqs);
        this.groupFaqDataByGroupName();
        this.selectFirstAvailableJourneyTab();
      } else {
        this.isFaqChecked = false;
        this.selectFirstAvailableJourneyTab();
      }
      console.log(this.isFaqChecked);

      // Patch the FAQ slice of the initial snapshot so that loaded FAQs
      // are treated as the baseline (not as user-made changes).
      if (this.edit && this._initialFlowState) {
        try {
          const snap = JSON.parse(this._initialFlowState);
          snap.faqs = (this._allFaqs || []).map(f => ({ question: f.question || '', answer: f.answer || '' }));
          this._initialFlowState = JSON.stringify(snap);
          // Re-evaluate in case the user hadn't made real changes yet
          if (!this.hasUnsavedChanges) {
            this.hasUnsavedChanges = this._buildStateSnapshot() !== this._initialFlowState;
            this.cdr.detectChanges();
          }
        } catch { /* ignore */ }
      }
    });
  }

  groupDataByGroupName() {
    if (!this.inames || this.inames.length === 0) {
      this.groupedData = {}; // Ensure no errors on empty or undefined data
      this.selectFirstAvailableJourneyTab();
      this.cdr.markForCheck();
      return;
    }

    // Create a new object to ensure change detection triggers
    const newGroupedData: Record<string, any[]> = {};

    this.inames.forEach((item) => {
      // Keep original groupName (including empty string) for data consistency
      const group = item.groupName || ""; // Default group if missing
      if (!newGroupedData[group]) {
        newGroupedData[group] = [];
      }
      newGroupedData[group].push(item);
    });

    // Assign new object to trigger change detection
    this.groupedData = { ...newGroupedData };
    console.log(this.groupedData);
    this.getAllItemGroupName();
    this.selectFirstAvailableJourneyTab();
    this.cdr.markForCheck();
  }

  getAllDropListIds(): string[] {
    return Object.keys(this.groupedData);
  }
  groupFaqDataByGroupName() {
    if (!this._allFaqs || this._allFaqs.length === 0) {
      this.groupedFaqData = {}; // Ensure no errors on empty or undefined data
      this.selectFirstAvailableJourneyTab();
      return;
    }

    this.groupedFaqData = this._allFaqs.reduce((acc, item) => {
      const group = item.groupName || ""; // Default group if missing
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(item);
      return acc;
    }, {} as Record<string, any[]>);
    console.log(this.groupedFaqData);
    this.getAllFaqGroupName();
    this.selectFirstAvailableJourneyTab();
  }

  getAllFaqDropListIds(): string[] {
    return Object.keys(this.groupedFaqData);
  }

  setActiveJourneyTab(tabId: JourneyTabId) {
    const currentIndex = this.getJourneyTabIndex(this.activeJourneyTab);
    const targetIndex = this.getJourneyTabIndex(tabId);

    if (
      targetIndex > currentIndex &&
      !this.validateCurrentTabBeforeNavigation(tabId)
    ) {
      return;
    }

    if (!this.canAccessJourneyTab(tabId)) {
      const warningMessage = this.getJourneyTabLockMessage(tabId);
      if (warningMessage) {
        this.toastr.warning(warningMessage);
      }
      return;
    }
    
    // Mark the previous tab as visited when navigating away from it
    // For items, faqs, access, and summary tabs, mark them as visited when leaving
    const previousTab = this.activeJourneyTab;
    if (previousTab && previousTab !== tabId) {
      if (
        previousTab === "items" ||
        previousTab === "faqs" ||
        previousTab === "access" ||
        previousTab === "summary"
      ) {
        this.visitedTabs.add(previousTab);
      }
      if (previousTab === "access" && this.journeyAccessChoice === "Restricted") {
        this.captureRestrictedAccessDraft();
      }
    }
    
    this.activeJourneyTab = tabId;
    this.journeyTabManuallySelected = true;
    if (tabId === "access" && this.journeyAccessChoice === "Restricted") {
      this.restoreRestrictedAccessDraft();
      this.stageAccessFlowModelForPanel();
    }
  }

  getJourneyTabCount(tabId: JourneyTabId): number {
    switch (tabId) {
      case "cover":
        return this.coverImageUri ? 1 : 0;
      case "items":
        return this.inames?.length || 0;
      case "steps":
        return this.allSteps?.length || 0;
      case "faqs":
        return this._allFaqs?.length || 0;
      default:
        return 0;
    }
  }

  getActiveTabLabel(): string {
    const tab = this.journeyTabs.find((t) => t.id === this.activeJourneyTab);
    if (!tab) return "Flow";

    // Format labels for summary title
    switch (tab.id) {
      case "cover":
        return "Cover Page";
      case "items":
        return "Items";
      case "steps":
        return "Steps";
      case "faqs":
        return "Support FAQs";
      default:
        return tab.label;
    }
  }

  getTruncatedDescription(html: string, maxLength: number = 150): string {
    if (!html) return "";
    // Remove HTML tags for length calculation
    const textContent = html.replace(/<[^>]*>/g, "");
    if (textContent.length <= maxLength) {
      return html;
    }
    // Truncate and add ellipsis
    const truncated = textContent.substring(0, maxLength) + "...";
    // Try to preserve some basic formatting if it's simple HTML
    if (html.includes("<p>") || html.includes("<div>")) {
      return `<p>${truncated}</p>`;
    }
    return truncated;
  }

  /**
   * Truncate text based on limit, showing specified characters and rest as ".."
   * @param text - Text to truncate
   * @param limit - Maximum character limit
   * @returns Truncated text with ".." if exceeds limit
   */
  truncateText(text: string, limit: number): string {
    if (!text) return "";
    if (text.length <= limit) return text;
    // Show characters up to the limit + ".."
    return text.substring(0, limit) + "..";
  }

  get hasCover(): boolean {
    return !!this.coverImageUri;
  }

  get hasItems(): boolean {
    return Array.isArray(this.inames) && this.inames.length > 0;
  }

  get hasGroupedItemsData(): boolean {
    return Object.keys(this.groupedData || {}).length > 0;
  }

  get hasGroupedFaqData(): boolean {
    return Object.keys(this.groupedFaqData || {}).length > 0;
  }

  get hasSteps(): boolean {
    return Array.isArray(this.allSteps) && this.allSteps.length > 0;
  }

  get totalItemsCount(): number {
    if (!this.hasGroupedItemsData) {
      return 0;
    }
    return Object.values(this.groupedData || {}).reduce(
      (total, items) => total + (items?.length || 0),
      0
    );
  }

  get totalSupportingDocs(): number {
    return (
      (this.supportingDocumentDocuments?.length || 0) +
      (this.supportingDocumentHyperLinks?.length || 0)
    );
  }

  get hasFaqs(): boolean {
    return Array.isArray(this._allFaqs) && this._allFaqs.length > 0;
  }

  private hasDataForTab(tabId: JourneyTabId): boolean {
    switch (tabId) {
      case "cover":
        return this.hasCover;
      case "items":
        // Only return true if there are actual items
        // The isItemsRequired flag affects validation, not whether tab has data
        return this.hasItems;
      case "steps":
        return this.hasSteps;
      case "faqs":
        return this.hasFaqs;
      case "access":
        return !!this.journeyAccessChoice;
      case "summary":
        return this.hasSteps; // Summary requires steps to be completed
      default:
        return false;
    }
  }

  private selectFirstAvailableJourneyTab(): void {
    if (this.journeyTabManuallySelected) {
      return;
    }
    const priority: JourneyTabId[] = ["cover", "items", "steps", "faqs"];
    for (const tab of priority) {
      if (this.hasDataForTab(tab)) {
        this.activeJourneyTab = tab;
        return;
      }
    }
    this.activeJourneyTab = "cover";
  }

  private getJourneyTabIndex(tabId: JourneyTabId): number {
    return this.journeyTabs.findIndex((tab) => tab.id === tabId);
  }

  get isLastJourneyTab(): boolean {
    const currentIndex = this.getJourneyTabIndex(this.activeJourneyTab);
    return currentIndex === -1 || currentIndex >= this.journeyTabs.length - 1;
  }

  get nextJourneyTabLabel(): string {
    const currentIndex = this.getJourneyTabIndex(this.activeJourneyTab);
    if (currentIndex === -1 || currentIndex >= this.journeyTabs.length - 1) {
      return "";
    }
    return this.journeyTabs[currentIndex + 1]?.label ?? "";
  }

  goToNextJourneyTab(): void {
    const currentIndex = this.getJourneyTabIndex(this.activeJourneyTab);
    if (currentIndex === -1 || currentIndex >= this.journeyTabs.length - 1) {
      return;
    }
    const nextTabId = this.journeyTabs[currentIndex + 1].id;
    if (!this.validateCurrentTabBeforeNavigation(nextTabId)) {
      return;
    }
    this.setActiveJourneyTab(nextTabId);
  }

  isJourneyStageComplete(tabId: JourneyTabId): boolean {
    // Mark a tab green once it's been visited (even if optional data wasn't added),
    // as long as it's not the currently active tab.
    return this.visitedTabs.has(tabId) && tabId !== this.activeJourneyTab;
  }

  isJourneyStageActive(tabId: JourneyTabId): boolean {
    return this.activeJourneyTab === tabId;
  }

  private validateCurrentTabBeforeNavigation(
    targetTabId: JourneyTabId
  ): boolean {
    const currentIndex = this.getJourneyTabIndex(this.activeJourneyTab);
    const targetIndex = this.getJourneyTabIndex(targetTabId);
    if (targetIndex <= currentIndex) {
      return true;
    }

    switch (this.activeJourneyTab) {
      case "cover":
        if (!this.title?.trim()) {
          this.toastr.warning("Please add a title before continuing.");
          this.scrollToSection(this.coverTitleSection);
          return false;
        }
        if (!this.coverImageUri) {
          this.toastr.warning("Please upload a cover image or video.");
          this.scrollToSection(this.coverMediaSection);
          return false;
        }
        // If cover is a video, require a thumbnail image to be uploaded
        if (this.showCoverVideo && !this.coverPosterPageURI) {
          this.toastr.warning(
            "Please upload a thumbnail image for your video cover before continuing."
          );
          this.scrollToSection(this.coverMediaSection);
          return false;
        }
        if (!this.hasCoverDescription()) {
          this.toastr.warning("Please add a description for your guide.");
          this.scrollToSection(this.coverDescriptionSection);
          return false;
        }
        // Validate price if paid content is enabled
        if (this.isPaid && !this.isValidPriceForPaidContent()) {
          this.toastr.warning(
            "Please enter a valid price greater than 0 for paid content."
          );
          return false;
        }
        break;
      case "items":
        // Only validate items if they are required
        if (this.isItemsRequired && !this.hasItems) {
          this.toastr.warning("Add at least one item to continue.");
          this.scrollToSection(this.itemsSection);
          return false;
        }
        // If navigating to steps from items, check if items are required
        if (targetTabId === "steps" && this.isItemsRequired && !this.hasItems) {
          this.toastr.warning(
            "Items are required. Please add at least one item before proceeding to steps."
          );
          this.scrollToSection(this.itemsSection);
          return false;
        }
        break;
      case "steps":
        if (!this.hasSteps) {
          this.toastr.warning("Add at least one step to continue.");
          this.scrollToSection(this.stepsSection);
          return false;
        }
        break;
      default:
        break;
    }
    return true;
  }

  // Check if price is valid when paid content is enabled
  isValidPriceForPaidContent(): boolean {
    if (!this.isPaid || isOrganizationAccountMode()) {
      return true; // Free / organization content needs no price
    }
    // If paid, price must exist and be greater than 0
    const priceValue = parseFloat(this.price);
    return !isNaN(priceValue) && priceValue > 0;
  }

  canAccessJourneyTab(tabId: JourneyTabId): boolean {
    const targetIndex = this.getJourneyTabIndex(tabId);
    if (targetIndex <= 0) {
      return true; // Cover tab is always available
    }
    // Access + Summary only require steps (FAQs/Access are optional selections)
    if (tabId === "summary" || tabId === "access") {
      return this.hasSteps;
    }
    for (let i = 0; i < targetIndex; i++) {
      const prerequisiteId = this.journeyTabs[i].id;
      // Skip items tab check if items are not required
      if (prerequisiteId === "items" && !this.isItemsRequired) {
        continue;
      }
      // FAQs and Access do not block later tabs
      if (prerequisiteId === "faqs" || prerequisiteId === "access") {
        continue;
      }
      if (!this.hasDataForTab(prerequisiteId)) {
        return false;
      }
    }
    return true;
  }

  getJourneyTabLockMessage(tabId: JourneyTabId): string {
    const targetIndex = this.getJourneyTabIndex(tabId);
    if (targetIndex <= 0) {
      return "";
    }
    // Special handling for steps tab when items are required
    if (tabId === "steps" && this.isItemsRequired && !this.hasItems) {
      return "Add items before continuing to steps.";
    }
    if ((tabId === "access" || tabId === "summary") && !this.hasSteps) {
      return "Add steps before continuing.";
    }
    const blockingTab = this.journeyTabs
      .slice(0, targetIndex)
      .reverse()
      .find((tab) => {
        // Skip items tab if items are not required
        if (tab.id === "items" && !this.isItemsRequired) {
          return false;
        }
        if (tab.id === "faqs" || tab.id === "access") {
          return false;
        }
        return !this.hasDataForTab(tab.id);
      });

    if (!blockingTab) {
      return "";
    }
    return `Complete ${blockingTab.label} before continuing.`;
  }

  private hasCoverDescription(): boolean {
    return this.stripHtml(this.description).trim().length > 0;
  }

  getPlainText(value?: string): string {
    return this.stripHtml(value || "").trim();
  }

  private stripHtml(value: string): string {
    if (!value) {
      return "";
    }
    return value.replace(/<[^>]+>/g, "");
  }

  private scrollToSection(section?: ElementRef<HTMLElement>) {
    if (!section) {
      return;
    }
    const container = this.journeyScrollContainer?.nativeElement;
    const sectionEl = section.nativeElement;
    if (container) {
      const containerRect = container.getBoundingClientRect();
      const sectionRect = sectionEl.getBoundingClientRect();
      const offset =
        sectionRect.top - containerRect.top + container.scrollTop - 40;
      container.scrollTo({ top: offset, behavior: "smooth" });
    } else {
      sectionEl.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    sectionEl.classList.add("field-highlight");
    setTimeout(() => sectionEl.classList.remove("field-highlight"), 2000);
  }

  removeGroup(index: number, group: any) {
    console.log(group);
    var model = {
      partitionKey: group.flowRowKey,
      rowKey: group.rowKey,
      groupName: group.groupName,
      answer: group.answer,
      question: group.question,
      userEmail: group.userEmail,
    };
    this.flowServiceService.deleteSupportFaq(model).subscribe((data) => {
      console.log(data);
      if (data) {
        this.toastr.success("All FAQs saved successfully!");
        this.getSupportFaqs(this.rowKey);
      } else {
        this.toastr.error("Faqs deletion failed. Please try again!");
      }
    });
  }
  // Edit an existing group
  editGroup(i, group: any) {
    console.log(group);
    const index = this.getGlobalIndexForFaq(group);
    console.log(index);
    localStorage.setItem("SupportFaqs", JSON.stringify(this._allFaqs));
    localStorage.setItem("stepToFaq", index.toString());

    // Populate form fields for editing
    this.faqGroupName = group.groupName || "";
    this.faqQuestion = group.question || "";
    this.faqAnswer = group.answer || "";

    // Optionally open dialog or just edit inline
    // const dialogRef = this.dialog.open(FaqComponent, {
    //   width: "90vw",
    //   maxWidth: "1200px",
    //   maxHeight: "95vh",
    //   panelClass: "faq-dialog",
    //   disableClose: false,
    // });

    // dialogRef.afterClosed().subscribe((result) => {
    //   // Refresh FAQs data after dialog closes
    //   this.refreshFaqsData();
    // });
  }

  dropFaq(event: CdkDragDrop<string[]>) {
    moveItemInArray(this._allFaqs, event.previousIndex, event.currentIndex);
  }

  openLink(url) {
    url = "https://" + url;
    window.open(url);
  }

  getFileName(fileName) {
    return fileName.slice(((fileName.lastIndexOf("/") - 1) >>> 0) + 2);
  }

  showImage: boolean;
  showVideo: boolean;

  isCoverAImageOrVideo(url) {
    const imageExtensions = [
      "jpeg",
      "jpg",
      "png",
      "gif",
      "jfif",
      "tiff",
      "tif",
      "pdf",
      "bmp",
      "webp",
      "svg",
      "heic",
      "heif",
      "raw",
      "arw",
      "cr2",
      "nef",
      "orf",
      "rw2",
      "dng",
      "psd",
      "ico",
      "exif",
      "pjpeg",
      "ppm",
      "pgm",
      "pbm",
      "pnm",
      "xpm",
      "tga",
      "pcx",
      "jp2",
      "jpx",
      "eps",
      "ai",
    ];
    const videoExtensions = [
      "mp4",
      "mov",
      "wmv",
      "flv",
      "avchd",
      "webm",
      "mkv",
      "vob",
      "ogv",
      "gifv",
      "m4p",
      "m4v",
      "3gp",
      "3g2",
      "amv",
      "nsv",
      "ogg",
      "f4v",
      "f4p",
      "f4a",
      "f4b",
      "avi",
      "mts",
      "m2ts",
      "ts",
      "mpg",
      "mpeg",
      "rm",
      "rmvb",
      "divx",
      "xvid",
      "asf",
      "mxf",
      "dv",
      "h264",
      "h265",
      "vp8",
      "vp9",
      "prores",
      "swf",
      "dat",
      "bik",
      "av1",
      "vro",
      "svi",
    ];

    const lowerUrl = url.toLowerCase();

    if (imageExtensions.some((ext) => lowerUrl.includes(ext))) {
      this.showCoverImage = true;
      this.showCoverVideo = false;
    } else if (videoExtensions.some((ext) => lowerUrl.includes(ext))) {
      this.showCoverVideo = true;
      this.showCoverImage = false;
    }
  }

  isImageOrVideo(url) {
    const imageExtensions = [
      "jpeg",
      "jpg",
      "png",
      "gif",
      "jfif",
      "tiff",
      "tif",
      "pdf",
      "bmp",
      "webp",
      "svg",
      "heic",
      "heif",
      "raw",
      "arw",
      "cr2",
      "nef",
      "orf",
      "rw2",
      "dng",
      "psd",
      "ico",
      "exif",
      "pjpeg",
      "ppm",
      "pgm",
      "pbm",
      "pnm",
      "xpm",
      "tga",
      "pcx",
      "jp2",
      "jpx",
      "eps",
      "ai",
    ];
    const videoExtensions = [
      "mp4",
      "mov",
      "wmv",
      "flv",
      "avchd",
      "webm",
      "mkv",
      "vob",
      "ogv",
      "gifv",
      "m4p",
      "m4v",
      "3gp",
      "3g2",
      "amv",
      "nsv",
      "ogg",
      "f4v",
      "f4p",
      "f4a",
      "f4b",
      "avi",
      "mts",
      "m2ts",
      "ts",
      "mpg",
      "mpeg",
      "rm",
      "rmvb",
      "divx",
      "xvid",
      "asf",
      "mxf",
      "dv",
      "h264",
      "h265",
      "vp8",
      "vp9",
      "prores",
      "swf",
      "dat",
      "bik",
      "av1",
      "vro",
      "svi",
    ];

    const lowerUrl = url.toLowerCase();

    if (imageExtensions.some((ext) => lowerUrl.includes(ext))) {
      this.showImage = true;
      this.showVideo = false;
    } else if (videoExtensions.some((ext) => lowerUrl.includes(ext))) {
      this.showVideo = true;
      this.showImage = false;
    }
  }

  closeToHome() {
    localStorage.setItem("activeTabIndex", "2");
    this.flowNavigationService.navigateBack(this.returnUrl);
  }

  saveDraftAndClose(): void {
    this.saveFlowToServer("Submitted", () => this.closeToHome());
  }

  cancelToSelection() {
    this.flowNavigationService.navigateBack(this.returnUrl);
  }

  leave() {
    localStorage.setItem("draftTabIndex", "2");
    var isDraft = localStorage.getItem("draftWord");
    var pageToNavigate = localStorage.setItem(
      "navigatebackfromcreateflow",
      "/user-profile"
    );
    localStorage.setItem("navigatebackfromcreatebundle", this.location.path());

    if (isDraft != null && isDraft != undefined) {
      this.router.navigate(["/user-profile"]);
    } else if (this.hasFlowRowKey()) {
      this.router.navigate([
        `/guide/${this.generateUrlSlug(this.title)}/${this.rowKey}`,
      ]);
    } else {
      this.flowNavigationService.navigateBack(this.returnUrl);
    }
  }

  previewFlow() {
    if (!this.hasFlowRowKey()) {
      this.toastr.warning(
        "Save your guide first to preview it.",
        "Preview unavailable"
      );
      return;
    }
    const slug = this.generateUrlSlug(this.title || "flow");
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/guide/${slug}/${this.rowKey}`])
    );
    window.open(url, "_blank");
  }

  generateUrlSlug(html) {
    if (!html) return "";

    return html
      .replace(/<[^>]*>/g, "") // Remove HTML tags
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove accents (é → e, ñ → n)
      .replace(/[^a-zA-Z0-9\s-]/g, "") // Remove special characters except spaces and "-"
      .trim() // Trim spaces from start/end
      .replace(/\s+/g, "-") // Replace spaces with "-"
      .replace(/-+/g, "-") // Remove duplicate dashes
      .toLowerCase(); // Convert to lowercase
  }

  showFlowImage(coverImageUri) {
    localStorage.setItem("flowImageToShow", coverImageUri);
    this.dialog.open(ShowFlowImageDialogComponent, {
      panelClass: ["media-dialog-pane", "media-dialog"],
      backdropClass: "custom-backdrop",
      maxWidth: "95vw",
      width: "auto",
      maxHeight: "95vh",
      height: "auto",
      autoFocus: false,
      restoreFocus: false,
    });
  }

  onButtonClick() {
    this.setActiveJourneyTab("cover");
    this.showMessage = false;
  }

  addSteps() {
    if (
      (this.title == undefined || null) &&
      (this.description == undefined || null) &&
      (this.coverImageUri == undefined || null)
    ) {
      this.showMessage = true;
      this.toastr.warning(
        "Please complete the cover page details before adding steps."
      );
      this.setActiveJourneyTab("cover");
    } else {
      this.showMessage = false;
      localStorage.removeItem("stepToEdit");
      this.setActiveJourneyTab("steps");
    }
  }
  addFaqs() {
    if (
      (this.title == undefined || null) &&
      (this.description == undefined || null) &&
      (this.coverImageUri == undefined || null)
    ) {
      this.showMessage = true;
      this.toastr.warning(
        "Please complete the cover page details before adding FAQs."
      );
      this.setActiveJourneyTab("cover");
    } else {
      this.showMessage = false;
      localStorage.removeItem("stepToFaq");
      this.setActiveJourneyTab("faqs");
    }
  }
  checkFaq() {
    this.isFaqChecked = true;
    if (
      (this.title == undefined || null) &&
      (this.description == undefined || null) &&
      (this.coverImageUri == undefined || null)
    ) {
      this.showMessage = true;
      this.toastr.warning(
        "Please fill in all the required details above before adding flow-FAQs."
      );
    }
  }

  // addFaqs(){
  //     this.router.navigate(["/faq"]);
  // }

  gotocategory() {
    localStorage.setItem("categoryName", this.CategoryName);
    localStorage.setItem("Flowdata", this.flowData);
    this.router.navigate(["/create-guide"]);
  }

  // drop(event: CdkDragDrop<string[]>) {
  //   moveItemInArray(this.inames, event.previousIndex, event.currentIndex);
  // }

  drop(event: CdkDragDrop<any[]>) {
    if (!event.item.data) return;

    const previousGroup = event.previousContainer.id;
    const newGroup = event.container.id;
    const item = event.item.data;

    if (previousGroup !== newGroup) {
      // Update the item with new group information
      // Handle "Ungrouped" display name - convert back to empty string for storage
      item.groupName =
        newGroup === "Ungrouped" || newGroup === "" ? "" : newGroup;

      // Update inames array to reflect the change
      const itemIndex = this.inames.findIndex((i) => i === item);
      if (itemIndex > -1) {
        this.inames[itemIndex] = { ...item };
      }

      // Save to localStorage
      localStorage.setItem("ItemsRequired", JSON.stringify(this.inames));

      // Regroup data to ensure consistency
      this.groupDataByGroupName();
    } else {
      // Reorder within the same group
      moveItemInArray(
        this.groupedData[newGroup],
        event.previousIndex,
        event.currentIndex
      );

      // Rebuild inames array from groupedData to maintain order
      this.inames = [];
      Object.keys(this.groupedData).forEach((groupKey) => {
        this.groupedData[groupKey].forEach((item) => {
          this.inames.push(item);
        });
      });

      // Save to localStorage
      localStorage.setItem("ItemsRequired", JSON.stringify(this.inames));
      this.cdr.markForCheck();
    }
  }

  stepDragDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.allSteps, event.previousIndex, event.currentIndex);

    var i = 1;
    this.allSteps.forEach((element) => {
      element.stepNumber = i;
      i++;
    });
    this.markAsChanged();
  }

  // remove(index) {
  //   this.inames.splice(index, 1);
  //   localStorage.setItem("ItemsRequired", JSON.stringify(this.inames));
  // }

  remove(index, item) {
    const indexToDelete = this.inames.indexOf(item);
    if (indexToDelete > -1) {
      this.inames.splice(indexToDelete, 1);
      localStorage.setItem("ItemsRequired", JSON.stringify(this.inames));
      this.groupDataByGroupName();
      this.markAsChanged();
      this.cdr.detectChanges();
    }
  }
  removeSupportingDocument(index) {
    this.supportingDocumentDocuments.splice(index, 1);
    localStorage.setItem(
      "SupportingDocumentDocuments",
      JSON.stringify(this.supportingDocumentDocuments)
    );
    this._documentCount = this.supportingDocumentDocuments.length;
    this.markAsChanged();
    setTimeout(() => {
      this.cdr.markForCheck();
    }, 0);
  }

  removeSupportingDocumentHyperLink(index) {
    this.supportingDocumentHyperLinks.splice(index, 1);
    localStorage.setItem(
      "SupportingDocumentHyperLinksRequired",
      JSON.stringify(this.supportingDocumentHyperLinks)
    );
    this._hyperlinkCount = this.supportingDocumentHyperLinks.length;
    this.markAsChanged();
    setTimeout(() => {
      this.cdr.markForCheck();
    }, 0);
  }

  items() {
    this.setActiveJourneyTab("items");
    this.showMessage = false;
  }

  editItem(i, item) {
    console.log(this.inames);
    const index = this.getGlobalIndex(item);
    console.log(index);
    localStorage.setItem("EditItemsRequired", index.toString());

    // Populate form fields for editing
    this.itemGroupName = item.groupName || "";
    this.itemName = item.itemkey || "";
    this.itemQuantity = item.itemValue || "";
    this.itemImageUrl = item.url || "";
    this.itemWhereToFindIt = item.wheretofindit || "";
    if (this.itemImageUrl) {
      this.showItemImage = true;
      this.showItemVideo = false;
    }

    // Optionally open dialog or just edit inline
    // const dialogRef = this.dialog.open(EditItemComponent, {
    //   width: "90vw",
    //   maxWidth: "1200px",
    //   maxHeight: "95vh",
    //   panelClass: "edit-item-dialog",
    //   disableClose: false,
    // });

    // dialogRef.afterClosed().subscribe((result) => {
    //   // Refresh items data after dialog closes
    //   this.refreshItemsData();
    // });
  }

  // Efficiently get the index using flatMap
  getGlobalIndex(item: any): number {
    return this.inames.findIndex(
      (i) =>
        i.itemkey === item.itemkey &&
        i.itemValue === item.itemValue &&
        i.wheretofindit === item.wheretofindit
    );
  }
  // Efficiently get the index using flatMap
  getGlobalIndexForFaq(item: any): number {
    return this._allFaqs.findIndex((i) => i.rowKey === item.rowKey);
  }

  openDialog(AccessType) {
    const dialogRef = this.dialog.open(PublishDialogComponent, {
      width: "420px",
      data: { accessType: this.accessType },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.accessType = result;
    });
  }

  private loadSavedAdvancedAccessFromServer(): void {
    const flowId = this.rowKey || this.flowId || this.flowData?.rowKey || this.flowData?.RowKey;
    if (!flowId) {
      return;
    }

    this.flowServiceService.getAccessControl(String(flowId)).subscribe(
      (accessControl) => {
        if (accessControl) {
          this.applySavedAccessFromSource(accessControl);
        }
      },
      () => {
        /* keep locally hydrated access values */
      }
    );
  }

  private buildViewerFeaturesPayload(): any {
    return {
      ShowShare: !!this.viewerFeatures.showShare,
      ShowComments: !!this.viewerFeatures.showComments,
      ShowLike: !!this.viewerFeatures.showLike,
      ShowReview: !!this.viewerFeatures.showReview,
      ShowSave: !!this.viewerFeatures.showSave,
      ShowQr: !!this.viewerFeatures.showQr,
      ShowReport: !!this.viewerFeatures.showReport,
      ShowFollow: !!this.viewerFeatures.showFollow,
      ShowSchedule: !!this.viewerFeatures.showSchedule,
      ShowConsult: !!this.viewerFeatures.showConsult,
      ShowChatbot: !!this.viewerFeatures.showChatbot,
      ShowCopyLinks: !!this.viewerFeatures.showCopyLinks,
      ShowTransfer: !!this.viewerFeatures.showTransfer,
      ShowQuestions: !!this.viewerFeatures.showQuestions,
      ShowImprovementFeedback: !!this.viewerFeatures.showImprovementFeedback,
      FeedbackWindowStartUtc: this.feedbackWindowStart
        ? new Date(this.feedbackWindowStart).toISOString()
        : null,
      FeedbackWindowEndUtc: this.feedbackWindowEnd
        ? new Date(this.feedbackWindowEnd).toISOString()
        : null,
      AllowDownload: !!this.viewerFeatures.allowDownload,
      AllowPrint: !!this.viewerFeatures.allowPrint,
      AllowEmbed: !!this.viewerFeatures.allowEmbed,
    };
  }

  /** First source that carries the field wins, so unsaved edits in local storage beat the server copy. */
  private applyEndQuestionFormFromSource(src: any): void {
    if (!src || this.endQuestionFormLoaded) return;
    if (!("endQuestionForm" in src) && !("EndQuestionForm" in src)) return;
    this.endQuestionForm = parseGuideQuestionForm(src.endQuestionForm ?? src.EndQuestionForm);
    this.endQuestionFormLoaded = true;
  }

  onStepQuestionFormChange(form: GuideQuestionForm | null): void {
    this.stepQuestionForm = form;
  }

  onEndQuestionFormChange(form: GuideQuestionForm | null): void {
    this.endQuestionForm = form;
    this.endQuestionFormLoaded = true;
    this.autoSaveCoverPageData();
  }

  stepQuestionCount(step: any): number {
    return guideQuestionCount(step?.questionForm ?? step?.QuestionForm);
  }

  get endQuestionCount(): number {
    return guideQuestionCount(this.endQuestionForm);
  }

  private endQuestionFormBlocksSave(): boolean {
    const errors = guideQuestionFormErrors(this.endQuestionForm);
    if (!errors.length) return false;
    this.toastr.warning(errors[0], "End-of-guide questions");
    return true;
  }

  private questionFormSignature(raw: any): string {
    return JSON.stringify(cleanGuideQuestionForm(parseGuideQuestionForm(raw)));
  }

  private applyViewerFeaturesFromSource(src: any): void {
    if (!src) {
      return;
    }
    const vf = src.viewerFeatures || src.ViewerFeatures || null;
    if (!vf) {
      return;
    }
    const read = (camel: string, pascal: string) =>
      vf[camel] !== false && vf[pascal] !== false;
    const readBool = (camel: string, pascal: string, fallback: boolean) => {
      if (vf[camel] === true || vf[pascal] === true) return true;
      if (vf[camel] === false || vf[pascal] === false) return false;
      return fallback;
    };

    this.viewerFeatures = {
      showShare: read('showShare', 'ShowShare'),
      showComments: read('showComments', 'ShowComments'),
      showLike: read('showLike', 'ShowLike'),
      showReview: read('showReview', 'ShowReview'),
      showSave: read('showSave', 'ShowSave'),
      showQr: read('showQr', 'ShowQr'),
      showReport: read('showReport', 'ShowReport'),
      showFollow: read('showFollow', 'ShowFollow'),
      showSchedule: read('showSchedule', 'ShowSchedule'),
      showConsult: read('showConsult', 'ShowConsult'),
      showChatbot: read('showChatbot', 'ShowChatbot'),
      showCopyLinks: read('showCopyLinks', 'ShowCopyLinks'),
      showTransfer: read('showTransfer', 'ShowTransfer'),
      showQuestions: read('showQuestions', 'ShowQuestions'),
      showImprovementFeedback: read('showImprovementFeedback', 'ShowImprovementFeedback'),
      allowDownload: readBool('allowDownload', 'AllowDownload', false),
      allowPrint: readBool('allowPrint', 'AllowPrint', false),
      allowEmbed: readBool('allowEmbed', 'AllowEmbed', false),
    };

    const start = vf.feedbackWindowStartUtc || vf.FeedbackWindowStartUtc;
    const end = vf.feedbackWindowEndUtc || vf.FeedbackWindowEndUtc;
    this.feedbackWindowStart = start ? new Date(start).toISOString().slice(0, 16) : '';
    this.feedbackWindowEnd = end ? new Date(end).toISOString().slice(0, 16) : '';
  }

  private applySavedAccessFromSource(src: any): void {
    if (!src) {
      return;
    }
    this.accessType = src.accessType || src.AccessType || this.accessType || "";
    this.restrictedAccessType =
      src.restrictedAccessType || src.RestrictedAccessType || this.restrictedAccessType || "";
    this.isSearchHidden = src.isSearchHidden ?? src.IsSearchHidden ?? this.isSearchHidden;
    const nextFlows = src.restrictedAccessFlows || src.RestrictedAccessFlows;
    if (Array.isArray(nextFlows) && nextFlows.length > 0) {
      this.savedAccessFlows = nextFlows;
    } else if (Array.isArray(nextFlows) && !this.savedAccessFlows?.length) {
      this.savedAccessFlows = nextFlows;
    }
    this.syncJourneyAccessChoiceFromFields();

    const existing = this.savedAccessAdvanced || {};
    const srcCidrs = src.allowedCidrs || src.AllowedCidrs || "";
    const srcEmailDomains = src.allowedEmailDomains || src.AllowedEmailDomains || "";
    const srcDeviceIds = src.allowedDeviceIds || src.AllowedDeviceIds || "";
    const srcGeo = src.geoFenceJson || src.GeoFenceJson || null;
    const enforceNetwork = !!(src.enforceNetwork ?? src.EnforceNetwork);
    const enforceGeo = !!(src.enforceGeo ?? src.EnforceGeo);
    const enforceDevice = !!(src.enforceDevice ?? src.EnforceDevice);
    const enforceCompanyEmail = !!(src.enforceCompanyEmail ?? src.EnforceCompanyEmail);
    const srcHasFlags =
      enforceNetwork || enforceGeo || enforceDevice || enforceCompanyEmail;
    const srcHasValues = !!(srcCidrs || srcEmailDomains || srcDeviceIds || srcGeo);

    if (!srcHasFlags && !srcHasValues && existing && Object.keys(existing).length) {
      this.syncJourneyAccessChoiceFromFields();
      return;
    }

    this.savedAccessAdvanced = {
      EnforceNetwork: enforceNetwork,
      enforceNetwork,
      EnforceGeo: enforceGeo,
      enforceGeo,
      EnforceDevice: enforceDevice,
      enforceDevice,
      EnforceCompanyEmail: enforceCompanyEmail,
      enforceCompanyEmail,
      AllowedCidrs: srcCidrs || existing.allowedCidrs || existing.AllowedCidrs || "",
      allowedCidrs: srcCidrs || existing.allowedCidrs || existing.AllowedCidrs || "",
      AllowedEmailDomains:
        srcEmailDomains || existing.allowedEmailDomains || existing.AllowedEmailDomains || "",
      allowedEmailDomains:
        srcEmailDomains || existing.allowedEmailDomains || existing.AllowedEmailDomains || "",
      AllowedDeviceIds:
        srcDeviceIds || existing.allowedDeviceIds || existing.AllowedDeviceIds || "",
      allowedDeviceIds:
        srcDeviceIds || existing.allowedDeviceIds || existing.AllowedDeviceIds || "",
      GeoFenceJson: srcGeo || existing.geoFenceJson || existing.GeoFenceJson || null,
      geoFenceJson: srcGeo || existing.geoFenceJson || existing.GeoFenceJson || null,
    };
    this.syncJourneyAccessChoiceFromFields();
    this.initializeRestrictedAccessDraftFromLoadedState();
    this.captureInitialAccessSnapshotIfNeeded();
  }

  private initializeRestrictedAccessDraftFromLoadedState(): void {
    const draft = buildDraftFromParentState({
      restrictedAccessType: this.restrictedAccessType,
      isSearchHidden: this.isSearchHidden,
      savedAccessFlows: this.savedAccessFlows,
      savedAccessAdvanced: this.savedAccessAdvanced,
    });
    if (hasRestrictedDraftContent(draft)) {
      this.restrictedAccessDraft = draft;
    }
  }

  private applyRestrictedDraftSnapshot(snapshot: RestrictedAccessDraft): void {
    const draft = cloneRestrictedAccessDraft(snapshot);
    this.restrictedAccessType = draft.restrictedAccessType;
    this.isSearchHidden = draft.isSearchHidden;
    this.savedAccessFlows = draft.savedAccessFlows;
    this.savedAccessAdvanced = draft.savedAccessAdvanced;
  }

  private captureRestrictedAccessDraft(): void {
    if (this.journeyAccessChoice === "Restricted") {
      this.syncRestrictedPanelIntoState({ silent: true });
    }
    this.restrictedAccessDraft = buildDraftFromParentState({
      restrictedAccessType: this.restrictedAccessType,
      isSearchHidden: this.isSearchHidden,
      savedAccessFlows: this.savedAccessFlows,
      savedAccessAdvanced: this.savedAccessAdvanced,
    });
  }

  private restoreRestrictedAccessDraft(): void {
    if (!this.restrictedAccessDraft) {
      return;
    }
    this.applyRestrictedDraftSnapshot(this.restrictedAccessDraft);
  }

  private isEditingExistingFlow(): boolean {
    return !!(this.edit || this.hasFlowRowKey());
  }

  /** True when RowKey is set (tick or undotted UniqueId). Avoid numeric comparisons. */
  private hasFlowRowKey(rowKey: any = this.rowKey): boolean {
    if (rowKey === null || rowKey === undefined) {
      return false;
    }
    const value = `${rowKey}`.trim();
    return value !== "" && value !== "0";
  }

  private captureInitialAccessSnapshotIfNeeded(): void {
    if (!this.isEditingExistingFlow() || this.initialAccessSnapshotLocked) {
      return;
    }
    const next = buildInitialAccessSnapshot({
      choice: this.journeyAccessChoice,
      label: this.getCurrentAccessLabel() || "Public",
      description: this.getJourneyAccessSummaryDescription(),
      savedAccessFlows: this.savedAccessFlows,
      savedAccessAdvanced: this.savedAccessAdvanced,
    });
    if (shouldEnrichInitialAccessSnapshot(this.initialAccessSnapshot, next)) {
      this.initialAccessSnapshot = next;
    }
  }

  private lockInitialAccessSnapshot(): void {
    if (!this.initialAccessSnapshot && this.isEditingExistingFlow()) {
      this.captureInitialAccessSnapshotIfNeeded();
    }
    this.initialAccessSnapshotLocked = true;
  }

  hasInitialAccessSnapshot(): boolean {
    return !!this.initialAccessSnapshot && this.isEditingExistingFlow();
  }

  getInitialAccessLabel(): string {
    return this.initialAccessSnapshot?.label || "";
  }

  getInitialAccessDescription(): string {
    return this.initialAccessSnapshot?.description || "";
  }

  getInitialAccessUserCount(): number {
    return this.initialAccessSnapshot?.userCount || 0;
  }

  getInitialAccessAdvancedLabels(): string[] {
    return this.initialAccessSnapshot?.advancedLabels || [];
  }

  isInitialAccessRestricted(): boolean {
    return this.initialAccessSnapshot?.choice === "Restricted";
  }

  restoreInitialAccessToCurrentSelection(): void {
    const snap = this.initialAccessSnapshot;
    if (!snap) {
      return;
    }
    const choice = snap.choice as JourneyAccessChoice;
    if (choice === "Restricted") {
      this.accessType = "Restricted";
      this.restrictedAccessType = "";
      this.isSearchHidden = false;
      this.savedAccessFlows = [];
      this.savedAccessAdvanced = {};
      this.restrictedAccessDraft = null;
      this.journeyAccessChoice = "Restricted";
      this.setActiveJourneyTab("access");
    } else if (choice === "PrivateToMe") {
      this.setJourneyAccessChoice("PrivateToMe");
    } else if (choice === "LinkAccess") {
      this.setJourneyAccessChoice("LinkAccess");
    } else {
      this.setJourneyAccessChoice("Public");
    }
  }

  private syncJourneyAccessChoiceFromFields(): void {
    const accessType = String(this.accessType || "").toLowerCase();
    const restrictedType = String(this.restrictedAccessType || "").toLowerCase();
    const users = this.savedAccessFlows || [];
    const adv = this.savedAccessAdvanced || {};
    const hasAdvanced = !!(
      adv.EnforceNetwork ||
      adv.enforceNetwork ||
      adv.EnforceGeo ||
      adv.enforceGeo ||
      adv.EnforceDevice ||
      adv.enforceDevice ||
      adv.EnforceCompanyEmail ||
      adv.enforceCompanyEmail
    );

    if (accessType === "public" || !accessType) {
      this.journeyAccessChoice = "Public";
      return;
    }
    if (accessType === "private") {
      this.journeyAccessChoice = "PrivateToMe";
      return;
    }
    if (
      accessType === "restricted" &&
      restrictedType === "linkaccess" &&
      !users.length &&
      !hasAdvanced
    ) {
      this.journeyAccessChoice = "LinkAccess";
      return;
    }
    if (accessType === "restricted" || users.length || hasAdvanced) {
      this.journeyAccessChoice = "Restricted";
      return;
    }
    this.journeyAccessChoice = "Public";
  }

  isJourneyAccessChoiceSelected(choice: JourneyAccessChoice): boolean {
    return this.journeyAccessChoice === choice;
  }

  setJourneyAccessChoice(choice: JourneyAccessChoice): void {
    if (this.isCollaboration && choice !== "Public") {
      this.toastr.warning("Only Public access is available for collaboration flows.");
      this.journeyAccessChoice = "Public";
      this.accessType = "Public";
      this.restrictedAccessType = "";
      this.isSearchHidden = false;
      this.savedAccessFlows = [];
      this.savedAccessAdvanced = {};
      this.restrictedAccessDraft = null;
      return;
    }

    if (this.blocksCreatorNonPublicAccess(choice)) {
      return;
    }

    if (this.journeyAccessChoice === "Restricted" && choice !== "Restricted") {
      this.captureRestrictedAccessDraft();
    }
    if (this.journeyAccessChoice !== choice) {
      this.lockInitialAccessSnapshot();
    }

    this.journeyAccessChoice = choice;
    if (choice === "Public") {
      this.accessType = "Public";
      this.restrictedAccessType = "";
      this.isSearchHidden = false;
      return;
    }
    if (choice === "PrivateToMe") {
      this.accessType = "Private";
      this.restrictedAccessType = "";
      this.isSearchHidden = true;
      return;
    }
    if (choice === "LinkAccess") {
      this.accessType = "Restricted";
      this.restrictedAccessType = "LinkAccess";
      this.isSearchHidden = true;
      return;
    }
    // Restricted — restore session draft and stage model for embedded panel
    this.accessType = "Restricted";
    this.restoreRestrictedAccessDraft();
    this.stageAccessFlowModelForPanel();
  }

  /** Persisted on flow.Type: selected category, or "Flow" when none chosen. */
  private resolveFlowType(): string {
    const category = (this.CategoryName || "").trim();
    return category || "Flow";
  }

  /** Only treat known subject categories as CategoryName (not "Flow"/"Bundle"). */
  private resolveCategoryName(
    storedType: string | null | undefined,
    selectedFromPicker: string | null | undefined
  ): string | null {
    const fromStored = (storedType || "").trim();
    if (fromStored && this.flowCategories.includes(fromStored)) {
      return fromStored;
    }
    const fromPicker = (selectedFromPicker || "").trim();
    if (fromPicker && this.flowCategories.includes(fromPicker)) {
      return fromPicker;
    }
    return null;
  }

  onCategoryChanged(): void {
    localStorage.setItem("selectedCategoryName", this.CategoryName || "");
    localStorage.setItem("categoryName", this.CategoryName || "");
    this.autoSaveCoverPageData();
    this.markAsChanged();
  }

  private applyCategoryFromFlowData(flowData: any): void {
    const resolved = this.resolveCategoryName(
      flowData?.type || flowData?.Type,
      null
    );
    if (resolved) {
      this.CategoryName = resolved;
    }
    if (this.edit && this._initialFlowState) {
      try {
        const snap = JSON.parse(this._initialFlowState);
        snap.categoryName = this.CategoryName || "";
        this._initialFlowState = JSON.stringify(snap);
        this.hasUnsavedChanges =
          this._buildStateSnapshot() !== this._initialFlowState;
      } catch {
        /* ignore */
      }
    }
  }

  private stageAccessFlowModelForPanel(): void {
    const model: any = {
      Type: this.resolveFlowType(),
      type: this.resolveFlowType(),
      accessType: this.accessType || "Restricted",
      AccessType: this.accessType || "Restricted",
      restrictedAccessType: this.restrictedAccessType || "",
      RestrictedAccessType: this.restrictedAccessType || "",
      isSearchHidden: this.isSearchHidden,
      IsSearchHidden: this.isSearchHidden,
      restrictedAccessFlows: this.savedAccessFlows || [],
      RestrictedAccessFlows: this.savedAccessFlows || [],
      ...(this.savedAccessAdvanced || {}),
      rowKey: this.rowKey || undefined,
      RowKey: this.rowKey || undefined,
      UniqueId: this.uniqueId || "",
      Title: this.title || "",
    };
    localStorage.setItem("flowModel", JSON.stringify(model));
  }

  onEmbeddedAccessConfigured(result: any): void {
    if (!result) {
      return;
    }
    this.lockInitialAccessSnapshot();
    this.accessType = result.accessType || result.AccessType || "Restricted";
    this.restrictedAccessType =
      result.restrictedAccessType || result.RestrictedAccessType || "";
    this.isSearchHidden =
      result.isSearchHidden ?? result.IsSearchHidden ?? false;
    const flows =
      result.restrictedAccessFlows || result.RestrictedAccessFlows;
    if (flows) {
      this.savedAccessFlows = flows;
    }
    this.savedAccessAdvanced = {
      EnforceNetwork: result.enforceNetwork ?? result.EnforceNetwork ?? false,
      EnforceGeo: result.enforceGeo ?? result.EnforceGeo ?? false,
      EnforceDevice: result.enforceDevice ?? result.EnforceDevice ?? false,
      EnforceCompanyEmail:
        result.enforceCompanyEmail ?? result.EnforceCompanyEmail ?? false,
      AllowedCidrs: result.allowedCidrs ?? result.AllowedCidrs ?? "",
      GeoFenceJson: result.geoFenceJson ?? result.GeoFenceJson ?? null,
      AllowedDeviceIds:
        result.allowedDeviceIds ?? result.AllowedDeviceIds ?? "",
      AllowedEmailDomains:
        result.allowedEmailDomains ?? result.AllowedEmailDomains ?? "",
    };
    this.journeyAccessChoice = "Restricted";
  }

  private syncRestrictedPanelIntoState(options?: { silent?: boolean }): boolean {
    if (this.journeyAccessChoice !== "Restricted") {
      return true;
    }
    const panel = this.restrictedAccessPanel;
    if (!panel) {
      if (options?.silent) {
        return true;
      }
      const hasUsers = (this.savedAccessFlows || []).length > 0;
      const adv = this.savedAccessAdvanced || {};
      const hasAdvanced = !!(
        adv.EnforceNetwork ||
        adv.EnforceGeo ||
        adv.EnforceDevice ||
        adv.EnforceCompanyEmail
      );
      if (!hasUsers && !hasAdvanced) {
        this.toastr.warning(
          "Add users or advanced access rules for Restricted access."
        );
        return false;
      }
      return true;
    }
    if (options?.silent) {
      this.applyRestrictedDraftSnapshot(panel.captureDraftSnapshot());
      return true;
    }
    const result = panel.buildConfigureResult();
    if (!result) {
      this.toastr.warning(
        "Add users or advanced access rules for Restricted access."
      );
      return false;
    }
    this.onEmbeddedAccessConfigured(result);
    return true;
  }

  /** Publish using Access-tab selection (no access menu). */
  publishWithSelectedAccess(): void {
    if (this.isCollaboration) {
      this.saveFlowToServerAccessLevel("Public");
      return;
    }
    if (!this.syncRestrictedPanelIntoState()) {
      return;
    }
    if (this.journeyAccessChoice === "Public") {
      this.saveFlowToServerAccessLevel("Public");
      return;
    }
    if (this.journeyAccessChoice === "PrivateToMe") {
      this.saveFlowToServerAccessLevel("Private");
      return;
    }
    // LinkAccess or Restricted
    this.saveFlowToServerAccessLevel("Restricted");
  }

  getCurrentAccessLabel(): string {
    if (this.journeyAccessChoice === "Public") {
      return "Public";
    }
    if (this.journeyAccessChoice === "PrivateToMe") {
      return "Private to you";
    }
    if (this.journeyAccessChoice === "LinkAccess") {
      return "Anyone with the link";
    }

    const accessType = String(this.accessType || "").toLowerCase();
    const restrictedType = String(this.restrictedAccessType || "");
    const users = this.savedAccessFlows || [];
    const adv = this.savedAccessAdvanced || {};
    const hasAdvanced = !!(
      adv.EnforceNetwork ||
      adv.EnforceGeo ||
      adv.EnforceDevice ||
      adv.EnforceCompanyEmail
    );

    if (accessType === "private") {
      return "Private to you";
    }
    if (accessType === "public") {
      return "Public";
    }
    if (accessType === "restricted" || this.journeyAccessChoice === "Restricted") {
      if (
        hasAdvanced ||
        users.length > 0 ||
        restrictedType === "SelectedUsers" ||
        restrictedType.toLowerCase() !== "linkaccess"
      ) {
        const bits: string[] = [];
        if (users.length > 0) {
          bits.push(users.length === 1 ? "1 user" : `${users.length} users`);
        }
        if (adv.EnforceNetwork) bits.push("network");
        if (adv.EnforceGeo) bits.push("location");
        if (adv.EnforceDevice) bits.push("devices");
        if (adv.EnforceCompanyEmail) bits.push("email");
        return bits.length ? `Restricted · ${bits.join(", ")}` : "Restricted";
      }
      return "Anyone with the link";
    }
    return this.accessType || "Public";
  }

  getJourneyAccessSummaryIcon(): string {
    switch (this.journeyAccessChoice) {
      case "PrivateToMe":
        return "lock";
      case "LinkAccess":
        return "link";
      case "Restricted":
        return "security";
      default:
        return "public";
    }
  }

  getJourneyAccessSummaryDescription(): string {
    switch (this.journeyAccessChoice) {
      case "PrivateToMe":
        return "Only you can open this guide.";
      case "LinkAccess":
        return "People with the link can open it. Hidden from search.";
      case "Restricted":
        return "Access is limited to selected people and rules.";
      default:
        return "Anyone can find and open this guide.";
    }
  }

  hasSavedAccessAdvanced(): boolean {
    const adv = this.savedAccessAdvanced || {};
    return !!(
      adv.EnforceNetwork ||
      adv.EnforceGeo ||
      adv.EnforceDevice ||
      adv.EnforceCompanyEmail
    );
  }

  restrictedAccessPage(accessType) {
    if (this.hasPendingCollabRequest()) {
      this.toastr.warning(
        'This guide has a pending collaboration request. ' +
        'Publishing is blocked until the co-author accepts or denies the invite.',
        'Collaboration Pending',
        { timeOut: 5000 }
      );
      return;
    }

    // Validate required properties before creating flowModel
    if (!this.userData || !this.userData.emailAddress) {
      this.toastr.error("User data is missing. Please sign in again.");
      return;
    }

    if (!this.title || !this.description || !this.coverImageUri) {
      this.toastr.warning(
        "Please ensure title, description, and cover image are provided."
      );
      return;
    }

    if (this.endQuestionFormBlocksSave()) return;

    // Collab flows cannot be paid, restrict access, or allow consultations
    const isCollab = this.isCollaboration && this.collabInvitees.length > 0;

    var flowModel: any = {
      PartitionKey: this.partitionKey || this.userData.emailAddress,
      UniqueId: this.uniqueId || "",
      UserName: this.uname || this.userData.userName || "",
      Description: this.description || "",
      CustomerEmail: this.userData.emailAddress,
      Title: this.title || "",
      AccessType: isCollab ? "Public" : (this.accessType || ""),
      accessType: isCollab ? "Public" : (this.accessType || ""),
      RestrictedAccessType: isCollab ? null : (this.restrictedAccessType || ""),
      restrictedAccessType: isCollab ? null : (this.restrictedAccessType || ""),
      IsSearchHidden: this.isSearchHidden,
      restrictedAccessFlows: this.savedAccessFlows || [],
      RestrictedAccessFlows: this.savedAccessFlows || [],
      ...(!isCollab ? this.savedAccessAdvanced : {}),
      Url: this.coverImageUri || "",
      VideoThumbNailUrl: this.coverPosterPageURI || "",
      Type: this.resolveFlowType(),
      FlowStatus: "Approved",
      Duration: this.duration || 0,
      DurationUnit: this.durationUnit || 'Mins',
      Steps: this.allSteps || [],
      Components: this.inames || [],
      Price: isCollab ? 0 : (this.price || 0),
      IsPaid: isCollab ? false : (this.isPaid || false),
      IsConsulatationAvailable: isCollab ? false : (this.isSCenabled || false),
      IsSponsored: this.isSponsored || false,
      ViewerFeatures: this.buildViewerFeaturesPayload(),
      EndQuestionForm: cleanGuideQuestionForm(this.endQuestionForm),
      IsCollaboration: isCollab,
      CoAuthorEmail: isCollab ? (this.collabInvitees[0]?.email ?? null) : null,
      CoAuthorUserName: isCollab ? (this.collabInvitees[0]?.userName ?? null) : null,
      CoAuthorProfilePicUrl: isCollab ? (this.collabInvitees[0]?.profilePicUrl ?? null) : null,
      CoAuthorEmails: isCollab ? JSON.stringify(this.collabInvitees.map(i => i.email)) : null,
      CoAuthorUserNames: isCollab ? JSON.stringify(this.collabInvitees.map(i => i.userName || i.email)) : null,
      CoAuthorProfilePicUrls: isCollab ? JSON.stringify(this.collabInvitees.map(i => i.profilePicUrl || '')) : null,
      CoAuthorStatuses: isCollab ? JSON.stringify(this.collabInvitees.map(i => i.status || 'Pending')) : null,
      CollaborationValue: isCollab ? (this.collabValue || 0) : null,
      CollaborationStatus: isCollab ? (this.collabInvitees[0]?.status || 'Pending') : null,
      FlowSupportingDocumentsHyperLinkModels:
        this.supportingDocumentHyperLinks || [],
      FlowSupportingDocumentsDocumentModels:
        this.supportingDocumentDocuments || [],
    };

    // Only include identity when RowKey is set (tick or undotted UniqueId)
    if (this.hasFlowRowKey()) {
      flowModel.rowKey = this.rowKey.toString();
      flowModel.partitionKey = this.partitionKey;
      flowModel.UniqueId = this.uniqueId;
    }

    console.log("Validated flowModel:", flowModel);

    localStorage.setItem("flowModel", JSON.stringify(flowModel));
    const dialogRef = this.dialog.open(EnhancedRestrictedAccessComponent, {
      panelClass: "dialoguebox",
      data: { mode: "publish" },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.router.navigate(["/user-profile"]);
      }
    });
  }

  saveRestrictedFlowToMakeTranferRequest(AccessType) {
    if (this.allSteps.length <= 0) {
      this.showMessage = true;
      this.toastr.warning(
        "Please add the cover page and steps to publish the flow."
      );
    } else if (!this.validateTransferRequest()) {
      // Validation failed, don't proceed with publishing
      return;
    } else {
      this.noResultReturned = true;
      console.log(this.selectedTransferUser);

      // Validate required properties before creating flowModel
      if (!this.userData || !this.userData.emailAddress) {
        this.toastr.error("User data is missing. Please sign in again.");
        this.noResultReturned = false;
        return;
      }

      if (!this.title || !this.description || !this.coverImageUri) {
        this.showMessage = true;
        this.toastr.warning(
          "Please ensure title, description, and cover image are provided."
        );
        this.noResultReturned = false;
        return;
      }
      // If cover is a video, ensure a thumbnail image is provided before saving transfer request
      if (this.showCoverVideo && !this.coverPosterPageURI) {
        this.showMessage = true;
        this.toastr.warning(
          "Please upload a thumbnail image for your video cover before publishing."
        );
        this.noResultReturned = false;
        return;
      }
      // If cover is a video, ensure a thumbnail image is provided before publishing
      if (this.showCoverVideo && !this.coverPosterPageURI) {
        this.showMessage = true;
        this.toastr.warning(
          "Please upload a thumbnail image for your video cover before publishing."
        );
        this.noResultReturned = false;
        return;
      }

      var flowModel: any = {
        PartitionKey: this.partitionKey || this.userData.emailAddress,
        UniqueId: this.uniqueId || "",
        UserName: this.uname || this.userData.userName || "",
        Description: this.description || "",
        CustomerEmail: this.userData.emailAddress,
        Title: this.title || "",
        AccessType: AccessType || "Public",
        Url: this.coverImageUri || "",
        VideoThumbNailUrl: this.coverPosterPageURI || "",
        Type: this.resolveFlowType(),
        restrictedAccessFlows: this.getUser(this.selectedTransferUser),
        FlowStatus: "Approved",
        Duration: this.duration || 0,
        DurationUnit: this.durationUnit || 'Mins',
        Steps: this.allSteps || [],
        Components: this.inames || [],
        Price: this.price || 0,
        IsPaid: this.isPaid || false,
        EndQuestionForm: cleanGuideQuestionForm(this.endQuestionForm),
        FlowSupportingDocumentsHyperLinkModels:
          this.supportingDocumentHyperLinks || [],
        FlowSupportingDocumentsDocumentModels:
          this.supportingDocumentDocuments || [],
        IsConsulatationAvailable: this.userData.enableConsultation || false,
        SearchKeyWords: Array.isArray(this.searchKeyWords)
          ? this.searchKeyWords.join(", ")
          : this.searchKeyWords ?? "",
      };

      // Only include identity when RowKey is set (tick or undotted UniqueId)
      if (this.hasFlowRowKey()) {
        flowModel.rowKey = this.rowKey.toString();
        flowModel.UniqueId = this.uniqueId;
        flowModel.partitionKey = this.partitionKey;
      }

      console.log("Validated flowModel:", flowModel);

      this.showMessage = false;

      if (this.userData) {
        this.isUploading = true;
        this.isLoading = true;
        this.progress = 0;
        this.openLoadingModal("Publishing flow with transfer request...", true);
        this.flowServiceService
          .publishUserFlow(flowModel, this.userData.emailAddress)
          .subscribe({
            next: (event: HttpEvent<any>) => {
              switch (event.type) {
                case HttpEventType.Sent:
                  console.log("Request sent to server.");
                  this.updateLoadingModal(
                    "Publishing flow with transfer request...",
                    0
                  );
                  break;

                case HttpEventType.UploadProgress:
                  this.progress = Math.round(
                    (95 * event.loaded) / (event.total || 1)
                  );
                  console.log(`Progress: ${this.progress}%`);
                  this.updateLoadingModal(
                    "Publishing flow with transfer request...",
                    this.progress
                  );
                  break;

                case HttpEventType.Response:
                  console.log("Upload complete:", event.body);
                  localStorage.setItem("draftTabIndex", "0");
                  this.applySavedFlowIdentity(event.body);
                  this.cdr.detectChanges();
                  this.updateLoadingModal("Flow published successfully!", 100);
                  const publishedTitle =
                    event.body?.title || event.body?.Title || this.title;
                  const publishedFlowId =
                    event.body?.rowKey || event.body?.RowKey || this.rowKey;
                  setTimeout(() => {
                    this.progress = 100;
                    console.log("set is loading");
                    this.noResultReturned = false;
                    this.isLoading = false;
                    this.closeLoadingModal();
                    this.toastr.success("Flow successfully published");
                    this.resetProgress();
                    if (
                      this.enableTransferAfterPublish &&
                      this.selectedTransferUser &&
                      event.body
                    ) {
                      this.handleTransferRequestAfterPublish(
                        event.body,
                        "Flow"
                      );
                      console.log(event.body);
                    }
                    this.navigateToPublishedFlowView(
                      publishedFlowId,
                      publishedTitle
                    );
                  }, 1500);

                  break;

                default:
                  console.log("Unhandled event:", event);
              }
            },
            error: (err) => {
              this.noResultReturned = false;
              this.isLoading = false;
              this.closeLoadingModal();
              if (isTrialLimitError(err)) {
                handleTrialLimitError(this.dialog, this.toastr, err, this.router.url);
                this.resetProgress();
                return;
              }
              if (isMaxPublishedFlowsError(err)) {
                handleMaxPublishedFlowsError(this.router, this.toastr, err, this.router.url);
                this.resetProgress();
                return;
              }
              if (isFlowBundlePermissionError(err)) {
                handleFlowBundlePermissionError(this.toastr, err);
                this.resetProgress();
                return;
              }
              if (isCreatorPublicOnlyError(err)) {
                handleCreatorPublicOnlyError(this.dialog, this.router.url, err);
                this.resetProgress();
                return;
              }
              this.toastr.error(
                this.approvalRequiredError(err) || "Failed to publish flow. Please try again."
              );
              this.resetProgress();
            },
          });
      }
    }
  }
  getUser(user: any): any {
    if (user) {
      const email = user.user?.emailAddress || user.EmailAddress;
      this.selectedUsers.push({
        emailAddress: email,
        userName: user.user?.userName || user.UserName,
        profilePicUrl: user.user?.profilePicUrl || user.ProfilePicUrl,
        firstName: user.user?.firstName || user.FirstName,
        IsAccessGiven: true,
      });
    }

    return this.selectedUsers;
  }

  createFlow() {
    this.router.navigate(["/create-guide"]);
  }

  navigateToQuickCreate() {
    localStorage.setItem("navigatebackfromcreateflow", this.location.path());
    this.router.navigate(["/create-guide/quick"]);
  }

  selectManualCreate() {
    this.showCreateTypeSelection = false;
    this.cdr.detectChanges();
  }

  checkLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    } else {
      this.router.navigate(["/create-guide"]);
    }
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    }
  }

  getProfileUser(): void {
    if (
      this.userData != null &&
      this.userData.emailAddress != null &&
      this.userData.emailAddress != ""
    ) {
      //
      this.noResultReturned = true;
      this.showNotificationCount = true;
      this.userserviceService.getProfileUser().subscribe((data) => {
        this.noResultReturned = false;
        if (
          data.userData.profilePicUrl === "" ||
          data.userData.profilePicUrl == null
        ) {
          //
          this.noResultReturned = false;
          this.showDefaultImage = true;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = data.userData.profilePicUrl;
        }
        this.email = data.userData.emailAddress;
        this.phone = data.userData.phoneNumber;
        this.info = data.userData.info;
        this.website = data.userData.website;
        this.uname = data.userData.userName;
        this.name = data.userData.firstName;
      });
    }
  }

  editStep(step, index) {
    localStorage.setItem(
      "stepToEdit",
      JSON.stringify({ stepToEdit: step, index: index })
    );

    // Populate form fields for editing
    this.stepTitle = step.title || "";
    this.stepDescription = step.Description || "";
    this.stepImageUrl = step.Url || "";
    this.stepPosterUrl = step.VideoThumbNailUrl || "";
    this.stepFileName = step.stepFileName || "";
    this.stepTaggedItems = step.taggedItems || []; // Load tagged items
    this.isSafetyCritical = step.isSafetyCritical || step.IsSafetyCritical || false; // Load safety critical flag
    this.safetyInstructionsTitle = step.safetyInstructionsTitle || step.SafetyInstructionsTitle || ""; // Load safety instructions title
    this.safetyInstructionsDescription = step.safetyInstructionsDescription || step.SafetyInstructionsDescription || ""; // Load safety instructions description
    this.stepQuestionForm = parseGuideQuestionForm(step.questionForm ?? step.QuestionForm);
    if (step.showImage) {
      this.showStepImage = true;
      this.showStepVideo = false;
    } else if (step.showVideo) {
      this.showStepVideo = true;
      this.showStepImage = false;
    }

    // Optionally open dialog or just edit inline
    // const dialogRef = this.dialog.open(StepsComponent, {
    //   width: "90vw",
    //   maxWidth: "1200px",
    //   maxHeight: "95vh",
    //   panelClass: "steps-dialog",
    //   disableClose: false,
    // });

    // dialogRef.afterClosed().subscribe((result) => {
    //   // Refresh steps data after dialog closes
    //   this.refreshStepsData();
    // });
  }

  deleteStep(step, index) {
    this.allSteps.splice(index, 1);
    localStorage.setItem(
      "stepsCoverPageDetails",
      JSON.stringify(this.allSteps)
    );

    if (this.allSteps.length <= 0) {
      this.disablePublishButton = true;
    }
    this.markAsChanged();
  }

  SignOut() {
    localStorage.setItem("LoggedInUser", null);
    this.userDisplayName = null;
  }

  saveFlowToServer(status, afterSaved?: () => void) {
    console.log(this.userData.enableConsultation);
    console.log(this.userData);

    // Validate required properties before creating flowModel
    if (!this.userData || !this.userData.emailAddress) {
      this.toastr.error("User data is missing. Please sign in again.");
      return;
    }

    // For drafts, only require title and coverImageUri. Description is optional.
    // For other statuses, require all fields
    const isDraft = status === "Submitted" || status === "Draft";

    if (isDraft && this.deferSaveForKeepLiveChoice(() => this.saveFlowToServer(status, afterSaved))) {
      return;
    }

    // Check if title exists and is not empty
    const hasTitle = this.title && this.title.trim().length > 0;

    // Check if coverImageUri exists
    const hasCoverImage =
      this.coverImageUri && this.coverImageUri.trim().length > 0;

    // For description, check if it has actual content (strip HTML tags)
    const hasDescription =
      this.description && this.stripHtml(this.description).trim().length > 0;

    if (isDraft) {
      if (!hasTitle || !hasCoverImage) {
        this.showMessage = true;
        this.toastr.warning(
          "Please add title and cover image to save the flow as a draft."
        );
        return;
      }
    } else {
      if (!hasTitle || !hasDescription || !hasCoverImage) {
        this.showMessage = true;
        this.toastr.warning(
          "Please add cover page details (title, description, and cover image) to save the flow."
        );
        return;
      }
    }

    if (this.endQuestionFormBlocksSave()) return;

    var flowModel: any = {
      PartitionKey: this.partitionKey || this.userData.emailAddress,
      UniqueId: this.uniqueId || "",
      UserName: this.uname || this.userData.userName || "",
      Description: this.description || "",
      CustomerEmail: this.userData.emailAddress,
      Title: this.title || "",
      AccessType: "Public",
      Url: this.coverImageUri || "",
      VideoThumbNailUrl: this.coverPosterPageURI || "",
      Type: this.resolveFlowType(),
      FlowStatus: status || "Draft",
      Duration: this.duration || 0,
      DurationUnit: this.durationUnit || 'Mins',
      CoverIsSafetyCritical: this.coverIsSafetyCritical || false,
      CoverSafetyInstructionsTitle: this.coverSafetyInstructionsTitle || "",
      CoverSafetyInstructionsDescription: this.coverSafetyInstructionsDescription || "",
      Steps: (this.allSteps || []).map((step: any) => ({
        Title: step.title || step.Title || "",
        Description: step.Description || step.description || "",
        Url: step.Url || "",
        VideoThumbNailUrl: step.VideoThumbNailUrl || "",
        TaggedItems: step.taggedItems || step.TaggedItems || [],
        IsSafetyCritical: step.isSafetyCritical || step.IsSafetyCritical || false,
        SafetyInstructionsTitle: step.safetyInstructionsTitle || step.SafetyInstructionsTitle || "",
        SafetyInstructionsDescription: step.safetyInstructionsDescription || step.SafetyInstructionsDescription || "",
        QuestionForm: cleanGuideQuestionForm(parseGuideQuestionForm(step.questionForm ?? step.QuestionForm)),
      })),
      Components: this.inames || [],
      Price: this.isCollaboration ? 0 : (this.price || 0),
      IsPaid: this.isCollaboration ? false : (this.isPaid || false),
      IsConsulatationAvailable: this.isCollaboration ? false : (this.userData.enableConsultation || false),
      IsSponsored: this.isSponsored || false,
      ViewerFeatures: this.buildViewerFeaturesPayload(),
      EndQuestionForm: cleanGuideQuestionForm(this.endQuestionForm),
      IsCollaboration: this.isCollaboration && this.collabInvitees.length > 0,
      CoAuthorEmail: (this.isCollaboration && this.collabInvitees.length > 0) ? (this.collabInvitees[0]?.email ?? null) : null,
      CoAuthorUserName: (this.isCollaboration && this.collabInvitees.length > 0) ? (this.collabInvitees[0]?.userName ?? null) : null,
      CoAuthorProfilePicUrl: (this.isCollaboration && this.collabInvitees.length > 0) ? (this.collabInvitees[0]?.profilePicUrl ?? null) : null,
      CoAuthorEmails: (this.isCollaboration && this.collabInvitees.length > 0) ? JSON.stringify(this.collabInvitees.map(i => i.email)) : null,
      CoAuthorUserNames: (this.isCollaboration && this.collabInvitees.length > 0) ? JSON.stringify(this.collabInvitees.map(i => i.userName || i.email)) : null,
      CoAuthorProfilePicUrls: (this.isCollaboration && this.collabInvitees.length > 0) ? JSON.stringify(this.collabInvitees.map(i => i.profilePicUrl || '')) : null,
      CoAuthorStatuses: (this.isCollaboration && this.collabInvitees.length > 0) ? JSON.stringify(this.collabInvitees.map(i => i.status || 'Pending')) : null,
      CollaborationValue: (this.isCollaboration && this.collabValue) ? this.collabValue : null,
      CollaborationStatus: (this.isCollaboration && this.collabInvitees.length > 0) ? (this.collabInvitees[0]?.status || 'Pending') : null,
      FlowSupportingDocumentsHyperLinkModels:
        this.supportingDocumentHyperLinks || [],
      FlowSupportingDocumentsDocumentModels:
        this.supportingDocumentDocuments || [],
      SearchKeyWords: Array.isArray(this.searchKeyWords)
        ? this.searchKeyWords.join(", ")
        : this.searchKeyWords ?? "",
    };

    // Only include identity when RowKey is set (tick or undotted UniqueId)
    if (this.hasFlowRowKey()) {
      flowModel.rowKey = this.rowKey.toString();
      flowModel.partitionKey = this.partitionKey;
      flowModel.UniqueId = this.uniqueId;
    }

    console.log("Validated flowModel:", flowModel);

    if (this.userData != null) {
      this.noResultReturned = true;
      this.isLoading = true;
      this.progress = 0;
      this.openLoadingModal("Saving draft...", true);

      this.flowServiceService
        .publishUserFlow(flowModel, this.userData.emailAddress)
        .subscribe({
          next: (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                console.log("Request sent to server.");
                this.updateLoadingModal("Saving draft...", 0);
                break;

              case HttpEventType.UploadProgress:
                this.progress = Math.round(
                  (95 * event.loaded) / (event.total || 1)
                );
                console.log(`Progress: ${this.progress}%`);
                this.updateLoadingModal("Saving draft...", this.progress);
                break;

              case HttpEventType.Response:
                console.log("Upload complete:", event.body);
                localStorage.setItem("draftTabIndex", "2");
                this.applySavedFlowIdentity(event.body);
                if (this.requiresOrgApproval && this.contentApprovalState === "Approved") {
                  // The server resets approval when approved content is edited.
                  this.contentApprovalState = "Draft";
                }
                this.syncEditStateAfterSave();
                this.loadApprovalInfo();
                this.cdr.detectChanges();
                this.updateLoadingModal("Draft saved successfully!", 100);
                setTimeout(() => {
                  this.progress = 100;
                  console.log("set is loading");
                  this.noResultReturned = false;
                  this.isLoading = false;
                  this.closeLoadingModal();
                  this.resetProgress();
                  if (afterSaved) {
                    this.toastr.success("Draft saved successfully.", "Draft Saved", { timeOut: 3000 });
                    afterSaved();
                  } else {
                    this.toastr.success(
                      "Draft saved successfully. You can continue editing or preview before publishing.",
                      "Draft Saved",
                      { timeOut: 4000 }
                    );
                    this.showDraftPreviewTab();
                  }
                }, 1500);

                break;

              default:
                console.log("Unhandled event:", event);
            }
          },
          error: (err) => {
            console.error("Error uploading:", err);
            this.noResultReturned = false;
            this.isLoading = false;
            this.closeLoadingModal();
            if (isTrialLimitError(err)) {
              handleTrialLimitError(this.dialog, this.toastr, err, this.router.url);
              this.resetProgress();
              return;
            }
            if (isMaxPublishedFlowsError(err)) {
              handleMaxPublishedFlowsError(this.router, this.toastr, err, this.router.url);
              this.resetProgress();
              return;
            }
            if (isFlowBundlePermissionError(err)) {
              handleFlowBundlePermissionError(this.toastr, err);
              this.resetProgress();
              return;
            }
            if (isCreatorPublicOnlyError(err)) {
              handleCreatorPublicOnlyError(this.dialog, this.router.url, err);
              this.resetProgress();
              return;
            }
            this.toastr.error("Failed to save flow. Please try again.");
            this.resetProgress();
          },
        });
    }
    return flowModel;
  }

  /** Returns true when ANY pending invite should block publishing. */
  private hasPendingCollabRequest(): boolean {
    return this.isCollaboration && this.collabInvitees.some(
      i => i.status === 'Pending' || i.status === 'pending'
    );
  }

  /** Returns true when ALL invites were denied/rejected (publish as normal flow). */
  private collabRequestDenied(): boolean {
    return this.isCollaboration &&
      this.collabInvitees.length > 0 &&
      this.collabInvitees.every(
        i => i.status === 'Rejected' || i.status === 'Denied' ||
             i.status === 'rejected' || i.status === 'denied'
      );
  }

  saveFlowToServerAccessLevel(AccessType) {
    // ─── Collaboration gate ───────────────────────────────────────────────────
    if (this.hasPendingCollabRequest()) {
      this.toastr.warning(
        'This guide has a pending collaboration request. ' +
        'Publishing is blocked until the co-author accepts or denies the invite.',
        'Collaboration Pending',
        { timeOut: 5000 }
      );
      return;
    }
    // ─────────────────────────────────────────────────────────────────────────

    if (this.allSteps.length <= 0) {
      this.showMessage = true;
      this.toastr.warning(
        "Please add the cover page and steps to publish the flow."
      );
    } else if (!this.validateTransferRequest()) {
      // Validation failed, don't proceed with publishing
      return;
    } else {
      this.noResultReturned = true;
      console.log(this.userData.enableConsultation);

      // Validate required properties before creating flowModel
      if (!this.userData || !this.userData.emailAddress) {
        this.toastr.error("User data is missing. Please sign in again.");
        this.noResultReturned = false;
        return;
      }

      if (!this.title || !this.description || !this.coverImageUri) {
        this.showMessage = true;
        this.toastr.warning(
          "Please ensure title, description, and cover image are provided."
        );
        this.noResultReturned = false;
        return;
      }

      if (this.endQuestionFormBlocksSave()) {
        this.noResultReturned = false;
        return;
      }

      // Transform steps to ensure proper API format with PascalCase properties
      const transformedSteps = (this.allSteps || []).map((step: any) => ({
        Title: step.title || step.Title || "",
        Description: step.Description || "",
        Url: step.Url || "",
        VideoThumbNailUrl: step.VideoThumbNailUrl || "",
        TaggedItems: step.taggedItems || step.TaggedItems || [],
        IsSafetyCritical: step.isSafetyCritical || step.IsSafetyCritical || false,
        SafetyInstructionsTitle: step.safetyInstructionsTitle || step.SafetyInstructionsTitle || "",
        SafetyInstructionsDescription: step.safetyInstructionsDescription || step.SafetyInstructionsDescription || "",
        QuestionForm: cleanGuideQuestionForm(parseGuideQuestionForm(step.questionForm ?? step.QuestionForm)),
      }));

      // When the collaboration request was denied, publish as a regular flow
      const publishAsCollab = this.isCollaboration &&
        this.collabInvitees.length > 0 &&
        !this.collabRequestDenied();

      var flowModel: any = {
        PartitionKey: this.partitionKey || this.userData.emailAddress,
        UniqueId: this.uniqueId || "",
        UserName: this.uname || this.userData.userName || "",
        Description: this.description || "",
        CustomerEmail: this.userData.emailAddress,
        Title: this.title || "",
        AccessType: AccessType || "Public",
        accessType: AccessType || "Public",
        RestrictedAccessType:
          AccessType === "Restricted" ? this.restrictedAccessType || "LinkAccess" : null,
        restrictedAccessType:
          AccessType === "Restricted" ? this.restrictedAccessType || "LinkAccess" : null,
        IsSearchHidden:
          AccessType === "Private"
            ? true
            : AccessType === "Restricted"
              ? !!this.isSearchHidden
              : false,
        isSearchHidden:
          AccessType === "Private"
            ? true
            : AccessType === "Restricted"
              ? !!this.isSearchHidden
              : false,
        restrictedAccessFlows:
          AccessType === "Restricted" ? this.savedAccessFlows || [] : [],
        RestrictedAccessFlows:
          AccessType === "Restricted" ? this.savedAccessFlows || [] : [],
        ...(AccessType === "Restricted" ? this.savedAccessAdvanced || {} : {}),
        Url: this.coverImageUri || "",
        VideoThumbNailUrl: this.coverPosterPageURI || "",
        Type: this.resolveFlowType(),
        FlowStatus: "Approved",
        Duration: this.duration || 0,
        DurationUnit: this.durationUnit || 'Mins',
        CoverIsSafetyCritical: this.coverIsSafetyCritical || false,
        CoverSafetyInstructionsTitle: this.coverSafetyInstructionsTitle || "",
        CoverSafetyInstructionsDescription: this.coverSafetyInstructionsDescription || "",
        Steps: transformedSteps,
        Components: this.inames || [],
        Price: publishAsCollab ? 0 : (this.price || 0),
        IsPaid: publishAsCollab ? false : (this.isPaid || false),
        IsConsulatationAvailable: publishAsCollab ? false : (this.userData.enableConsultation || false),
        IsSponsored: this.isSponsored || false,
        ViewerFeatures: this.buildViewerFeaturesPayload(),
        EndQuestionForm: cleanGuideQuestionForm(this.endQuestionForm),
        IsCollaboration: publishAsCollab,
        CoAuthorEmail: publishAsCollab ? (this.collabInvitees[0]?.email ?? null) : null,
        CoAuthorUserName: publishAsCollab ? (this.collabInvitees[0]?.userName ?? null) : null,
        CoAuthorProfilePicUrl: publishAsCollab ? (this.collabInvitees[0]?.profilePicUrl ?? null) : null,
        CoAuthorEmails: publishAsCollab ? JSON.stringify(this.collabInvitees.map(i => i.email)) : null,
        CoAuthorUserNames: publishAsCollab ? JSON.stringify(this.collabInvitees.map(i => i.userName || i.email)) : null,
        CoAuthorProfilePicUrls: publishAsCollab ? JSON.stringify(this.collabInvitees.map(i => i.profilePicUrl || '')) : null,
        CoAuthorStatuses: publishAsCollab ? JSON.stringify(this.collabInvitees.map(i => i.status || 'Pending')) : null,
        CollaborationValue: publishAsCollab ? (this.collabValue || 0) : null,
        CollaborationStatus: publishAsCollab ? (this.collabInvitees[0]?.status || 'Pending') : null,
        FlowSupportingDocumentsHyperLinkModels:
          this.supportingDocumentHyperLinks || [],
        FlowSupportingDocumentsDocumentModels:
          this.supportingDocumentDocuments || [],
        SearchKeyWords: Array.isArray(this.searchKeyWords)
          ? this.searchKeyWords.join(", ")
          : this.searchKeyWords ?? "",
      };

      // Only include identity when RowKey is set (tick or undotted UniqueId)
      if (this.hasFlowRowKey()) {
        flowModel.rowKey = this.rowKey.toString();
        flowModel.UniqueId = this.uniqueId;
        flowModel.partitionKey = this.partitionKey;
      }

      console.log("Validated flowModel:", flowModel);

      this.showMessage = false;

      if (this.userData) {
        this.isUploading = true;
        this.isLoading = true;
        this.progress = 0;
        this.openLoadingModal("Publishing flow...", true);
        this.flowServiceService
          .publishUserFlow(flowModel, this.userData.emailAddress)
          .subscribe({
            next: (event: HttpEvent<any>) => {
              switch (event.type) {
                case HttpEventType.Sent:
                  console.log("Request sent to server.");
                  this.updateLoadingModal("Publishing flow...", 0);
                  break;

                case HttpEventType.UploadProgress:
                  this.progress = Math.round(
                    (95 * event.loaded) / (event.total || 1)
                  );
                  console.log(`Progress: ${this.progress}%`);
                  this.updateLoadingModal("Publishing flow...", this.progress);
                  break;

                case HttpEventType.Response:
                  console.log("Upload complete:", event.body);
                  localStorage.setItem("draftTabIndex", "0");
                  this.applySavedFlowIdentity(event.body);
                  this.cdr.detectChanges();
                  this.updateLoadingModal("Flow published successfully!", 100);

                  // Send invites to all collaborators who haven't been invited yet
                  const publishedFlowId = event.body?.rowKey || event.body?.RowKey || this.rowKey;
                  const unsentInvitees = this.collabInvitees.filter(i => !i.status || i.status === '');
                  if (this.isCollaboration && unsentInvitees.length > 0 && publishedFlowId) {
                    this.sendCollabInvitesAfterPublish(publishedFlowId, unsentInvitees);
                  }

                  const deniedAndPublishedNormal = this.collabRequestDenied();
                  const publishedTitle =
                    event.body?.title || event.body?.Title || this.title;
                  setTimeout(() => {
                    this.progress = 100;
                    console.log("set is loading");
                    this.noResultReturned = false;
                    this.isLoading = false;
                    this.closeLoadingModal();
                    if (deniedAndPublishedNormal) {
                      this.toastr.success(
                        'Flow published as a regular flow (collaboration request was denied).'
                      );
                    } else {
                      this.toastr.success("Flow successfully published");
                    }
                    this.resetProgress();
                    this.navigateToPublishedFlowView(publishedFlowId, publishedTitle);
                  }, 1500);

                  break;

                default:
                  console.log("Unhandled event:", event);
              }
            },
            error: (err) => {
              console.error("Error uploading:", err);
              this.noResultReturned = false;
              this.isLoading = false;
              this.closeLoadingModal();
              if (isTrialLimitError(err)) {
                handleTrialLimitError(this.dialog, this.toastr, err, this.router.url);
                this.resetProgress();
                return;
              }
              if (isMaxPublishedFlowsError(err)) {
                handleMaxPublishedFlowsError(this.router, this.toastr, err, this.router.url);
                this.resetProgress();
                return;
              }
              if (isFlowBundlePermissionError(err)) {
                handleFlowBundlePermissionError(this.toastr, err);
                this.resetProgress();
                return;
              }
              if (isCreatorPublicOnlyError(err)) {
                handleCreatorPublicOnlyError(this.dialog, this.router.url, err);
                this.resetProgress();
                return;
              }
              this.toastr.error(
                this.approvalRequiredError(err) || "Failed to publish flow. Please try again."
              );
              this.resetProgress();
            },
          });
      }
      // if (this.userData != null) {
      //   this.flowServiceService
      //     .publishUserFlow(flowModel, this.userData.emailAddress)
      //     .subscribe((data) => {
      //       if(this.isFaqChecked){
      //         this.addFaqs();
      //       }
      //       localStorage.setItem("draftTabIndex", "0");
      //       this.router.navigate(["/user-profile"]);
      //       this.noResultReturned = false;
      //       });
      // }
    }
  }

  resetProgress() {
    setTimeout(() => {
      this.progress = 0;
      this.isUploading = false;
      this.isLoading = false;
    }, 500); // Small delay before hiding progress
  }

  // ─── Collaboration helpers ────────────────────────────────────────────────

  onCollabToggle() {
    if (this.isCollaboration) {
      this.isPaid = false;
      this.price = null;
      this.isSCenabled = false;
      this.accessType = "Public";
    } else {
      this.collabInvitees = [];
      this.pendingCollabUser = null;
      this.collabUserSuggestions = [];
      this.applyCreatorPaidOnlyRules();
    }
    this.autoSaveCoverPageData();
  }

  private applyCreatorPaidOnlyRules(): void {
    // Organization content is never sold — no price, regardless of the member's personal plan.
    if (isOrganizationAccountMode()) {
      this.creatorRequiresPaidCreation = false;
      this.isPaid = false;
      this.price = null;
      return;
    }
    this.creatorRequiresPaidCreation = isCreatorPlanUser(this.userData);
    if (this.creatorRequiresPaidCreation && !this.isCollaboration) {
      this.isPaid = true;
    }
  }

  /** Price fields show when sales are enabled, or when the Creator plan requires a price. */
  get showPriceFields(): boolean {
    if (isOrganizationAccountMode()) return false;
    return (
      this.showContentPurchase ||
      (this.creatorRequiresPaidCreation && !this.isCollaboration)
    );
  }

  openCreatorAccessUpgradeDialog(): void {
    openCreatorPlanUpgradeDialog(this.dialog, this.router.url);
  }

  /** Private / link-only require upgrade; Restricted tabs stay open for Creators. */
  private blocksCreatorNonPublicAccess(choice: JourneyAccessChoice | "Restricted"): boolean {
    if (
      !this.creatorRequiresPaidCreation ||
      this.isCollaboration ||
      choice === "Public" ||
      choice === "Restricted"
    ) {
      return false;
    }

    this.openCreatorAccessUpgradeDialog();
    return true;
  }

  goToUpgradeForFreeContent(): void {
    this.router.navigate(["/pricing"], {
      queryParams: { upgradeFree: "1", returnUrl: this.router.url },
    });
  }

  onCollabSearchInput(value: string) {
    this.collabUserSearchInput$.next(value);
  }

  /** Stage a user from the search dropdown — not yet added to the list. */
  selectCollabUser(user: any) {
    this.pendingCollabUser = user;
    this.collabUserSuggestions = [];
  }

  /** Confirm adding the staged user to the collaborators list. */
  addCollabUser() {
    if (!this.pendingCollabUser) return;
    const email: string = this.pendingCollabUser.emailAddress;
    if (this.collabInvitees.some(i => i.email.toLowerCase() === email.toLowerCase())) {
      this.toastr.warning('This user is already added as a collaborator.');
      return;
    }
    this.collabInvitees = [
      ...this.collabInvitees,
      {
        email,
        userName: this.pendingCollabUser.userName || email,
        profilePicUrl: this.pendingCollabUser.profilePicUrl || '',
        status: '',
      },
    ];
    this.pendingCollabUser = null;
    this.autoSaveCoverPageData();
  }

  /** Remove a collaborator from the list, cancelling the invite via API when already sent. */
  removeCollabUser(email: string) {
    const invitee = this.collabInvitees.find(i => i.email === email);
    const needsApiCancel = invitee && (invitee.status === 'Pending' || invitee.status === 'Accepted') && this.flowId;

    if (needsApiCancel) {
      this.flowServiceService.cancelCollabInvite(this.flowId, email).subscribe({
        next: () => {
          this.toastr.success(`Collaboration invite to @${invitee.userName || email} cancelled.`);
        },
        error: () => {
          this.toastr.warning(`Could not cancel the invite to ${email} on the server, but they were removed locally.`);
        },
      });
    }

    this.collabInvitees = this.collabInvitees.filter(i => i.email !== email);
    this.autoSaveCoverPageData();
  }

  /** Returns true if collaboration is on and any collaborator has a Pending invite. */
  hasPendingCollabInvite(): boolean {
    return this.isCollaboration && this.collabInvitees.some(i => i.status === 'Pending');
  }

  /** Discard the staged (not-yet-added) user without clearing the list. */
  clearCollabUser() {
    this.pendingCollabUser = null;
    this.collabUserSuggestions = [];
  }

  /** Send invites sequentially to every collaborator whose invite hasn't been sent yet. */
  sendCollabInvitesAfterPublish(
    flowId: string,
    invitees: { email: string; userName: string; status: string }[]
  ) {
    invitees.forEach(invitee => {
      this.flowServiceService
        .sendCollabInvite({
          flowId,
          inviteeEmail: invitee.email,
          inviteMessage: this.collabInviteMessage,
          collaborationValue: this.collabValue,
        })
        .subscribe({
          next: () => {
            invitee.status = 'Pending';
            this.toastr.success(`Collaboration invite sent to ${invitee.email}`);
          },
          error: () => {
            this.toastr.warning(
              `Flow published but invite to ${invitee.email} could not be sent. Retry from your dashboard.`
            );
          },
        });
    });
  }

  // ─── Sponsored helpers ────────────────────────────────────────────────────

  onSponsoredToggle() {
    this.autoSaveCoverPageData();
  }

  // Loading modal helper methods
  openLoadingModal(message: string, showProgress: boolean = false) {
    if (this.loadingModalRef) {
      this.closeLoadingModal();
    }
    this.loadingModalRef = this.dialog.open(LoadingModalComponent, {
      width: "400px",
      disableClose: true,
      data: {
        message: message,
        progress: 0,
        showProgress: showProgress,
      } as LoadingModalData,
    });
  }

  updateLoadingModal(message?: string, progress?: number) {
    if (this.loadingModalRef && this.loadingModalRef.componentInstance) {
      if (message) {
        this.loadingModalRef.componentInstance.updateMessage(message);
      }
      if (progress !== undefined) {
        this.loadingModalRef.componentInstance.updateProgress(progress);
      }
    }
  }

  closeLoadingModal() {
    if (this.loadingModalRef) {
      this.loadingModalRef.close();
      this.loadingModalRef = null;
    }
  }

  openLeavingDialog() {
    const dialogRef = this.dialog.open(CancalFlowDialogComponent, {
      width: "250px",
    });
  }

  showToastForDelete(message) {
    this.toastr.success(message);
  }

  deleteFlow() {
    if (this.hasFlowRowKey()) {
      var flowModel = {
        rowKey: this.rowKey.toString(),
        CustomerEmail: this.userData.emailAddress,
        FlowStatus: "Submitted",
      };

      this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
      if (this.userData != null) {
        this.noResultReturned = true;
        //
        this.flowServiceService.deleteFlow(flowModel).subscribe((data) => {
          this.noResultReturned = false;
          //
          var isDraftDeleted = localStorage.getItem("draftWord");
          localStorage.setItem("draftTabIndex", "2");
          if (data.Deleted && isDraftDeleted == "Draft Flow") {
            this.router.navigate(["/user-profile"]);
            localStorage.removeItem("Draft Flow");
            this.showToastForDelete("Draft successfully deleted");
          } else {
            this.showToastForDelete("Flow deleted successfully");
            this.router.navigate(["/"]);
          }
        });
      }
    }
  }

  openImage(Url) {
    localStorage.setItem("itemsRequiredImageToShow", Url);

    this.dialog.open(ShowFlowImageDialogComponent, {
      panelClass: ["media-dialog-pane", "media-dialog"],
      backdropClass: "custom-backdrop",
      maxWidth: "95vw",
      width: "auto",
      maxHeight: "95vh",
      height: "auto",
      autoFocus: false,
      restoreFocus: false,
    });
  }

  /**
   * Handle transfer toggle change
   */
  onTransferToggleChange() {
    // Check if there are active transfer requests before allowing toggle
    if (this.hasActiveTransferRequest) {
      this.toastr.warning(
        "Cannot enable transfer ownership while there is an active transfer request in progress. Please wait for the current request to be completed."
      );
      this.enableTransferAfterPublish = false; // Reset the toggle
      return;
    }

    if (this.enableTransferAfterPublish) {
      if (!hasContentCreationPlanAccess(this.userData)) {
        this.enableTransferAfterPublish = false;
        this.toastr.info(
          "A Creator or Business plan is required to transfer ownership."
        );
        return;
      }
      // Open dialog to select user when toggle is enabled
      this.openTransferOwnershipDialog();
    } else {
      // Clear selected user when toggle is disabled
      this.disableTransferUserPublishButton = true;
      this.selectedTransferUser = null;
      localStorage.removeItem("selectedTransferUserForTransfer");
      this.toastr.info("Transfer ownership request has been disabled");
    }
  }

  /**
   * Open transfer ownership dialog to select user
   */
  openTransferOwnershipDialog() {
    if (!this.enableTransferAfterPublish) {
      return;
    }

    if (!hasContentCreationPlanAccess(this.userData)) {
      this.enableTransferAfterPublish = false;
      this.toastr.info(
        "A Creator or Business plan is required to transfer ownership."
      );
      return;
    }

    // Store current flow data for transfer
    const flowModel = {
      rowKey: this.hasFlowRowKey() ? this.rowKey.toString() : "",
      title: this.title,
      customerEmail: this.userData?.emailAddress,
      type: "flow",
      coverImageUri: this.coverImageUri,
      url: this.coverImageUri, // Fallback for compatibility
      userName:
        this.userData?.userName || this.userData?.firstName || "Current User",
    };
    localStorage.setItem("flowModel", JSON.stringify(flowModel));

    const dialogRef = this.dialog.open(TransferOwnershipComponent, {
      panelClass: "dialoguebox",
      width: "600px",
      maxHeight: "80vh",
      data: {
        isCreateFlowMode: true, // Flag to indicate this is opened from create-flow
        flowData: flowModel,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.selectedUser) {
        this.selectedTransferUser = result.selectedUser;
        this.selectedTransferUserComment = result.transferComment;

        this.disableTransferUserPublishButton = false;
        // Persist selection for subsequent publish
        localStorage.setItem(
          "selectedTransferUserForTransfer",
          JSON.stringify(this.selectedTransferUser)
        );
        this.toastr.success(
          `Transfer ownership will be requested to ${
            result.selectedUser.firstName || result.selectedUser.userName
          } after publishing`
        );
      } else {
        // User cancelled or closed dialog, disable transfer
        this.enableTransferAfterPublish = false;
        this.selectedTransferUser = null;
        localStorage.removeItem("selectedTransferUserForTransfer");
      }
    });
  }

  /**
   * Handle transfer request after successful publish
   * @param responseBody - Response from publish API containing rowKey and other details
   * @param contentType - Type of content ('flow' or 'bundle')
   */
  handleTransferRequestAfterPublish(
    responseBody: any,
    contentType: "Flow" | "Bundle"
  ) {
    try {
      // Check if transfer is enabled and user is selected
      if (!this.enableTransferAfterPublish || !this.selectedTransferUser) {
        console.log("Transfer not enabled or no user selected");
        return;
      }

      // Extract necessary data from response
      const contentId = responseBody.rowKey;
      const contentTitle = responseBody.title || responseBody.Title;
      const customerEmail =
        responseBody.customerEmail || responseBody.CustomerEmail;

      if (!contentId) {
        console.warn("No content ID found in response for transfer request");
        return;
      }
      // Create transfer request model
      const transferRequest = {
        requestStatus: "Pending", // override to Pending for new request
        statusMessage:
          this.selectedTransferUserComment ||
          "Ownership transfer request initiated.",
        contentId: contentId,
        contentName: contentTitle, // if you want to use the actual title, otherwise keep contentName from source
        contentType: contentType,
        isActive: true,
        updatedBy: customerEmail,
        newOwnerEmail: this.selectedTransferUser.emailAddress,
        oldOwnerEmail: customerEmail,
        newOwnerUserName: this.selectedTransferUser.userName,
        partitionKey: contentId,
        oldOwnerUserName: responseBody.userName,
        updatedDateTime: new Date().toISOString(),
        createdDateTime: new Date().toISOString(),
      };

      // Send transfer request API
      this.sendTransferRequest(transferRequest);

      console.log("Transfer request prepared:", transferRequest);
    } catch (error) {
      console.error("Error preparing transfer request:", error);
      this.toastr.error("Failed to prepare transfer request");
    }
  }

  /**
   * Validate transfer request before publishing
   */
  validateTransferRequest(): boolean {
    if (this.enableTransferAfterPublish && !this.selectedTransferUser) {
      this.toastr.warning(
        "Please select a user for transfer ownership request before publishing"
      );
      return false;
    }
    return true;
  }

  /**
   * Send transfer request API
   * @param transferRequest - Transfer request data
   */
  private sendTransferRequest(transferRequest: any) {
    try {
      // Call the transfer ownership API
      this.flowServiceService
        .postTransferOwnership(transferRequest, this.userData.emailAddress)
        .subscribe({
          next: (response: any) => {
            console.log("Transfer request sent successfully:", response);
            this.toastr.success("Transfer ownership request sent successfully");

            // Clear the selected user after successful API call
            this.selectedTransferUser = null;
            this.enableTransferAfterPublish = false;
          },
          error: (error) => {
            console.error("Error sending transfer request:", error);
            const code = error?.error?.code;
            const message = error?.error?.message;
            if (
              code === "subscription_required" ||
              code === "recipient_subscription_required" ||
              code === "invalid_transfer_recipient"
            ) {
              this.toastr.info(message || "Transfer ownership request could not be sent.");
            } else {
              this.toastr.error(message || "Failed to send transfer ownership request");
            }
          },
        });
    } catch (error) {
      console.error("Error in sendTransferRequest:", error);
      this.toastr.error("Failed to send transfer ownership request");
    }
  }

  /**
   * Check if there are any active transfer ownership requests for the current flow
   * @returns Promise<boolean> - true if there are active requests, false otherwise
   */
  hasActiveTransferRequests(): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.rowKey) {
        resolve(false);
        return;
      }

      this.flowServiceService
        .getTransferOwnershipByContentId(this.rowKey)
        .subscribe({
          next: (data) => {
            if (data && data.length > 0) {
              // Check if there's any request with status other than "Approved", "Rejected", or "Cancelled"
              const activeRequest = data.find(
                (request: any) =>
                  request.requestStatus !== "Approved" &&
                  request.requestStatus !== "Rejected" &&
                  request.requestStatus !== "Cancelled"
              );
              resolve(!!activeRequest);
            } else {
              resolve(false);
            }
          },
          error: (error) => {
            console.error("Error checking active transfer requests:", error);
            resolve(false); // On error, assume no active requests (fail-safe)
          },
        });
    });
  }

  /**
   * Check transfer ownership status and disable transfer toggle if active requests exist
   */
  checkTransferOwnershipStatus(contentId: string) {
    console.log(
      `Checking transfer ownership status for contentId: ${contentId}`
    );

    this.flowServiceService
      .getTransferOwnershipByContentId(contentId)
      .subscribe((data) => {
        if (data && data.length > 0) {
          // Check if there's any request with status other than "Approved", "Rejected", or "Cancelled"
          // Statuses that indicate an active/ongoing request: "Pending", "ReworkRequested", "ReworkAccepted", etc.
          // Statuses that indicate a completed request: "Approved", "Rejected", "Cancelled"
          const activeRequest = data.find(
            (request: any) =>
              request.requestStatus !== "Approved" &&
              request.requestStatus !== "Rejected" &&
              request.requestStatus !== "Cancelled"
          );

          if (activeRequest) {
            console.log(
              `Found active transfer request with status: ${activeRequest.requestStatus}`
            );
            // Show info message about transfer request in progress and disable transfer toggle
            this.toastr.info(
              `Transfer request is already in progress with status: ${activeRequest.requestStatus}. Please wait for the current request to be completed before initiating a new one.`
            );
            this.hasActiveTransferRequest = true; // Set the flag to disable transfer actions
            this.enableTransferAfterPublish = false; // Disable the transfer toggle
            return; // Exit early - do not proceed with any transfer actions
          } else {
            console.log(
              "No active transfer requests found, all requests are completed"
            );
            this.hasActiveTransferRequest = false; // Clear the flag to allow transfer actions
          }
        } else {
          console.log("No transfer ownership records found for this content");
          this.hasActiveTransferRequest = false; // Clear the flag to allow transfer actions
        }
      });
  }

  /**
   * Refresh transfer ownership status - can be called manually if needed
   */
  refreshTransferOwnershipStatus() {
    if (this.rowKey) {
      this.checkTransferOwnershipStatus(this.rowKey);
    }
  }

  /**
   * Refresh flow data after cover page dialog closes
   */
  refreshFlowData() {
    var flowCoverPage = JSON.parse(
      localStorage.getItem("flowCoverPageDetails")
    );

    if (flowCoverPage != null) {
      this.isCoverAImageOrVideo(flowCoverPage.coverImage);
      this.coverImageUri = flowCoverPage.coverImage;
      this.coverPosterPageURI = flowCoverPage.coverPosterPageURI;
      this.title = flowCoverPage.title;
      this.searchKeyWords =
        flowCoverPage.searchKeyWords && flowCoverPage.searchKeyWords.length > 0
          ? flowCoverPage.searchKeyWords
          : "";
      this.description = flowCoverPage.description;
      this.duration = flowCoverPage.duration || 0;
      this.durationUnit = flowCoverPage.DurationUnit || flowCoverPage.durationUnit || 'Mins';
      this.rowKey = flowCoverPage.rowKey;
      this.uniqueId = flowCoverPage.uniqueId;
      this.fileName = flowCoverPage.fileName;
      this.price = flowCoverPage.price;
      this.isPaid = flowCoverPage.isPaid;
      this.partitionKey = flowCoverPage.customerEmail;
      this.showItemsOrStepsButton = false;
      this.applyCreatorPaidOnlyRules();
    }

    var supportingDocumentDocuments = JSON.parse(
      localStorage.getItem("SupportingDocumentDocuments")
    );

    var supportingDocumentHyperLinks = JSON.parse(
      localStorage.getItem("SupportingDocumentHyperLinksRequired")
    );

    if (supportingDocumentDocuments != null) {
      this.supportingDocumentDocuments = supportingDocumentDocuments;
      this._documentCount = supportingDocumentDocuments.length;
    } else {
      this._documentCount = 0;
    }

    if (supportingDocumentHyperLinks != null) {
      this.supportingDocumentHyperLinks = supportingDocumentHyperLinks;
      this._hyperlinkCount = supportingDocumentHyperLinks.length;
    } else {
      this._hyperlinkCount = 0;
    }

    this.selectFirstAvailableJourneyTab();
    this.cdr.detectChanges();
  }

  /**
   * Refresh items data after items dialog closes
   */
  refreshItemsData() {
    this.inames = JSON.parse(localStorage.getItem("ItemsRequired"));
    if (!Array.isArray(this.inames)) {
      this.inames = [];
    }
    // If items exist after refresh, keep the toggle checked so the items UI stays visible
    if (this.hasItems) {
      this.isItemsRequired = true;
    }
    this.groupDataByGroupName();
    this.selectFirstAvailableJourneyTab();
    this.cdr.detectChanges();
  }

  /**
   * Refresh steps data after steps dialog closes
   */
  refreshStepsData() {
    this._steps = JSON.parse(localStorage.getItem("stepsCoverPageDetails"));
    this.allSteps = [];
    this.stepNumber = 1;

    if (this._steps != null && this._steps.length > 0) {
      this.disablePublishButton = false;

      this._steps.forEach((element) => {
        this.isImageOrVideo(element.url);

        this.allSteps.push({
          Url: element.url,
          title: element.title,
          Description: element.description,
          showImage: this.showImage,
          VideoThumbNailUrl: element.posterUrl,
          showVideo: this.showVideo,
          stepFileName: element.stepFileName || element.fileName,
          stepNumber: this.stepNumber++,
          taggedItems: element.taggedItems || [], // Include tagged items
          isSafetyCritical: element.isSafetyCritical || false, // Include safety critical flag
          safetyInstructionsTitle: element.safetyInstructionsTitle || "", // Include safety instructions title
          safetyInstructionsDescription: element.safetyInstructionsDescription || "", // Include safety instructions description
          questionForm: parseGuideQuestionForm(element.questionForm ?? element.QuestionForm),
        });
      });
    } else {
      if (this.allSteps.length <= 0) {
        this.disablePublishButton = true;
      }
    }

    this.selectFirstAvailableJourneyTab();
    this.markAsChanged();
    this.cdr.detectChanges();
  }

  /**
   * Refresh FAQs data after FAQ dialog closes
   */
  refreshFaqsData() {
    this.getSupportFaqs(this.rowKey);
    this.selectFirstAvailableJourneyTab();
    this.cdr.detectChanges();
  }

  // Cover page methods
  titleChanged() {
    if (!this.title) {
      this.autoSaveCoverPageData();
      return;
    }
    this.title = this.title.trim();
    if (this.title.length > this.maxtitlelenght) {
      this.title = this.title.substring(0, this.maxtitlelenght);
    }
    this.currenttitlelenght = this.title.length;
    this.autoSaveCoverPageData();
  }

  descChanged() {
    if (!this.description) {
      this.autoSaveCoverPageData();
      return;
    }
    this.description = this.description.trim();
    if (this.description.length > this.maxdesclenght) {
      this.description = this.description.substring(0, this.maxdesclenght);
    }
    this.autoSaveCoverPageData();
  }

  // Auto-save cover page data in real-time (without toast notification)
  autoSaveCoverPageData() {
    // Update cover image/video display flags if coverImageUri exists
    if (this.coverImageUri) {
      this.isCoverAImageOrVideo(this.coverImageUri);
    }

    var flowCoverPage = {
      coverImage: this.coverImageUri || "",
      description: this.description || "",
      coverPosterPageURI: this.coverPosterPageURI || "",
      title: this.title || "",
      flowId: this.flowId,
      uniqueId: this.uniqueId,
      type: this.resolveFlowType(),
      duration: this.duration || 0,
      durationUnit: this.durationUnit || 'Mins',
      fileName: this.fileName,
      price: this.price || 0,
      isPaid: this.isPaid || false,
      rowKey: this.rowKey,
      customerEmail: this.partitionKey || this.userData?.emailAddress,
      searchKeyWords: Array.isArray(this.searchKeyWords)
        ? this.searchKeyWords.join(", ")
        : this.searchKeyWords ?? "",
      coverIsSafetyCritical: this.coverIsSafetyCritical || false,
      coverSafetyInstructionsTitle: this.coverSafetyInstructionsTitle || "",
      coverSafetyInstructionsDescription: this.coverSafetyInstructionsDescription || "",
      isSponsored: this.isSponsored || false,
      isCollaboration: this.isCollaboration || false,
      coAuthorEmail: this.collabInvitees[0]?.email || "",
      coAuthorUserName: this.collabInvitees[0]?.userName || "",
      coAuthorProfilePicUrl: this.collabInvitees[0]?.profilePicUrl || "",
      coAuthorEmails: JSON.stringify(this.collabInvitees.map(i => i.email)),
      coAuthorUserNames: JSON.stringify(this.collabInvitees.map(i => i.userName || i.email)),
      coAuthorProfilePicUrls: JSON.stringify(this.collabInvitees.map(i => i.profilePicUrl || '')),
      coAuthorStatuses: JSON.stringify(this.collabInvitees.map(i => i.status || 'Pending')),
      collaborationStatus: this.collabInvitees[0]?.status || "",
      accessType: this.accessType || "",
      restrictedAccessType: this.restrictedAccessType || "",
      isSearchHidden: this.isSearchHidden,
      restrictedAccessFlows: this.savedAccessFlows || [],
      ...(this.savedAccessAdvanced || {}),
      endQuestionForm: this.endQuestionForm,
    };

    localStorage.setItem("flowCoverPageDetails", JSON.stringify(flowCoverPage));
    this.markAsChanged();
    this.cdr.detectChanges();
  }

  /**
   * Reads the raw localStorage values that viewflow stored when the user clicked
   * "Edit" and builds the baseline snapshot from those values directly.
   * This is called at the very top of ngOnInit — before any component property
   * is set — so the baseline is always the exact server version, nothing else.
   */
  private _snapshotFromLocalStorage() {
    try {
      const coverPage = JSON.parse(localStorage.getItem('flowCoverPageDetails') || 'null');
      const steps: any[] = JSON.parse(localStorage.getItem('stepsCoverPageDetails') || '[]') || [];
      const items: any[] = JSON.parse(localStorage.getItem('ItemsRequired') || '[]') || [];
      const docs: any[] = JSON.parse(localStorage.getItem('SupportingDocumentDocuments') || '[]') || [];
      const links: any[] = JSON.parse(localStorage.getItem('SupportingDocumentHyperLinksRequired') || '[]') || [];

      this._initialFlowState = JSON.stringify({
        title: (coverPage?.title || '').trim(),
        description: this.stripHtml(coverPage?.description || '').trim(),
        coverImageUri: coverPage?.coverImage || '',
        coverPosterPageURI: coverPage?.coverPosterPageURI || '',
        categoryName: this.resolveCategoryName(coverPage?.type, null) || '',
        duration: Number(coverPage?.duration) || 0,
        durationUnit: coverPage?.durationUnit || 'Mins',
        price: coverPage?.price != null ? Number(coverPage.price) : null,
        isPaid: coverPage?.isPaid || false,
        isSponsored: coverPage?.isSponsored || false,
        isCollaboration: coverPage?.isCollaboration || false,
        coAuthorEmails: coverPage?.coAuthorEmails || '[]',
        coverIsSafetyCritical: coverPage?.coverIsSafetyCritical || false,
        coverSafetyInstructionsTitle: coverPage?.coverSafetyInstructionsTitle || '',
        coverSafetyInstructionsDescription: this.stripHtml(coverPage?.coverSafetyInstructionsDescription || '').trim(),
        endQuestions: this.questionFormSignature(coverPage?.endQuestionForm ?? coverPage?.EndQuestionForm),
        steps: steps.map(s => ({
          Url: s.url || s.Url || '',
          title: s.title || '',
          Description: s.description || s.Description || '',
          isSafetyCritical: s.isSafetyCritical || s.IsSafetyCritical || false,
          questions: this.questionFormSignature(s.questionForm ?? s.QuestionForm),
        })),
        items: items.map(i => ({
          itemkey: i.itemkey || '', itemValue: i.itemValue || '',
          url: i.url || '', wheretofindit: i.wheretofindit || '', groupName: i.groupName || '',
        })),
        faqs: [],  // patched asynchronously once getSupportFaqs() resolves
        docs: docs.length,
        links: links.length,
      });
    } catch {
      this._initialFlowState = null;
    }
  }

  /** Builds a lightweight snapshot of all user-editable state for change comparison. */
  private _buildStateSnapshot(): string {
    return JSON.stringify({
      title: (this.title || '').trim(),
      description: this.stripHtml(this.description || '').trim(),
      coverImageUri: this.coverImageUri || '',
      coverPosterPageURI: this.coverPosterPageURI || '',
      categoryName: this.CategoryName || '',
      duration: Number(this.duration) || 0,
      durationUnit: this.durationUnit || 'Mins',
      price: this.price != null ? Number(this.price) : null,
      isPaid: this.isPaid || false,
      isSponsored: this.isSponsored || false,
      isCollaboration: this.isCollaboration || false,
      coAuthorEmails: JSON.stringify(this.collabInvitees.map(i => i.email)),
      coverIsSafetyCritical: this.coverIsSafetyCritical || false,
      coverSafetyInstructionsTitle: this.coverSafetyInstructionsTitle || '',
      coverSafetyInstructionsDescription: this.stripHtml(this.coverSafetyInstructionsDescription || '').trim(),
      endQuestions: this.questionFormSignature(this.endQuestionForm),
      steps: (this.allSteps || []).map(s => ({
        Url: s.Url || '', title: s.title || '', Description: s.Description || '',
        isSafetyCritical: s.isSafetyCritical || false,
        questions: this.questionFormSignature(s.questionForm),
      })),
      items: (this.inames || []).map(i => ({
        itemkey: i.itemkey || '', itemValue: i.itemValue || '',
        url: i.url || '', wheretofindit: i.wheretofindit || '', groupName: i.groupName || '',
      })),
      faqs: (this._allFaqs || []).map(f => ({ question: f.question || '', answer: f.answer || '' })),
      docs: (this.supportingDocumentDocuments || []).length,
      links: (this.supportingDocumentHyperLinks || []).length,
    });
  }

  /** Re-evaluate whether the current state differs from the initial loaded state. */
  markAsChanged() {
    if (!this.edit || !this._initialFlowState || !this._editChangeDetectionReady) return;
    this.hasUnsavedChanges = this._buildStateSnapshot() !== this._initialFlowState;
    this.cdr.detectChanges();
  }

  private applySavedFlowIdentity(body: any): void {
    const rowKey = body?.rowKey ?? body?.RowKey;
    const uniqueId = body?.uniqueId ?? body?.UniqueId;
    const partitionKey = body?.partitionKey ?? body?.PartitionKey;

    if (rowKey != null && rowKey !== "") {
      this.rowKey = String(rowKey);
    }
    if (uniqueId) {
      this.uniqueId = uniqueId;
    }
    if (partitionKey) {
      this.partitionKey = partitionKey;
    }
  }

  private syncEditStateAfterSave(): void {
    if (!this.edit) {
      return;
    }
    this._initialFlowState = this._buildStateSnapshot();
    this.hasUnsavedChanges = false;
    this.cdr.detectChanges();
  }

  private showDraftPreviewTab(): void {
    this.visitedTabs.add("summary");
    this.activeJourneyTab = "summary";
    this.journeyTabManuallySelected = true;
    this.cdr.detectChanges();
  }

  private navigateToPublishedFlowView(
    rowKey?: number | string,
    title?: string
  ): void {
    const publishedRowKey = rowKey ?? this.rowKey;
    if (!publishedRowKey) {
      this.flowNavigationService.navigateBack(this.returnUrl);
      return;
    }

    this.flowNavigationService.navigateToPublishedFlow(
      title || this.title || "flow",
      publishedRowKey
    );
  }

  checkValue() {
    if (isOrganizationAccountMode()) {
      this.isPaid = false;
      this.price = null;
      this.autoSaveCoverPageData();
      return;
    }
    if (this.creatorRequiresPaidCreation && !this.isCollaboration) {
      this.isPaid = true;
    }
    if (!this.isPaid) {
      this.price = null;
    }
    this.autoSaveCoverPageData();
  }

  async selectFiles(event: any, source: string) {
    if (event.target.files) {
      this.noResultReturned = true;
      this.fileData = <File>event.target.files[0];
      this.isLoading = true;

      const fileType = source === "cp" ? "cover media" : "supporting document";
      const imageExtensions = [
        "jpeg",
        "jpg",
        "png",
        "gif",
        "jfif",
        "tiff",
        "tif",
        "pdf",
        "bmp",
        "webp",
        "svg",
        "heic",
        "heif",
        "raw",
        "arw",
        "cr2",
        "nef",
        "orf",
        "rw2",
        "dng",
        "psd",
        "ico",
        "exif",
        "pjpeg",
        "ppm",
        "pgm",
        "pbm",
        "pnm",
        "xpm",
        "tga",
        "pcx",
        "jp2",
        "jpx",
        "eps",
        "ai",
      ];
      const videoExtensions = [
        "mp4",
        "mov",
        "wmv",
        "flv",
        "avchd",
        "webm",
        "mkv",
        "vob",
        "ogv",
        "gifv",
        "m4p",
        "m4v",
        "3gp",
        "3g2",
        "amv",
        "nsv",
        "ogg",
        "f4v",
        "f4p",
        "f4a",
        "f4b",
        "avi",
        "mts",
        "m2ts",
        "ts",
        "mpg",
        "mpeg",
        "rm",
        "rmvb",
        "divx",
        "xvid",
        "asf",
        "mxf",
        "dv",
        "h264",
        "h265",
        "vp8",
        "vp9",
        "prores",
        "swf",
        "dat",
        "bik",
        "av1",
        "vro",
        "svi",
      ];
      const fileExtension = this.fileData.name.split(".").pop().toLowerCase();

      const isImageOrPdf = imageExtensions.includes(fileExtension);
      const isVideo = videoExtensions.includes(fileExtension);

      let fileToUpload = this.fileData;
      if (isVideo) {
        try {
          this.openLoadingModal("Optimizing video for upload...", true);
          fileToUpload = await this.mediaUploadService.prepareFileForUpload(
            this.fileData,
            (progress) => this.updateLoadingModal("Optimizing video for upload...", progress)
          );
          this.fileData = fileToUpload;
        } catch (error: any) {
          this.isLoading = false;
          this.noResultReturned = false;
          this.fileName = "";
          this.closeLoadingModal();
          this.toastr.warning(error?.message || this.mediaUploadService.uploadTooLargeMessage());
          return;
        }
      }

      const formData = new FormData();
      formData.append("fileData", fileToUpload);
      this.openLoadingModal(`Uploading ${fileType}...`, true);

      const uploadUrl = isImageOrPdf
        ? environment.apiBaseUrl + environment.uploadImageUrl
        : environment.apiBaseUrl + environment.uploadVideoUrl;

      this.http
        .post(uploadUrl, formData, {
          reportProgress: true,
          observe: "events",
        })
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                if (event.total) {
                  this.progress = Math.round(
                    (event.loaded / event.total) * 100
                  );
                  this.updateLoadingModal(undefined, this.progress);
                }
                break;
              case HttpEventType.Response:
                this.handleFileUpload(event.body, isImageOrPdf, source);
                break;
            }
          },
          (error) => {
            this.isLoading = false;
            this.noResultReturned = false;
            this.fileName = "";
            this.closeLoadingModal();
            this.toastr.warning(this.mediaUploadService.uploadTooLargeMessage());
            console.error("Upload error:", error);
          }
        );
    }
  }

  handleFileUpload(response: any, isImageOrPdf: boolean, source: string) {
    this.isLoading = false;
    this.noResultReturned = false;
    this.closeLoadingModal();
    const mediaUploadStatus = response;

    if (mediaUploadStatus) {
      if (isImageOrPdf) {
        this.showCoverImage = true;
        this.showCoverVideo = false;
        if (source === "cp") {
          this.fileName = this.fileData.name;
          this.coverImageUri =
            environment.imageStorageBaseUrl + mediaUploadStatus.fileName;
          // Reset thumbnail state when image is uploaded
          this.generatedCoverThumbnailUrl = "";
          this.customCoverThumbnailUrl = "";
          this.customCoverThumbnailFile = null;
          this.coverThumbnails = [];
          this.videoDuration = 0;
          this.currentVideoTime = 0;
          this.thumbnailSelectionMode = "auto";
          this.autoSaveCoverPageData();
        } else if (source === "sd") {
          this.sffilename = mediaUploadStatus.fileName;
          this.sffilelink =
            environment.documentsStorageBaseUrl + mediaUploadStatus.fileName;
        }
        this.toastr.success("File has been uploaded successfully.");
        this.progress = 100;
      } else {
        // Video upload - show thumbnail selection icon
        this.showCoverVideo = true;
        this.showCoverImage = false;
        if (source === "cp") {
          this.fileName = this.fileData.name;
          this.coverImageUri =
            environment.videoStorageBaseUrl + mediaUploadStatus.fileName;

          // Store generated thumbnail URL
          this.generatedCoverThumbnailUrl = mediaUploadStatus.posterImageName
            ? environment.imageStorageBaseUrl +
              mediaUploadStatus.posterImageName
            : "";

          // Set generated thumbnail as default if available
          if (this.generatedCoverThumbnailUrl) {
            this.coverPosterPageURI = this.generatedCoverThumbnailUrl;
          }

          // Fetch auto-generated thumbnails
          this.fetchVideoThumbnails(mediaUploadStatus.fileName, "cover");
          this.thumbnailSelectionMode = "auto";
          this.autoSaveCoverPageData();
        } else if (source === "sd") {
          this.sffilename = mediaUploadStatus.fileName;
        }
        this.progress = 100;
        this.toastr.success(
          "Video uploaded successfully. Select a thumbnail below."
        );
      }
    } else {
      this.toastr.error("Upload failed");
    }
  }

  openThumbnailSelectionDialog(
    generatedThumbnailUrl: string,
    videoUrl: string,
    source: "cover" | "step"
  ) {
    const dialogRef = this.dialog.open(ThumbnailSelectionDialogComponent, {
      width: "700px",
      maxWidth: "90vw",
      data: {
        generatedThumbnailUrl: generatedThumbnailUrl,
        videoUrl: videoUrl,
        source: source,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (source === "cover") {
          this.coverPosterPageURI = result.thumbnailUrl;
          this.markAsChanged();
        } else if (source === "step") {
          this.stepPosterUrl = result.thumbnailUrl;
        }
        this.toastr.success("Thumbnail selected successfully");
      } else {
        // User cancelled - use generated thumbnail if available
        if (generatedThumbnailUrl) {
          if (source === "cover") {
            this.coverPosterPageURI = generatedThumbnailUrl;
            this.markAsChanged();
          } else if (source === "step") {
            this.stepPosterUrl = generatedThumbnailUrl;
          }
        }
      }
    });
  }

  // Video player methods for thumbnail selection
  onVideoMetadataLoaded() {
    if (this.coverVideoPlayer?.nativeElement) {
      const video = this.coverVideoPlayer.nativeElement;
      // Ensure crossOrigin is set to allow canvas extraction
      if (!video.crossOrigin) {
        video.crossOrigin = "anonymous";
      }
      this.videoDuration = video.duration;
    }
  }

  onVideoTimeUpdate() {
    if (this.coverVideoPlayer?.nativeElement) {
      this.currentVideoTime = this.coverVideoPlayer.nativeElement.currentTime;
    }
  }

  onScrubberChange(event: any) {
    const time = parseFloat(event.target.value);
    if (this.coverVideoPlayer?.nativeElement) {
      this.coverVideoPlayer.nativeElement.currentTime = time;
      this.currentVideoTime = time;
    }
  }

  formatTime(seconds: number): string {
    if (!seconds || isNaN(seconds)) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  }

  captureFrameFromVideo() {
    // Temporarily disabled manual frame capture due to CORS issues
    return;
  }

  private performFrameCapture(video: HTMLVideoElement) {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");

      if (ctx) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
          if (blob) {
            const file = new File([blob], "thumbnail.png", {
              type: "image/png",
            });
            this.customCoverThumbnailFile = file;
            const reader = new FileReader();
            reader.onload = (e: any) => {
              this.customCoverThumbnailUrl = e.target.result;
              this.thumbnailSelectionMode = "upload";
              // Auto-upload the captured frame
              this.uploadCustomCoverThumbnail();
            };
            reader.readAsDataURL(file);
          }
        }, "image/png");
      }
    } catch (error) {
      console.error("Error capturing frame:", error);
      this.toastr.error(
        "Unable to capture frame. The video may not support cross-origin access. Please ensure CORS is enabled on the video server."
      );
    }
  }

  selectAutoThumbnail(thumbnailUrl: string) {
    this.coverPosterPageURI = thumbnailUrl;
    this.selectedAutoThumbnailUrl = thumbnailUrl;
    this.thumbnailSelectionMode = "auto";
    this.markAsChanged();

    // Convert the data URL to a File object for upload
    this.convertDataUrlToFile(thumbnailUrl).then((file) => {
      this.selectedAutoThumbnailFile = file;
    });

    this.toastr.success("Thumbnail selected. Click 'Upload' to save it.");
  }

  // Extract first 3 frames from the uploaded video
  extractFirstThreeFrames() {
    // Temporarily disabled automatic frame extraction due to CORS issues
    return;
  }

  private performFrameExtraction(video: HTMLVideoElement) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      return;
    }

    this.isCoverThumbnailLoading = true;
    this.coverThumbnails = [];

    // Wait for video to be ready
    const extractFrames = () => {
      if (
        video.readyState >= 2 &&
        video.videoWidth > 0 &&
        video.videoHeight > 0
      ) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const duration = video.duration || 0;
        if (duration === 0 || isNaN(duration)) {
          this.isCoverThumbnailLoading = false;
          this.coverThumbnailError = "Unable to read video duration";
          return;
        }

        const frameCount = 3;
        const extractedFrames: string[] = [];
        let framesExtracted = 0;
        let hasError = false;

        // Extract frames at evenly spaced intervals from the first portion
        // Get frames at: 10%, 20%, 30% of video duration (or first 3 seconds if video is short)
        const maxTime = Math.min(duration, 3); // Use first 3 seconds or full duration if shorter
        const timeIntervals = [];
        for (let i = 0; i < frameCount; i++) {
          const time = (maxTime / (frameCount + 1)) * (i + 1);
          timeIntervals.push(Math.max(0.1, time)); // Ensure at least 0.1 seconds
        }

        // Store original time to restore later
        const originalTime = video.currentTime;

        timeIntervals.forEach((time, index) => {
          video.currentTime = time;

          const onSeeked = () => {
            try {
              ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
              const dataUrl = canvas.toDataURL("image/png");
              extractedFrames[index] = dataUrl;
              framesExtracted++;

              if (framesExtracted === frameCount) {
                // Restore original video time
                video.currentTime = originalTime;

                if (hasError && extractedFrames.length === 0) {
                  this.coverThumbnailError =
                    "Unable to extract frames from video. Please ensure CORS is enabled on the video server.";
                } else {
                  this.coverThumbnails = extractedFrames;

                  // Set first frame as default if no poster is set
                  if (!this.coverPosterPageURI && extractedFrames[0]) {
                    this.coverPosterPageURI = extractedFrames[0];
                    this.selectedAutoThumbnailUrl = extractedFrames[0];
                    this.convertDataUrlToFile(extractedFrames[0]).then(
                      (file) => {
                        this.selectedAutoThumbnailFile = file;
                      }
                    );
                  }
                }
                this.isCoverThumbnailLoading = false;
              }
            } catch (error) {
              console.error("Error extracting frame:", error);
              hasError = true;
              framesExtracted++;
              if (framesExtracted === frameCount) {
                video.currentTime = originalTime;
                this.isCoverThumbnailLoading = false;
                if (extractedFrames.length > 0) {
                  this.coverThumbnails = extractedFrames;
                } else {
                  this.coverThumbnailError =
                    "Unable to extract frames from video. Please ensure CORS is enabled on the video server.";
                }
              }
            }

            video.removeEventListener("seeked", onSeeked);
          };

          video.addEventListener("seeked", onSeeked, { once: true });
        });
      } else {
        // Wait a bit and try again
        setTimeout(extractFrames, 100);
      }
    };

    // Ensure video metadata is loaded
    if (video.readyState >= 2) {
      extractFrames();
    } else {
      const onLoadedMetadata = () => {
        extractFrames();
        video.removeEventListener("loadedmetadata", onLoadedMetadata);
      };
      video.addEventListener("loadedmetadata", onLoadedMetadata, {
        once: true,
      });

      // Also try after a delay in case event doesn't fire
      setTimeout(() => {
        if (this.isCoverThumbnailLoading) {
          extractFrames();
        }
      }, 1000);
    }
  }

  // Convert data URL to File object
  async convertDataUrlToFile(dataUrl: string): Promise<File> {
    const response = await fetch(dataUrl);
    const blob = await response.blob();
    return new File([blob], "thumbnail.png", { type: "image/png" });
  }

  // Upload the selected auto-generated thumbnail
  uploadSelectedAutoThumbnail() {
    if (!this.selectedAutoThumbnailFile && !this.selectedAutoThumbnailUrl) {
      this.toastr.warning("Please select a thumbnail first");
      return;
    }

    // If we have a file, use it; otherwise convert the data URL
    const uploadFile = async () => {
      let fileToUpload = this.selectedAutoThumbnailFile;

      if (!fileToUpload && this.selectedAutoThumbnailUrl) {
        fileToUpload = await this.convertDataUrlToFile(
          this.selectedAutoThumbnailUrl
        );
      }

      if (!fileToUpload) {
        this.toastr.error("Unable to prepare thumbnail for upload");
        return;
      }

      this.customCoverThumbnailUploading = true;
      this.coverThumbnailUploadProgress = 0;

      const formData = new FormData();
      formData.append("fileData", fileToUpload);

      this.http
        .post(environment.apiBaseUrl + environment.uploadImageUrl, formData, {
          reportProgress: true,
          observe: "events",
        })
        .subscribe({
          next: (event: any) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.coverThumbnailUploadProgress = Math.round(
                (100 * event.loaded) / event.total
              );
            } else if (event.type === HttpEventType.Response) {
              const uploadedFileName =
                event.body?.fileName || event.body?.data?.fileName;
              if (uploadedFileName) {
                this.customCoverThumbnailUrl =
                  this.resolveImageUrl(uploadedFileName);
                this.coverPosterPageURI = this.customCoverThumbnailUrl;
                this.thumbnailSelectionMode = "auto";
                this.selectedAutoThumbnailFile = null;
                this.selectedAutoThumbnailUrl = "";
                this.customCoverThumbnailUploading = false;
                this.toastr.success("Thumbnail uploaded successfully");
                this.markAsChanged();
                this.closeThumbnailDialog();
              }
            }
          },
          error: () => {
            this.customCoverThumbnailUploading = false;
            this.toastr.error("Failed to upload thumbnail");
          },
        });
    };

    uploadFile();
  }

  onCustomCoverThumbnailSelect(event: any) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      // Check file size (max 2MB)
      if (file.size > 2 * 1024 * 1024) {
        this.toastr.warning("File size must be less than 2MB");
        return;
      }
      this.customCoverThumbnailFile = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.customCoverThumbnailUrl = e.target.result;
        this.thumbnailSelectionMode = "upload";
        this.uploadCustomCoverThumbnail();
      };
      reader.readAsDataURL(this.customCoverThumbnailFile);
    }
  }

  uploadCustomCoverThumbnail() {
    if (!this.customCoverThumbnailFile) {
      this.toastr.warning("Please select a thumbnail image");
      return;
    }

    this.customCoverThumbnailUploading = true;
    this.coverThumbnailUploadProgress = 0;
    const formData = new FormData();
    formData.append("fileData", this.customCoverThumbnailFile);

    this.http
      .post(environment.apiBaseUrl + environment.uploadImageUrl, formData, {
        reportProgress: true,
        observe: "events",
      })
      .subscribe(
        (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              if (event.total) {
                this.coverThumbnailUploadProgress = Math.round(
                  (event.loaded / event.total) * 100
                );
              }
              break;
            case HttpEventType.Response:
              const response = event.body;
              if (response && response.fileName) {
                this.customCoverThumbnailUrl =
                  environment.imageStorageBaseUrl + response.fileName;
                this.coverPosterPageURI = this.customCoverThumbnailUrl;
                this.thumbnailSelectionMode = "upload";
                this.customCoverThumbnailFile = null;
                this.customCoverThumbnailUploading = false;
                this.toastr.success("Custom thumbnail uploaded successfully");
                this.markAsChanged();
              }
              break;
          }
        },
        (error) => {
          this.customCoverThumbnailUploading = false;
          this.toastr.error("Failed to upload thumbnail");
          console.error("Upload error:", error);
        }
      );
  }

  openThumbnailDialog(mode: "upload" | "compare") {
    this.thumbnailDialogMode = mode;
    this.setThumbnailSelectionMode(mode);
    this.isThumbnailDialogOpen = true;

    // Reset selected thumbnail when opening dialog
    if (mode === "upload") {
      this.selectedUploadFrameIndex = -1;
      this.coverThumbnails = []; // Clear previous frames
      this.isCoverThumbnailLoading = false;
      this.coverThumbnailError = "";
    }

    // Frame extraction temporarily disabled
  }

  closeThumbnailDialog() {
    this.isThumbnailDialogOpen = false;
    // Reset selected thumbnail when dialog closes (optional - you may want to keep it)
    // this.selectedAutoThumbnailUrl = "";
    // this.selectedAutoThumbnailFile = null;
  }

  openFaqModal(faq: any, groupName: string) {
    this.selectedFaq = faq;
    this.selectedFaqGroup = groupName;
    this.isFaqModalOpen = true;
  }

  closeFaqModal() {
    this.isFaqModalOpen = false;
    this.selectedFaq = null;
    this.selectedFaqGroup = "";
  }

  setThumbnailSelectionMode(mode: "auto" | "upload" | "compare") {
    this.thumbnailSelectionMode = mode;
  }

  triggerThumbnailUploadDialog() {
    this.thumbnailSelectionMode = "upload";
    if (this.thumbnailUploadInput) {
      this.thumbnailUploadInput.nativeElement.value = "";
      this.thumbnailUploadInput.nativeElement.click();
    }
  }

  // Select an extracted frame in upload mode
  selectUploadFrame(frameIndex: number) {
    if (frameIndex >= 0 && frameIndex < this.coverThumbnails.length) {
      this.selectedUploadFrameIndex = frameIndex;
    }
  }

  // Use selected extracted frame as poster in upload mode
  useSelectedUploadFrame() {
    if (this.selectedUploadFrameIndex >= 0 && this.selectedUploadFrameIndex < this.coverThumbnails.length) {
      const selectedFrame = this.coverThumbnails[this.selectedUploadFrameIndex];
      // Convert data URL to file and upload it
      this.convertDataUrlToFile(selectedFrame).then((file) => {
        this.customCoverThumbnailFile = file;
        this.customCoverThumbnailUrl = selectedFrame;
        this.uploadCustomCoverThumbnail();
      });
    }
  }

  // Step thumbnail methods
  onStepVideoMetadataLoaded() {
    if (this.stepVideoPlayer?.nativeElement) {
      const video = this.stepVideoPlayer.nativeElement;
      // Ensure crossOrigin is set to allow canvas extraction
      if (!video.crossOrigin) {
        video.crossOrigin = "anonymous";
        // Reload video if crossOrigin was just set
        const currentSrc = video.src;
        video.src = "";
        video.src = currentSrc;
      }
      this.stepVideoDuration = video.duration;
    }
  }

  onStepVideoTimeUpdate() {
    if (this.stepVideoPlayer?.nativeElement) {
      this.currentStepVideoTime =
        this.stepVideoPlayer.nativeElement.currentTime;
    }
  }

  onStepScrubberChange(event: any) {
    const time = parseFloat(event.target.value);
    if (this.stepVideoPlayer?.nativeElement) {
      this.stepVideoPlayer.nativeElement.currentTime = time;
      this.currentStepVideoTime = time;
    }
  }

  captureFrameFromStepVideo() {
    if (!this.stepVideoPlayer?.nativeElement) {
      return;
    }

    const video = this.stepVideoPlayer.nativeElement;

    // Ensure crossOrigin is set to allow canvas extraction
    if (!video.crossOrigin) {
      video.crossOrigin = "anonymous";
      // If crossOrigin wasn't set before, we need to reload the video
      const currentSrc = video.src;
      video.src = "";
      video.src = currentSrc;
      // Wait for video to reload before capturing
      video.addEventListener(
        "loadedmetadata",
        () => {
          this.performStepFrameCapture(video);
        },
        { once: true }
      );
      return;
    }

    this.performStepFrameCapture(video);
  }

  private performStepFrameCapture(video: HTMLVideoElement) {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");

      if (ctx) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
          if (blob) {
            const file = new File([blob], "thumbnail.png", {
              type: "image/png",
            });
            this.customStepThumbnailFile = file;
            const reader = new FileReader();
            reader.onload = (e: any) => {
              this.customStepThumbnailUrl = e.target.result;
              this.stepThumbnailSelectionMode = "upload";
              // Auto-upload the captured frame
              this.uploadCustomStepThumbnail();
            };
            reader.readAsDataURL(file);
          }
        }, "image/png");
      }
    } catch (error) {
      console.error("Error capturing frame:", error);
      this.toastr.error(
        "Unable to capture frame. The video may not support cross-origin access. Please ensure CORS is enabled on the video server."
      );
    }
  }

  selectStepAutoThumbnail(thumbnailUrl: string) {
    this.stepPosterUrl = thumbnailUrl;
    this.selectedStepAutoThumbnailUrl = thumbnailUrl;
    this.stepThumbnailSelectionMode = "auto";

    // Convert the data URL to a File object for upload
    this.convertDataUrlToFile(thumbnailUrl).then((file) => {
      this.selectedStepAutoThumbnailFile = file;
    });

    this.toastr.success("Thumbnail selected. Click 'Upload' to save it.");
  }

  // Extract first 3 frames from the step video
  extractFirstThreeStepFrames() {
    if (!this.stepVideoPlayer?.nativeElement || !this.stepImageUrl) {
      return;
    }

    const video = this.stepVideoPlayer.nativeElement;

    // Ensure crossOrigin is set to allow canvas extraction
    if (!video.crossOrigin) {
      video.crossOrigin = "anonymous";
      // If crossOrigin wasn't set before, we need to reload the video
      const currentSrc = video.src;
      video.src = "";
      video.src = currentSrc;
      // Wait for video to reload before extracting frames
      video.addEventListener(
        "loadedmetadata",
        () => {
          this.performStepFrameExtraction(video);
        },
        { once: true }
      );
      return;
    }

    this.performStepFrameExtraction(video);
  }

  private performStepFrameExtraction(video: HTMLVideoElement) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      return;
    }

    this.isStepThumbnailLoading = true;
    this.stepThumbnails = [];

    // Wait for video to be ready
    const extractFrames = () => {
      if (
        video.readyState >= 2 &&
        video.videoWidth > 0 &&
        video.videoHeight > 0
      ) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const duration = video.duration || 0;
        if (duration === 0 || isNaN(duration)) {
          this.isStepThumbnailLoading = false;
          this.stepThumbnailError = "Unable to read video duration";
          return;
        }

        const frameCount = 3;
        const extractedFrames: string[] = [];
        let framesExtracted = 0;

        // Extract frames at evenly spaced intervals from the first portion
        // Get frames at: 10%, 20%, 30% of video duration (or first 3 seconds if video is short)
        const maxTime = Math.min(duration, 3); // Use first 3 seconds or full duration if shorter
        const timeIntervals = [];
        for (let i = 0; i < frameCount; i++) {
          const time = (maxTime / (frameCount + 1)) * (i + 1);
          timeIntervals.push(Math.max(0.1, time)); // Ensure at least 0.1 seconds
        }

        // Store original time to restore later
        const originalTime = video.currentTime;

        timeIntervals.forEach((time, index) => {
          video.currentTime = time;

          const onSeeked = () => {
            try {
              ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
              const dataUrl = canvas.toDataURL("image/png");
              extractedFrames[index] = dataUrl;
              framesExtracted++;

              if (framesExtracted === frameCount) {
                // Restore original video time
                video.currentTime = originalTime;

                this.stepThumbnails = extractedFrames;
                this.isStepThumbnailLoading = false;

                // Set first frame as default if no poster is set
                if (!this.stepPosterUrl && extractedFrames[0]) {
                  this.stepPosterUrl = extractedFrames[0];
                  this.selectedStepAutoThumbnailUrl = extractedFrames[0];
                  this.convertDataUrlToFile(extractedFrames[0]).then((file) => {
                    this.selectedStepAutoThumbnailFile = file;
                  });
                }
              }
            } catch (error) {
              console.error("Error extracting frame:", error);
              framesExtracted++;
              if (framesExtracted === frameCount) {
                video.currentTime = originalTime;
                this.isStepThumbnailLoading = false;
                if (extractedFrames.length > 0) {
                  this.stepThumbnails = extractedFrames;
                } else {
                  this.stepThumbnailError =
                    "Unable to extract frames from video";
                }
              }
            }

            video.removeEventListener("seeked", onSeeked);
          };

          video.addEventListener("seeked", onSeeked, { once: true });
        });
      } else {
        // Wait a bit and try again
        setTimeout(extractFrames, 100);
      }
    };

    // Ensure video metadata is loaded
    if (video.readyState >= 2) {
      extractFrames();
    } else {
      const onLoadedMetadata = () => {
        extractFrames();
        video.removeEventListener("loadedmetadata", onLoadedMetadata);
      };
      video.addEventListener("loadedmetadata", onLoadedMetadata, {
        once: true,
      });

      // Also try after a delay in case event doesn't fire
      setTimeout(() => {
        if (this.isStepThumbnailLoading) {
          extractFrames();
        }
      }, 1000);
    }
  }

  // Upload the selected auto-generated step thumbnail
  uploadSelectedStepAutoThumbnail() {
    if (
      !this.selectedStepAutoThumbnailFile &&
      !this.selectedStepAutoThumbnailUrl
    ) {
      this.toastr.warning("Please select a thumbnail first");
      return;
    }

    // If we have a file, use it; otherwise convert the data URL
    const uploadFile = async () => {
      let fileToUpload = this.selectedStepAutoThumbnailFile;

      if (!fileToUpload && this.selectedStepAutoThumbnailUrl) {
        fileToUpload = await this.convertDataUrlToFile(
          this.selectedStepAutoThumbnailUrl
        );
      }

      if (!fileToUpload) {
        this.toastr.error("Unable to prepare thumbnail for upload");
        return;
      }

      this.customStepThumbnailUploading = true;
      this.stepThumbnailUploadProgress = 0;

      const formData = new FormData();
      formData.append("fileData", fileToUpload);

      this.http
        .post(environment.apiBaseUrl + environment.uploadImageUrl, formData, {
          reportProgress: true,
          observe: "events",
        })
        .subscribe({
          next: (event: any) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.stepThumbnailUploadProgress = Math.round(
                (100 * event.loaded) / event.total
              );
            } else if (event.type === HttpEventType.Response) {
              const uploadedFileName =
                event.body?.fileName || event.body?.data?.fileName;
              if (uploadedFileName) {
                this.customStepThumbnailUrl =
                  this.resolveImageUrl(uploadedFileName);
                this.stepPosterUrl = this.customStepThumbnailUrl;
                this.stepThumbnailSelectionMode = "auto";
                this.selectedStepAutoThumbnailFile = null;
                this.selectedStepAutoThumbnailUrl = "";
                this.customStepThumbnailUploading = false;
                this.toastr.success("Thumbnail uploaded successfully");
                this.closeStepThumbnailDialog();
              }
            }
          },
          error: () => {
            this.customStepThumbnailUploading = false;
            this.toastr.error("Failed to upload thumbnail");
          },
        });
    };

    uploadFile();
  }

  onCustomStepThumbnailSelect(event: any) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      // Check file size (max 2MB)
      if (file.size > 2 * 1024 * 1024) {
        this.toastr.warning("File size must be less than 2MB");
        return;
      }
      this.customStepThumbnailFile = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.customStepThumbnailUrl = e.target.result;
        this.stepThumbnailSelectionMode = "upload";
        // Automatically upload when file is selected
        this.uploadCustomStepThumbnail();
      };
      reader.readAsDataURL(this.customStepThumbnailFile);
    }
  }

  uploadCustomStepThumbnail() {
    if (!this.customStepThumbnailFile) {
      this.toastr.warning("Please select a thumbnail image");
      return;
    }

    this.customStepThumbnailUploading = true;
    this.stepThumbnailUploadProgress = 0;
    const formData = new FormData();
    formData.append("fileData", this.customStepThumbnailFile);

    this.http
      .post(environment.apiBaseUrl + environment.uploadImageUrl, formData, {
        reportProgress: true,
        observe: "events",
      })
      .subscribe(
        (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              if (event.total) {
                this.stepThumbnailUploadProgress = Math.round(
                  (event.loaded / event.total) * 100
                );
              }
              break;
            case HttpEventType.Response:
              const response = event.body;
              if (response && response.fileName) {
                this.customStepThumbnailUrl =
                  environment.imageStorageBaseUrl + response.fileName;
                this.stepPosterUrl = this.customStepThumbnailUrl;
                this.stepThumbnailSelectionMode = "upload";
                this.customStepThumbnailFile = null;
                this.customStepThumbnailUploading = false;
                this.toastr.success("Custom thumbnail uploaded successfully");
                this.closeStepThumbnailDialog();
              }
              break;
          }
        },
        (error) => {
          this.customStepThumbnailUploading = false;
          this.toastr.error("Failed to upload thumbnail");
          console.error("Upload error:", error);
        }
      );
  }

  openStepThumbnailDialog(mode: "auto" | "upload" | "compare") {
    this.stepThumbnailDialogMode = mode;
    this.setStepThumbnailSelectionMode(mode);
    this.isStepThumbnailDialogOpen = true;

    // Reset selected thumbnail when opening dialog
    if (mode === "auto") {
      this.selectedStepAutoThumbnailUrl = "";
      this.selectedStepAutoThumbnailFile = null;
    }

    // Extract first 3 frames from video when auto mode is opened
    // Wait for dialog to render and video element to be available
    if (mode === "auto" && this.showStepVideo && this.stepImageUrl) {
      // Use multiple timeouts to ensure video element is ready
      setTimeout(() => {
        if (this.stepVideoPlayer?.nativeElement) {
          this.extractFirstThreeStepFrames();
        } else {
          // Try again after a longer delay if element not found
          setTimeout(() => {
            this.extractFirstThreeStepFrames();
          }, 500);
        }
      }, 300); // Wait for dialog animation and rendering
    }
  }

  closeStepThumbnailDialog() {
    this.isStepThumbnailDialogOpen = false;
    // Reset selected thumbnail when dialog closes (optional - you may want to keep it)
    // this.selectedStepAutoThumbnailUrl = "";
    // this.selectedStepAutoThumbnailFile = null;
  }

  setStepThumbnailSelectionMode(mode: "auto" | "upload" | "compare") {
    this.stepThumbnailSelectionMode = mode;
  }

  triggerStepThumbnailUploadDialog() {
    this.stepThumbnailSelectionMode = "upload";
    if (this.stepThumbnailUploadInput) {
      this.stepThumbnailUploadInput.nativeElement.value = "";
      this.stepThumbnailUploadInput.nativeElement.click();
    }
  }

  get currentSummaryStep() {
    // Handle Cover (-2) and Items (-1) - return null
    if (this.selectedSummaryStepIndex < 0) {
      return null;
    }
    // Handle Steps (>= 0)
    if (!this.allSteps || this.allSteps.length === 0) {
      return null;
    }
    const safeIndex = Math.min(
      Math.max(this.selectedSummaryStepIndex, 0),
      this.allSteps.length - 1
    );
    return this.allSteps[safeIndex];
  }

  get currentSummaryDescription() {
    if (this.selectedSummaryStepIndex === -2) {
      return this.description;
    } else if (this.selectedSummaryStepIndex === -1) {
      return "Check that you have all items required to complete the instruction";
    } else if (this.selectedSummaryStepIndex >= 0 && this.currentSummaryStep) {
      return this.currentSummaryStep.Description;
    }
    return "";
  }

  selectSummaryStep(index: number) {
    // Store original cover description on first access
    if (this.originalCoverDescription === "" && this.description) {
      this.originalCoverDescription = this.description;
    }

    // Allow -2 (Cover), -1 (Items), or valid step indices (>= 0)
    if (index === -2 || index === -1) {
      this.selectedSummaryStepIndex = index;
      // Update description based on selection
      if (index === -2) {
        // Cover page - restore original cover description
        this.description = this.originalCoverDescription || this.description;
      } else if (index === -1) {
        // Items page - use step text
        this.description =
          "Check that you have all items required to complete the instruction";
      }
      return;
    }
    // For steps, validate the index
    if (this.allSteps && index >= 0 && index < this.allSteps.length) {
      this.selectedSummaryStepIndex = index;
      // Update description to step description
      const step = this.allSteps[index];
      if (step && step.Description) {
        this.description = step.Description;
      } else {
        this.description = "";
      }
    }
  }

  openUrlPreviewDialog(url?: string, title?: string) {
    if (!url) {
      this.toastr.warning("No link available to preview");
      return;
    }

    if (!this.urlPreviewDialog) {
      window.open(url, "_blank");
      return;
    }

    this.dialog.open(this.urlPreviewDialog, {
      data: { url, title },
      width: "480px",
    });
  }

  copyUrlToClipboard(url?: string) {
    if (!url) {
      return;
    }

    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(() => this.toastr.success("Link copied to clipboard"))
        .catch(() => this.fallbackCopy(url));
    } else {
      this.fallbackCopy(url);
    }
  }

  private fallbackCopy(text: string) {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.top = "0";
    textarea.style.left = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
      document.execCommand("copy");
      this.toastr.success("Link copied to clipboard");
    } catch (error) {
      this.toastr.error("Unable to copy link");
    } finally {
      document.body.removeChild(textarea);
    }
  }

  uploadSupportingDocuments(event, source) {
    if (event.target.files) {
      this.noResultReturned = true;
      this.fileData = <File>event.target.files[0];
      const formData = new FormData();
      formData.append("fileData", this.fileData);

      if (
        this.fileData.name.includes("pdf") ||
        this.fileData.name.includes("PDF")
      ) {
        this.openLoadingModal("Uploading supporting document...", true);
        this.http
          .post(
            environment.apiBaseUrl + environment.uploadDocumentsUrl,
            formData,
            { reportProgress: true, observe: "events" }
          )
          .subscribe(
            (event: HttpEvent<any>) => {
              if (event.type === HttpEventType.UploadProgress) {
                if (event.total) {
                  this.updateLoadingModal(
                    undefined,
                    Math.round((event.loaded / event.total) * 100)
                  );
                }
                return;
              }
              if (event.type !== HttpEventType.Response) return;
              var mediaUploadStatus = event.body as any;
              this.noResultReturned = false;
              this.closeLoadingModal();
              if (mediaUploadStatus != null) {
                this.sffilename = mediaUploadStatus.fileName;
                this.sffilelink =
                  environment.documentsStorageBaseUrl +
                  mediaUploadStatus.fileName;
              } else {
                this.toastr.error(mediaUploadStatus.message);
              }
            },
            (error) => {
              this.closeLoadingModal();
              this.noResultReturned = false;
              this.toastr.error("Failed to upload document. Please try again.");
            }
          );
      }
    }
  }

  addSupportingDocument() {
    if (
      (this.supportingDocumentHyperLinks?.length || 0) +
        (this.supportingDocumentDocuments?.length || 0) >=
      10
    ) {
      this.toastr.warning("Maximum 10 supporting documents allowed");
      return;
    }

    if (!this.documentName || !this.sffilelink) {
      this.toastr.warning("Please enter document name and upload a file");
      return;
    }

    // Initialize array if it doesn't exist
    if (!this.supportingDocumentDocuments) {
      this.supportingDocumentDocuments = [];
    }

    var editSupportingDocumentRequiredIndex = localStorage.getItem(
      "editSupportingDocumentRequiredIndex"
    );

    if (editSupportingDocumentRequiredIndex != null) {
      this.supportingDocumentDocuments.splice(
        parseInt(editSupportingDocumentRequiredIndex),
        1
      );
      var document = {
        documentName: this.documentName,
        documentUrl: this.sffilelink,
      };

      this.supportingDocumentDocuments.splice(
        parseInt(editSupportingDocumentRequiredIndex),
        0,
        document
      );
      this.toastr.success("Document updated successfully");
    } else {
      this.supportingDocumentDocuments.push({
        documentName: this.documentName,
        documentUrl: this.sffilelink,
      });
      this.toastr.success("Document added successfully");
    }
    this.documentName = "";
    this.sffilename = "";
    this.sffilelink = "";

    localStorage.setItem(
      "SupportingDocumentDocuments",
      JSON.stringify(this.supportingDocumentDocuments)
    );
    localStorage.removeItem("editSupportingDocumentRequiredIndex");

    // Update cached count
    this._documentCount = this.supportingDocumentDocuments.length;
    this.markAsChanged();

    // Use setTimeout to batch change detection and prevent flickering
    setTimeout(() => {
      this.cdr.markForCheck();
    }, 0);
  }

  editSupportingDocument(index, document) {
    this.documentName = document.documentName;
    this.sffilelink = document.documentUrl;
    localStorage.setItem("editSupportingDocumentRequiredIndex", index);
  }

  addLink() {
    if (
      (this.supportingDocumentHyperLinks?.length || 0) +
        (this.supportingDocumentDocuments?.length || 0) >=
      10
    ) {
      this.toastr.warning("Maximum 10 supporting documents allowed");
      return;
    }

    if (!this.linkName || !this.hyperLink) {
      this.toastr.warning("Please enter both anchor text and URL");
      return;
    }

    // Initialize array if it doesn't exist
    if (!this.supportingDocumentHyperLinks) {
      this.supportingDocumentHyperLinks = [];
    }

    var editsupportingDocumentHyperLinksIndex = localStorage.getItem(
      "editsupportingDocumentHyperLinksIndex"
    );
    if (editsupportingDocumentHyperLinksIndex != null) {
      this.supportingDocumentHyperLinks.splice(
        parseInt(editsupportingDocumentHyperLinksIndex),
        1
      );
      var slink = {
        linkName: this.linkName,
        linkUrl: this.hyperLink,
      };
      this.supportingDocumentHyperLinks.splice(
        parseInt(editsupportingDocumentHyperLinksIndex),
        0,
        slink
      );
      this.toastr.success("Link updated successfully");
    } else {
      this.supportingDocumentHyperLinks.push({
        linkName: this.linkName,
        linkUrl: this.hyperLink,
      });
      this.toastr.success("Link added successfully");
    }
    this.linkName = "";
    this.hyperLink = "";
    localStorage.setItem(
      "SupportingDocumentHyperLinksRequired",
      JSON.stringify(this.supportingDocumentHyperLinks)
    );
    localStorage.removeItem("editsupportingDocumentHyperLinksIndex");

    // Update cached count
    this._hyperlinkCount = this.supportingDocumentHyperLinks.length;
    this.markAsChanged();

    // Use setTimeout to batch change detection and prevent flickering
    setTimeout(() => {
      this.cdr.markForCheck();
    }, 0);
  }

  trackByDocumentId(index: number, item: any): any {
    return item.documentUrl || index;
  }

  trackByLinkId(index: number, item: any): any {
    return item.linkUrl || index;
  }

  private _documentCount: number = 0;
  private _hyperlinkCount: number = 0;

  getDocumentCount(): number {
    const count = this.supportingDocumentDocuments?.length || 0;
    if (count !== this._documentCount) {
      this._documentCount = count;
    }
    return this._documentCount;
  }

  getHyperLinkCount(): number {
    const count = this.supportingDocumentHyperLinks?.length || 0;
    if (count !== this._hyperlinkCount) {
      this._hyperlinkCount = count;
    }
    return this._hyperlinkCount;
  }

  editLink(index, link) {
    this.linkName = link.linkName;
    this.hyperLink = link.linkUrl;
    localStorage.setItem("editsupportingDocumentHyperLinksIndex", index);
  }

  dropSupportingDocuments(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.supportingDocumentDocuments,
      event.previousIndex,
      event.currentIndex
    );
  }

  tabChanged(tabChangedEvent) {
    // Update tab index to prevent flickering
    this.tabIndex = tabChangedEvent.index;
    // Use setTimeout to batch change detection
    setTimeout(() => {
      this.cdr.markForCheck();
    }, 0);
  }

  openRephraseDialog() {
    const dialogRef = this.dialog.open(SelectionRephraseAIComponent, {
      width: "400px",
      data: { textToRephrase: this.title },
    });
    if (!this.isTitleRephrased) {
      this.originalTitleText = this.title;
    }
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isTitleRephraseInProgress = true;
        this.title = result.rephrasedText;
        this.isTitleRephrased = true;
      }
    });
  }

  goToOriginalTitleText() {
    this.title = this.originalTitleText;
    this.isTitleRephrased = false;
  }

  openDescriptionRephraseDialog() {
    const dialogRef = this.dialog.open(SelectionRephraseAIComponent, {
      width: "400px",
      data: { textToRephrase: this.description },
    });
    if (!this.isRephrased) {
      this.originalContentTitleText = this.description;
    }
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isRephraseInProgress = true;
        this.description = result.rephrasedText;
        this.isRephrased = true;
      }
    });
  }

  goToOriginalText() {
    this.description = this.originalContentTitleText;
    this.isRephrased = false;
  }

  saveCoverPageData() {
    if (!this.coverImageUri) {
      this.toastr.info("Cover image/video missing");
      return;
    }

    if (!this.description || this.description.trim() === "") {
      this.toastr.info("Cover description missing");
      return;
    }

    // Validate safety critical cover
    if (this.coverIsSafetyCritical) {
      if (!this.coverSafetyInstructionsTitle || this.coverSafetyInstructionsTitle.trim().length === 0) {
        this.toastr.warning("Safety instructions title is required for safety critical cover.");
        return;
      }
      if (!this.coverSafetyInstructionsDescription || this.coverSafetyInstructionsDescription.trim().length === 0) {
        this.toastr.warning("Safety instructions description is required for safety critical cover.");
        return;
      }
    }

    // Update cover image/video display flags
    this.isCoverAImageOrVideo(this.coverImageUri);

    var flowCoverPage = {
      coverImage: this.coverImageUri,
      description: this.description,
      coverPosterPageURI: this.coverPosterPageURI,
      title: this.title,
      flowId: this.flowId,
      uniqueId: this.uniqueId,
      type: this.resolveFlowType(),
      duration: this.duration || 0,
      durationUnit: this.durationUnit || 'Mins',
      fileName: this.fileName,
      price: this.price,
      isPaid: this.isPaid,
      rowKey: this.rowKey,
      customerEmail: this.partitionKey || this.userData?.emailAddress,
      searchKeyWords: Array.isArray(this.searchKeyWords)
        ? this.searchKeyWords.join(", ")
        : this.searchKeyWords ?? "",
      coverIsSafetyCritical: this.coverIsSafetyCritical || false,
      coverSafetyInstructionsTitle: this.coverSafetyInstructionsTitle || "",
      coverSafetyInstructionsDescription: this.coverSafetyInstructionsDescription || "",
      endQuestionForm: this.endQuestionForm,
    };

    localStorage.setItem("flowCoverPageDetails", JSON.stringify(flowCoverPage));
    this.refreshFlowData();
    this.toastr.success("Cover page details saved successfully");
  }

  // Items methods
  onSelectItemGroup(event: MatAutocompleteSelectedEvent) {
    const selectedValue = event.option.value;
    this.itemGroupName = selectedValue;
    
    // Check if it's from library
    const libraryItem = this.libraryGroupSuggestions.find(
      item => item.groupName === selectedValue
    );
    if (libraryItem) {
      // Optionally populate item name if there's only one item in this group
    }
  }

  getAllItemGroupName() {
    const groups = new Set<string>();
    if (this.inames && this.inames.length > 0) {
      this.inames.forEach((item) => {
        if (item.groupName) {
          groups.add(item.groupName);
        }
      });
    }
    // Merge with library groups if any
    if (this.libraryGroupSuggestions && this.libraryGroupSuggestions.length > 0) {
      this.libraryGroupSuggestions.forEach((item) => {
        if (item.groupName) {
          groups.add(item.groupName);
        }
      });
    }
    this.itemGroupList = Array.from(groups);
  }

  setupLibrarySearch() {
    // Search library when group name is typed (server-side search for performance)
    // This avoids loading all 10,000+ items and only searches when user types
    this.groupNameInput$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term: string) => {
        if (term && term.trim().length >= 2) {
          return this.itemLibraryService.searchItemLibraries({ groupName: term.trim() });
        }
        this.libraryGroupSuggestions = [];
        return of([]);
      }),
      catchError((error) => {
        console.error('Error searching library groups:', error);
        this.libraryGroupSuggestions = [];
        return of([]);
      })
    ).subscribe((results: ItemLibraryModel[]) => {
      // Backend already expands metadataList entries, so use results directly
      // Extract unique group names from results (already expanded from metadataList)
      // Use Set to ensure no duplicates
      const uniqueGroups = [...new Set(results.map(item => item.groupName).filter(g => g))];
      this.libraryGroupSuggestions = uniqueGroups.map(groupName => ({
        groupName: groupName
      } as ItemLibraryModel));
      this.cdr.detectChanges();
    });

    // Search library when item name is typed (server-side search for performance)
    // This avoids loading all 10,000+ items and only searches when user types
    this.itemNameInput$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term: string) => {
        if (term && term.trim().length >= 2) {
          return this.itemLibraryService.searchItemLibraries({ itemName: term.trim() });
        }
        this.libraryItemSuggestions = [];
        return of([]);
      }),
      catchError((error) => {
        console.error('Error searching library items:', error);
        this.libraryItemSuggestions = [];
        return of([]);
      })
    ).subscribe((results: ItemLibraryModel[]) => {
      // Backend already expands metadataList entries, so use results directly
      // Filter to ensure we only show items with required fields
      // Deduplicate by itemName + groupName + link combination to avoid duplicates
      const seen = new Set<string>();
      this.libraryItemSuggestions = results.filter(item => {
        if (!item.itemName || !item.groupName) return false;
        const key = `${item.itemName}|${item.groupName}|${item.link || ''}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
      this.cdr.detectChanges();
    });
  }

  onGroupNameInput(value: string) {
    this.itemGroupName = value;
    // Only trigger search if user has typed at least 2 characters (optimized for large datasets)
    if (value && value.trim().length >= 2) {
      this.groupNameInput$.next(value);
    } else {
      // Clear suggestions if less than 2 characters
      this.libraryGroupSuggestions = [];
      this.cdr.detectChanges();
    }
  }

  onItemNameInput(value: string) {
    this.itemName = value;
    // Only trigger search if user has typed at least 2 characters (optimized for large datasets)
    if (value && value.trim().length >= 2) {
      this.itemNameInput$.next(value);
    } else {
      // Clear suggestions if less than 2 characters
      this.libraryItemSuggestions = [];
      this.cdr.detectChanges();
    }
  }

  onItemNameFocus() {
    // Don't load all items on focus - wait for user to type at least 2 characters
    // This optimizes performance for large libraries (10,000+ items)
    // User needs to type to see suggestions
    if (this.itemName && this.itemName.trim().length >= 2) {
      // If there's already text, trigger search
      this.itemNameInput$.next(this.itemName);
    } else {
      // Clear suggestions if field is empty
      this.libraryItemSuggestions = [];
      this.cdr.detectChanges();
    }
  }

  displayGroupName(group: string): string {
    return group || '';
  }

  displayItemName(item: any): string {
    if (!item) return '';
    if (typeof item === 'string') return item;
    if (item.isNewItem) return item.displayText || item.itemName || '';
    return item.itemName || item.itemkey || '';
  }

  selectLibraryItem(item: ItemLibraryModel) {
    if (item) {
      this.selectedLibraryItem = item;
      this.itemGroupName = item.groupName || "";
      this.itemName = item.itemName || "";
      this.itemWhereToFindIt = item.link || "";
      this.itemImageUrl = item.imageUrl || "";
      if (item.imageUrl) {
        this.showItemImage = true;
      }
    }
  }

  // Step item tagging methods
  setupStepItemSearch() {
    this.stepItemInput$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term: string) => {
        if (term && term.trim().length >= 2) {
          // Get user email for library search
          const userEmail = this.userData?.emailAddress || '';
          
          // Search both library items and user's items
          const librarySearch = this.itemLibraryService.searchItemLibraries({ 
            itemName: term.trim(),
            userEmail: userEmail
          });
          
          // Combine with user's items from inames
          const userItems = of(
            (this.inames || []).filter(item => 
              (item.itemkey || item.itemName || "").toLowerCase().includes(term.toLowerCase().trim())
            )
          );
          
          return librarySearch.pipe(
            switchMap(libraryResults => {
              return userItems.pipe(
                switchMap(userResults => {
                  // Combine and deduplicate
                  const allResults = [...libraryResults, ...userResults];
                  const seen = new Set<string>();
                  const filteredResults = allResults.filter(item => {
                    const itemName = item.itemName || item.itemkey || "";
                    const key = `${itemName}|${item.groupName || ''}|${item.link || item.wheretofindit || ''}`;
                    if (seen.has(key)) return false;
                    seen.add(key);
                    return true;
                  });
                  
                  // Add "Add new item" option if no results found
                  if (filteredResults.length === 0) {
                    return of([{ 
                      isNewItem: true, 
                      itemName: term.trim(),
                      displayText: `Add "${term.trim()}" as new item`
                    }]);
                  }
                  
                  return of(filteredResults);
                })
              );
            })
          );
        }
        this.stepItemSuggestions = [];
        return of([]);
      }),
      catchError((error) => {
        console.error('Error searching items for step:', error);
        // On error, still show "Add new item" option
        if (this.stepItemSearch && this.stepItemSearch.trim().length >= 2) {
          this.stepItemSuggestions = [{ 
            isNewItem: true, 
            itemName: this.stepItemSearch.trim(),
            displayText: `Add "${this.stepItemSearch.trim()}" as new item`
          }];
        } else {
          this.stepItemSuggestions = [];
        }
        return of(this.stepItemSuggestions);
      })
    ).subscribe((results: any[]) => {
      this.stepItemSuggestions = results || [];
      this.cdr.detectChanges();
    });
  }

  onStepItemSearch(value: string) {
    this.stepItemSearch = value;
    if (value && value.trim().length >= 2) {
      this.stepItemInput$.next(value);
    } else {
      this.stepItemSuggestions = [];
      this.cdr.detectChanges();
    }
  }

  tagItemToStep(item: any) {
    if (!item) return;
    
    // Handle "Add new item" option
    if (item.isNewItem) {
      this.openAddNewItemDialog(item.itemName);
      return;
    }
    
    // Check if item is already tagged
    const itemName = item.itemName || item.itemkey || "";
    const isAlreadyTagged = this.stepTaggedItems.some(tagged => 
      (tagged.itemName || tagged.itemkey) === itemName
    );
    
    if (!isAlreadyTagged) {
      // Add item to tagged items with normalized structure
      const taggedItem: any = {
        itemName: item.itemName || item.itemkey || item.itemKey || "",
        itemKey: item.itemkey || item.itemKey || item.itemName || "",
        groupName: item.groupName || "",
        link: item.link || item.wheretofindit || item.whereToFindIt || "",
        imageUrl: item.imageUrl || item.url || "",
        itemValue: item.itemValue || item.quantity || ""
      };
      
      // Remove empty properties to keep structure clean
      Object.keys(taggedItem).forEach(key => {
        if (taggedItem[key] === "" || taggedItem[key] === null || taggedItem[key] === undefined) {
          delete taggedItem[key];
        }
      });
      
      this.stepTaggedItems.push(taggedItem);
      this.stepItemSearch = "";
      this.stepItemSuggestions = [];
      this.cdr.detectChanges();
    } else {
      this.toastr.info("Item is already tagged to this step");
    }
  }

  // Open dialog to add new item with options to save to items list and/or library
  openAddNewItemDialog(itemName: string) {
    const dialogRef = this.dialog.open(AddNewItemDialogComponent, {
      width: '600px',
      maxWidth: '90vw',
      data: {
        itemName: itemName || '',
        itemGroupList: this.itemGroupList,
        userData: this.userData
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const newItem = {
          itemName: result.itemName || '',
          itemkey: result.itemName || '',
          itemKey: result.itemName || '',
          itemValue: result.itemQuantity || '',
          quantity: result.itemQuantity || '',
          groupName: result.itemGroupName || '',
          link: result.itemWhereToFindIt || '',
          wheretofindit: result.itemWhereToFindIt || '',
          imageUrl: result.imageUrl || '',
          url: result.imageUrl || ''
        };

        // Remove empty properties
        Object.keys(newItem).forEach(key => {
          if (newItem[key] === '' || newItem[key] === null || newItem[key] === undefined) {
            delete newItem[key];
          }
        });

        // Save to items list if requested
        if (result.saveToItemsList) {
          if (!this.inames) {
            this.inames = [];
          }
          this.inames.push({
            itemkey: newItem.itemName,
            itemValue: newItem.itemValue || '',
            url: newItem.imageUrl || '',
            wheretofindit: newItem.link || '',
            groupName: newItem.groupName || ''
          });
          localStorage.setItem("ItemsRequired", JSON.stringify(this.inames));
          this.groupDataByGroupName();
          this.getAllItemGroupName();
          this.markAsChanged();
        }

        // Save to library if requested
        if (result.saveToLibrary && this.userData) {
          const libraryItem: ItemLibraryModel = {
            itemName: newItem.itemName,
            groupName: newItem.groupName || '',
            link: newItem.link || '',
            imageUrl: newItem.imageUrl || '',
            isPublic: false, // Default to private for regular users
            createdBy: this.userData.emailAddress
          };

          this.itemLibraryService.createItemLibrary(libraryItem).subscribe(
            (savedItem) => {
              this.toastr.success('Item saved to library successfully');
            },
            (error) => {
              console.error('Error saving item to library:', error);
              this.toastr.error('Failed to save item to library');
            }
          );
        }

        // Add to tagged items
        this.stepTaggedItems.push(newItem);
        this.stepItemSearch = "";
        this.stepItemSuggestions = [];
        this.cdr.detectChanges();
        
        this.toastr.success('Item added successfully');
      }
    });
  }

  removeTaggedItem(index: number, event: Event) {
    event.stopPropagation(); // Prevent chip click from firing
    this.stepTaggedItems.splice(index, 1);
    this.cdr.detectChanges();
  }

  openItemDetailsDialog(item: any) {
    // Open dialog to show item details
    const dialogRef = this.dialog.open(ItemDetailsDialogComponent, {
      width: '600px',
      maxWidth: '90vw',
      data: {
        itemName: item.itemName || item.itemkey || '',
        itemQuantity: item.itemValue || item.quantity || '',
        itemGroupName: item.groupName || '',
        itemWhereToFindIt: item.wheretofindit || item.link || '',
        imageUrl: item.url || item.imageUrl || '',
        itemGroupList: this.itemGroupList,
        readOnly: true // Make it read-only for viewing
      }
    });
  }

  // Edit tagged item
  editTaggedItem(item: any, itemIndex: number, event?: Event) {
    if (event) {
      event.stopPropagation(); // Prevent chip click event
    }

    const dialogRef = this.dialog.open(ItemDetailsDialogComponent, {
      width: '600px',
      maxWidth: '90vw',
      data: {
        itemName: item.itemName || item.itemkey || item.itemKey || '',
        itemQuantity: item.itemValue || item.quantity || '',
        itemGroupName: item.groupName || '',
        itemWhereToFindIt: item.wheretofindit || item.link || '',
        imageUrl: item.url || item.imageUrl || '',
        itemGroupList: this.itemGroupList,
        readOnly: false // Enable editing
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Update the item with edited values
        const updatedItem = {
          ...item,
          itemName: result.itemName || '',
          itemkey: result.itemName || '',
          itemKey: result.itemName || '',
          itemValue: result.itemQuantity || '',
          quantity: result.itemQuantity || '',
          groupName: result.itemGroupName || '',
          link: result.itemWhereToFindIt || '',
          wheretofindit: result.itemWhereToFindIt || ''
        };

        // Remove empty properties
        Object.keys(updatedItem).forEach(key => {
          if (updatedItem[key] === '' || updatedItem[key] === null || updatedItem[key] === undefined) {
            delete updatedItem[key];
          }
        });

        // Update in stepTaggedItems (for form section)
        if (this.stepTaggedItems && this.stepTaggedItems[itemIndex] !== undefined) {
          this.stepTaggedItems[itemIndex] = updatedItem;
        }

        // Update in allSteps if we're editing a step
        const stepToEdit = JSON.parse(localStorage.getItem("stepToEdit") || "{}");
        if (stepToEdit.stepToEdit && stepToEdit.stepToEdit.taggedItems) {
          const stepIndex = stepToEdit.index;
          if (this.allSteps && this.allSteps[stepIndex] && this.allSteps[stepIndex].taggedItems) {
            const taggedItems = this.allSteps[stepIndex].taggedItems;
            // Find the item index in the step's taggedItems
            const stepItemIndex = taggedItems.findIndex((tagged: any) => 
              (tagged.itemName || tagged.itemkey || tagged.itemKey) === (item.itemName || item.itemkey || item.itemKey)
            );
            if (stepItemIndex >= 0) {
              this.allSteps[stepIndex].taggedItems[stepItemIndex] = updatedItem;
            }
          }
        }

        this.cdr.detectChanges();
        this.toastr.success('Tagged item updated successfully');
      }
    });
  }

  // Edit tagged item from step preview
  editTaggedItemFromStep(item: any, stepIndex: number, itemIndex: number, event?: Event) {
    if (event) {
      event.stopPropagation(); // Prevent chip click event
    }

    const dialogRef = this.dialog.open(ItemDetailsDialogComponent, {
      width: '600px',
      maxWidth: '90vw',
      data: {
        itemName: item.itemName || item.itemkey || item.itemKey || '',
        itemQuantity: item.itemValue || item.quantity || '',
        itemGroupName: item.groupName || '',
        itemWhereToFindIt: item.wheretofindit || item.link || '',
        imageUrl: item.url || item.imageUrl || '',
        itemGroupList: this.itemGroupList,
        readOnly: false // Enable editing
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Update the item with edited values
        const updatedItem = {
          ...item,
          itemName: result.itemName || '',
          itemkey: result.itemName || '',
          itemKey: result.itemName || '',
          itemValue: result.itemQuantity || '',
          quantity: result.itemQuantity || '',
          groupName: result.itemGroupName || '',
          link: result.itemWhereToFindIt || '',
          wheretofindit: result.itemWhereToFindIt || ''
        };

        // Remove empty properties
        Object.keys(updatedItem).forEach(key => {
          if (updatedItem[key] === '' || updatedItem[key] === null || updatedItem[key] === undefined) {
            delete updatedItem[key];
          }
        });

        // Update in allSteps (for display)
        if (this.allSteps && this.allSteps[stepIndex] && this.allSteps[stepIndex].taggedItems) {
          if (this.allSteps[stepIndex].taggedItems[itemIndex] !== undefined) {
            this.allSteps[stepIndex].taggedItems[itemIndex] = updatedItem;
          }
        }

        // Update in _steps and localStorage (for persistence)
        const storedSteps = localStorage.getItem("stepsCoverPageDetails");
        if (storedSteps) {
          try {
            const steps = JSON.parse(storedSteps);
            if (steps && steps[stepIndex] && steps[stepIndex].taggedItems) {
              if (steps[stepIndex].taggedItems[itemIndex] !== undefined) {
                steps[stepIndex].taggedItems[itemIndex] = updatedItem;
                localStorage.setItem("stepsCoverPageDetails", JSON.stringify(steps));
                this._steps = steps; // Sync with component property
              }
            }
          } catch (e) {
            console.error('Error updating tagged item in localStorage:', e);
          }
        }

        this.cdr.detectChanges();
        this.toastr.success('Tagged item updated successfully');
      }
    });
  }

  selectItemFiles(event: any) {
    if (event.target.files) {
      this.itemUploadProgress = 0;
      this.fileData = <File>event.target.files[0];
      const formData = new FormData();
      formData.append("fileData", this.fileData);

      const imageExtensions = [
        "jpeg",
        "jpg",
        "png",
        "gif",
        "jfif",
        "tiff",
        "tif",
        "bmp",
        "webp",
        "svg",
        "heic",
        "heif",
        "raw",
        "arw",
        "cr2",
        "nef",
        "orf",
        "rw2",
        "dng",
        "psd",
        "ico",
        "exif",
        "pjpeg",
        "ppm",
        "pgm",
        "pbm",
        "pnm",
        "xpm",
        "tga",
        "pcx",
        "jp2",
        "jpx",
        "eps",
        "ai",
      ];

      const fileExtension = this.fileData.name.split(".").pop().toLowerCase();
      const isImage = imageExtensions.includes(fileExtension);

      if (!isImage) {
        this.toastr.warning("Please upload an image file");
        return;
      }

      this.openLoadingModal(`Uploading item image: ${this.fileData.name}...`, true);

      const uploadUrl = environment.apiBaseUrl + environment.uploadImageUrl;

      this.http
        .post(uploadUrl, formData, {
          reportProgress: true,
          observe: "events",
        })
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                if (event.total) {
                  this.itemUploadProgress = Math.round(
                    (event.loaded / event.total) * 100
                  );
                  this.updateLoadingModal(undefined, this.itemUploadProgress);
                }
                break;
              case HttpEventType.Response:
                const mediaUploadStatus = event.body;
                if (mediaUploadStatus) {
                  this.itemImageUrl =
                    environment.imageStorageBaseUrl +
                    mediaUploadStatus.fileName;
                  this.showItemImage = true;
                  this.showItemVideo = false;
                  this.itemUploadProgress = 100;
                  this.closeLoadingModal();
                  this.toastr.success("Image uploaded successfully");
                }
                break;
            }
          },
          (error) => {
            this.itemUploadProgress = 0;
            this.closeLoadingModal();
            this.toastr.error("Upload failed");
          }
        );
    }
  }

  removeItemPicture() {
    this.itemImageUrl = "";
    this.showItemImage = false;
  }

  addItem() {
    if (!this.itemName) {
      this.toastr.warning("Item name is required");
      return;
    }

    const newItem = {
      itemkey: this.itemName,
      itemValue: this.itemQuantity || "",
      url: this.itemImageUrl || "",
      wheretofindit: this.itemWhereToFindIt || "",
      groupName: this.itemGroupName || "",
    };

    // Items added from quick-create-flow or create-flow pages are not saved to library table
    // They are only added to the local flow items list

    if (!this.inames) {
      this.inames = [];
    }

    // Check if editing
    const editItemIndex = localStorage.getItem("EditItemsRequired");
    if (editItemIndex != null) {
      const index = parseInt(editItemIndex);
      if (index >= 0 && index < this.inames.length) {
        this.inames[index] = newItem;
        localStorage.removeItem("EditItemsRequired");
      }
    } else {
      this.inames.push(newItem);
    }

    localStorage.setItem("ItemsRequired", JSON.stringify(this.inames));
    // Ensure the toggle stays checked once at least one item exists
    if (this.hasItems) {
      this.isItemsRequired = true;
    }
    this.groupDataByGroupName();
    this.getAllItemGroupName();
    this.markAsChanged();

    // Reset form
    this.itemName = "";
    this.itemQuantity = "";
    this.itemImageUrl = "";
    this.itemWhereToFindIt = "";
    this.itemGroupName = "";
    this.showItemImage = false;
    this.itemUploadProgress = 0;
    this.selectedLibraryItem = null;

    this.toastr.success("Item added successfully");
    this.cdr.detectChanges();
  }

  // Steps methods
  stepTitleChanged() {
    if (!this.stepTitle) return;
    this.stepTitle = this.stepTitle.trim();
    if (this.stepTitle.length > this.maxtitlelenght) {
      this.stepTitle = this.stepTitle.substring(0, this.maxtitlelenght);
    }
  }

  async selectStepFiles(event: any) {
    if (event.target.files) {
      this.stepNoResultReturned = true;
      this.stepIsLoading = true;
      this.fileData = <File>event.target.files[0];

      const imageExtensions = [
        "jpeg",
        "jpg",
        "png",
        "gif",
        "jfif",
        "tiff",
        "tif",
        "pdf",
        "bmp",
        "webp",
        "svg",
        "heic",
        "heif",
        "raw",
        "arw",
        "cr2",
        "nef",
        "orf",
        "rw2",
        "dng",
        "psd",
        "ico",
        "exif",
        "pjpeg",
        "ppm",
        "pgm",
        "pbm",
        "pnm",
        "xpm",
        "tga",
        "pcx",
        "jp2",
        "jpx",
        "eps",
        "ai",
      ];
      const videoExtensions = [
        "mp4",
        "mov",
        "wmv",
        "flv",
        "avchd",
        "webm",
        "mkv",
        "vob",
        "ogv",
        "gifv",
        "m4p",
        "m4v",
        "3gp",
        "3g2",
        "amv",
        "nsv",
        "ogg",
        "f4v",
        "f4p",
        "f4a",
        "f4b",
        "avi",
        "mts",
        "m2ts",
        "ts",
        "mpg",
        "mpeg",
        "rm",
        "rmvb",
        "divx",
        "xvid",
        "asf",
        "mxf",
        "dv",
        "h264",
        "h265",
        "vp8",
        "vp9",
        "prores",
        "swf",
        "dat",
        "bik",
        "av1",
        "vro",
        "svi",
      ];

      const fileExtension = this.fileData.name.split(".").pop().toLowerCase();
      const isImageOrPdf = imageExtensions.includes(fileExtension);
      const isVideo = videoExtensions.includes(fileExtension);

      let fileToUpload = this.fileData;
      if (isVideo) {
        try {
          this.openLoadingModal("Optimizing video for upload...", true);
          fileToUpload = await this.mediaUploadService.prepareFileForUpload(
            this.fileData,
            (progress) => this.updateLoadingModal("Optimizing video for upload...", progress)
          );
          this.fileData = fileToUpload;
        } catch (error: any) {
          this.stepIsLoading = false;
          this.stepNoResultReturned = false;
          this.stepFileName = "";
          this.closeLoadingModal();
          this.toastr.warning(error?.message || this.mediaUploadService.uploadTooLargeMessage());
          return;
        }
      }

      const formData = new FormData();
      formData.append("fileData", fileToUpload);
      this.openLoadingModal("Uploading step media...", true);

      const uploadUrl = isImageOrPdf
        ? environment.apiBaseUrl + environment.uploadImageUrl
        : environment.apiBaseUrl + environment.uploadVideoUrl;

      this.http
        .post(uploadUrl, formData, {
          reportProgress: true,
          observe: "events",
        })
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                if (event.total) {
                  this.stepProgress = Math.round(
                    (event.loaded / event.total) * 100
                  );
                  this.updateLoadingModal(undefined, this.stepProgress);
                }
                break;
              case HttpEventType.Response:
                this.handleStepFileUpload(event.body, isImageOrPdf);
                break;
            }
          },
          (error) => {
            this.stepIsLoading = false;
            this.stepNoResultReturned = false;
            this.stepFileName = "";
            this.closeLoadingModal();
            this.toastr.warning(this.mediaUploadService.uploadTooLargeMessage());
          }
        );
    }
  }

  handleStepFileUpload(response: any, isImageOrPdf: boolean) {
    this.stepIsLoading = false;
    this.stepNoResultReturned = false;
    this.closeLoadingModal();
    const mediaUploadStatus = response;

    if (mediaUploadStatus) {
      if (isImageOrPdf) {
        this.showStepImage = true;
        this.showStepVideo = false;
        this.stepFileName = this.fileData.name;
        this.stepImageUrl =
          environment.imageStorageBaseUrl + mediaUploadStatus.fileName;
        this.isStepImageOrVideo(this.stepImageUrl);
        this.toastr.success("File uploaded successfully");
        this.stepProgress = 100;
      } else {
        // Video upload - show thumbnail selection dialog
        this.showStepVideo = true;
        this.showStepImage = false;
        this.stepFileName = this.fileData.name;
        this.stepImageUrl =
          environment.videoStorageBaseUrl + mediaUploadStatus.fileName;

        // Reset step thumbnail state for new video
        this.resetThumbnailState("step");
        this.customStepThumbnailUrl = "";
        this.customStepThumbnailFile = null;
        this.selectedStepAutoThumbnailUrl = "";
        this.selectedStepAutoThumbnailFile = null;
        this.stepVideoDuration = 0;
        this.currentStepVideoTime = 0;

        // Set poster if available
        if (mediaUploadStatus.posterImageName) {
          this.stepPosterUrl =
            environment.imageStorageBaseUrl + mediaUploadStatus.posterImageName;
        }

        // Show thumbnail selection dialog (existing dialog component)
        const generatedThumbnailUrl = mediaUploadStatus.posterImageName
          ? environment.imageStorageBaseUrl + mediaUploadStatus.posterImageName
          : "";

        this.openThumbnailSelectionDialog(
          generatedThumbnailUrl,
          this.stepImageUrl,
          "step"
        );
        this.isStepImageOrVideo(this.stepImageUrl);
        this.stepProgress = 100;
      }
    } else {
      this.toastr.error("Upload failed");
    }
  }

  private resetThumbnailState(source: "cover" | "step") {
    if (source === "cover") {
      this.coverThumbnails = [];
      this.coverThumbnailError = "";
      this.isCoverThumbnailLoading = false;
      this.customCoverThumbnailUploading = false;
      this.coverThumbnailUploadProgress = 0;
    } else {
      this.stepThumbnails = [];
      this.stepThumbnailError = "";
      this.isStepThumbnailLoading = false;
      this.customStepThumbnailUploading = false;
      this.stepThumbnailUploadProgress = 0;
    }
  }

  private resolveImageUrl(path: string): string {
    if (!path) {
      return "";
    }
    return path.startsWith("http")
      ? path
      : environment.imageStorageBaseUrl + path;
  }

  private normalizeThumbnailResponse(response: any): string[] {
    if (!response) {
      return [];
    }

    const thumbnailCandidates =
      response?.thumbnailUrls ??
      response?.thumbnailFileNames ??
      response?.thumbnails ??
      response?.data ??
      [];

    if (!Array.isArray(thumbnailCandidates)) {
      return [];
    }

    return thumbnailCandidates
      .filter((thumb) => !!thumb)
      .map((thumb: string) => this.resolveImageUrl(thumb));
  }

  private canGenerateThumbnails(): boolean {
    return (
      !!environment.enableAutoVideoThumbnails &&
      !!environment.generateThumbnailsUrl
    );
  }

  private fetchVideoThumbnails(fileName: string, source: "cover" | "step") {
    if (!fileName || !this.canGenerateThumbnails()) {
      return;
    }

    const url = environment.apiBaseUrl + environment.generateThumbnailsUrl;
    const payload = {
      fileName: fileName,
      count: 3,
    };

    if (source === "cover") {
      this.isCoverThumbnailLoading = true;
      this.coverThumbnailError = "";
      this.coverThumbnails = [];
    } else {
      this.isStepThumbnailLoading = true;
      this.stepThumbnailError = "";
      this.stepThumbnails = [];
    }

    this.http.post(url, payload).subscribe({
      next: (response: any) => {
        const thumbnails = this.normalizeThumbnailResponse(response);
        if (source === "cover") {
          this.coverThumbnails = thumbnails;
          this.isCoverThumbnailLoading = false;
          if (thumbnails.length && !this.coverPosterPageURI) {
            this.coverPosterPageURI = thumbnails[0];
          }
          if (!thumbnails.length) {
            this.coverThumbnailError =
              "We couldn't auto-generate thumbnails. Upload one manually.";
          }
        } else {
          this.stepThumbnails = thumbnails;
          this.isStepThumbnailLoading = false;
          if (thumbnails.length && !this.stepPosterUrl) {
            this.stepPosterUrl = thumbnails[0];
          }
          if (!thumbnails.length) {
            this.stepThumbnailError =
              "We couldn't auto-generate thumbnails. Upload one manually.";
          }
        }
      },
      error: () => {
        if (source === "cover") {
          this.isCoverThumbnailLoading = false;
          this.coverThumbnailError =
            "Unable to generate thumbnails. Please upload one manually.";
        } else {
          this.isStepThumbnailLoading = false;
          this.stepThumbnailError =
            "Unable to generate thumbnails. Please upload one manually.";
        }
      },
    });
  }

  onThumbnailSelected(source: "cover" | "step", thumbnailUrl: string) {
    if (!thumbnailUrl) {
      return;
    }

    if (source === "cover") {
      this.coverPosterPageURI = thumbnailUrl;
      this.markAsChanged();
    } else {
      this.stepPosterUrl = thumbnailUrl;
    }
    this.toastr.success("Thumbnail updated");
  }

  onCustomThumbnailSelected(event: Event, source: "cover" | "step") {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file) {
      return;
    }

    const formData = new FormData();
    formData.append("fileData", file);

    const setUploadingState = (isUploading: boolean) => {
      if (source === "cover") {
        this.customCoverThumbnailUploading = isUploading;
        if (!isUploading) {
          this.coverThumbnailUploadProgress = 0;
        }
      } else {
        this.customStepThumbnailUploading = isUploading;
        if (!isUploading) {
          this.stepThumbnailUploadProgress = 0;
        }
      }
    };

    setUploadingState(true);

    this.http
      .post(environment.apiBaseUrl + environment.uploadImageUrl, formData, {
        reportProgress: true,
        observe: "events",
      })
      .subscribe({
        next: (uploadEvent: HttpEvent<any>) => {
          switch (uploadEvent.type) {
            case HttpEventType.UploadProgress:
              if (uploadEvent.total) {
                const progress = Math.round(
                  (uploadEvent.loaded / uploadEvent.total) * 100
                );
                if (source === "cover") {
                  this.coverThumbnailUploadProgress = progress;
                } else {
                  this.stepThumbnailUploadProgress = progress;
                }
              }
              break;
            case HttpEventType.Response:
              const uploadedFileName = uploadEvent.body?.fileName;
              const thumbnailUrl = this.resolveImageUrl(uploadedFileName);
              this.onThumbnailSelected(source, thumbnailUrl);
              setUploadingState(false);
              this.toastr.success("Thumbnail uploaded successfully");
              break;
          }
        },
        error: () => {
          setUploadingState(false);
          this.toastr.error("Unable to upload thumbnail. Please try again.");
        },
      });

    if (input) {
      input.value = "";
    }
  }

  isStepImageOrVideo(url) {
    if (!url) {
      this.showStepImage = false;
      this.showStepVideo = false;
      return;
    }

    const imageExtensions = [
      "jpeg",
      "jpg",
      "png",
      "gif",
      "jfif",
      "tiff",
      "tif",
      "pdf",
      "bmp",
      "webp",
      "svg",
      "heic",
      "heif",
      "raw",
      "arw",
      "cr2",
      "nef",
      "orf",
      "rw2",
      "dng",
      "psd",
      "ico",
      "exif",
      "pjpeg",
      "ppm",
      "pgm",
      "pbm",
      "pnm",
      "xpm",
      "tga",
      "pcx",
      "jp2",
      "jpx",
      "eps",
      "ai",
    ];
    const videoExtensions = [
      "mp4",
      "mov",
      "wmv",
      "flv",
      "avchd",
      "webm",
      "mkv",
      "vob",
      "ogv",
      "gifv",
      "m4p",
      "m4v",
      "3gp",
      "3g2",
      "amv",
      "nsv",
      "ogg",
      "f4v",
      "f4p",
      "f4a",
      "f4b",
      "avi",
      "mts",
      "m2ts",
      "ts",
      "mpg",
      "mpeg",
      "rm",
      "rmvb",
      "divx",
      "xvid",
      "asf",
      "mxf",
      "dv",
      "h264",
      "h265",
      "vp8",
      "vp9",
      "prores",
      "swf",
      "dat",
      "bik",
      "av1",
      "vro",
      "svi",
    ];

    const fileExtension = url.split(".").pop().split("?")[0].toLowerCase();
    const isImage = imageExtensions.includes(fileExtension);
    const isVideo = videoExtensions.includes(fileExtension);

    this.showStepImage = isImage;
    this.showStepVideo = isVideo;
  }

  addStep() {
    if (!this.stepTitle) {
      this.toastr.warning("Step title is required");
      return;
    }

    if (!this.stepImageUrl) {
      this.toastr.warning("Step image or video is required");
      return;
    }

    // Validate safety critical step
    if (this.isSafetyCritical) {
      if (!this.safetyInstructionsTitle || this.safetyInstructionsTitle.trim().length === 0) {
        this.toastr.warning("Safety instructions title is required for safety critical steps.");
        return;
      }
      if (!this.safetyInstructionsDescription || this.safetyInstructionsDescription.trim().length === 0) {
        this.toastr.warning("Safety instructions description is required for safety critical steps.");
        return;
      }
    }

    const questionErrors = guideQuestionFormErrors(this.stepQuestionForm);
    if (questionErrors.length) {
      this.toastr.warning(questionErrors[0], "Step questions");
      return;
    }

    const stepData = {
      url: this.stepImageUrl,
      posterUrl: this.stepPosterUrl,
      description: this.stepDescription || "",
      stepFileName: this.stepFileName,
      title: this.stepTitle,
      taggedItems: this.stepTaggedItems || [], // Include tagged items
      isSafetyCritical: this.isSafetyCritical || false, // Include safety critical flag
      safetyInstructionsTitle: this.isSafetyCritical ? (this.safetyInstructionsTitle || "") : "", // Store safety instructions title
      safetyInstructionsDescription: this.isSafetyCritical ? (this.safetyInstructionsDescription || "") : "", // Store safety instructions description
      questionForm: cleanGuideQuestionForm(this.stepQuestionForm),
    };

    // Always sync with localStorage first to avoid duplicate steps
    const storedSteps = localStorage.getItem("stepsCoverPageDetails");
    if (storedSteps) {
      try {
        this._steps = JSON.parse(storedSteps);
      } catch (e) {
        this._steps = [];
      }
    } else {
      this._steps = [];
    }

    // Check if editing
    const stepToEdit = localStorage.getItem("stepToEdit");
    if (stepToEdit) {
      try {
        const editData = JSON.parse(stepToEdit);
        if (editData.index >= 0 && editData.index < this._steps.length) {
          this._steps[editData.index] = stepData;
          localStorage.removeItem("stepToEdit");
        } else {
          // If edit index is invalid, treat as new step
          this._steps.push(stepData);
        }
      } catch (e) {
        // If parsing fails, treat as new step
        this._steps.push(stepData);
      }
    } else {
      this._steps.push(stepData);
    }

    localStorage.setItem("stepsCoverPageDetails", JSON.stringify(this._steps));
    this.refreshStepsData();

    // Reset form
    this.stepTitle = "";
    this.stepDescription = "";
    this.stepImageUrl = "";
    this.stepPosterUrl = "";
    this.stepFileName = "";
    this.stepTaggedItems = [];
    this.stepItemSearch = "";
    this.showStepImage = false;
    this.showStepVideo = false;
    this.stepProgress = 0;
    this.isSafetyCritical = false;
    this.safetyInstructionsTitle = "";
    this.safetyInstructionsDescription = "";
    this.stepQuestionForm = null;

    this.toastr.success("Step added successfully");
    this.cdr.detectChanges();
  }

  rephraseStepDescriptionText() {
    const dialogRef = this.dialog.open(SelectionRephraseAIComponent, {
      width: "400px",
      data: { textToRephrase: this.stepDescription },
    });
    if (!this.isStepRephrased) {
      this.originalStepDescriptionText = this.stepDescription;
    }
    this.isStepRephraseInProgress = true;
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.stepDescription = result.rephrasedText;
        this.isStepRephrased = true;
      }
      this.isStepRephraseInProgress = false;
    });
  }

  goToOriginalStepText() {
    this.stepDescription = this.originalStepDescriptionText;
    this.isStepRephrased = false;
  }

  // FAQs methods
  onSelectFaqGroup(event: any) {
    this.faqGroupName = event.option.value;
  }

  getAllFaqGroupName() {
    if (!this._allFaqs || this._allFaqs.length === 0) {
      this.faqGroupList = [];
      return;
    }
    const groups = new Set<string>();
    this._allFaqs.forEach((faq) => {
      if (faq.groupName) {
        groups.add(faq.groupName);
      }
    });
    this.faqGroupList = Array.from(groups);
  }

  addFaqGroup() {
    if (!this.faqGroupName || !this.faqQuestion || !this.faqAnswer) {
      this.toastr.warning("Please fill in all fields");
      return;
    }

    const newFaq = {
      groupName: this.faqGroupName,
      question: this.faqQuestion,
      answer: this.faqAnswer,
      partitionKey: this.rowKey || this.partitionKey,
      userEmail: this.userData?.emailAddress,
    };

    if (!this._allFaqs) {
      this._allFaqs = [];
    }

    // Check if editing
    const editFaqIndex = localStorage.getItem("stepToFaq");
    if (editFaqIndex != null) {
      const index = parseInt(editFaqIndex);
      if (index >= 0 && index < this._allFaqs.length) {
        this._allFaqs[index] = {
          ...newFaq,
          rowKey: this._allFaqs[index].rowKey,
          flowRowKey: this._allFaqs[index].flowRowKey,
        };
        localStorage.removeItem("stepToFaq");
      }
    } else {
      this._allFaqs.push(newFaq);
    }

    localStorage.setItem("SupportFaqs", JSON.stringify(this._allFaqs));
    this.groupFaqDataByGroupName();
    this.getAllFaqGroupName();
    this.markAsChanged();

    // Reset form
    this.faqGroupName = "";
    this.faqQuestion = "";
    this.faqAnswer = "";

    this.toastr.success("FAQ added successfully");
    this.cdr.detectChanges();
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.checkMobileView();
  }

  checkMobileView() {
    this.isMobileView = window.innerWidth <= 768;
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    // Restore body scrolling when component is destroyed
    document.body.style.overflow = "";
  }
}
